import React, { useState, useEffect, useCallback } from 'react';
import StatutAo from './components/StatutAo';
import ErpiaSelect from './components/ErpiaSelect';
// LE VISAGE d'un candidat : le composant partagé (photo si le serveur en
// publie une, initiales sinon) — src/components/AvatarCandidat.jsx.
import AvatarCandidat from './components/AvatarCandidat';
import { useNavigate, useLocation } from 'react-router-dom';

import APIService from './services/api';
import Notification from './components/Notification';
import { ErpiaConfirmHost, confirmErpia } from './components/ConfirmDialog';
import JDGeneratorModal from './components/JDGenerator';
import JDDocument from './components/JDDocument';
import QuestionnairePage from './components/QuestionnairePage';
import CVValidationPage from './components/CVValidationPage';
import CVPrep from './components/CVPrep';
import { MatchingLancementModal, ScoreDetailModal } from './components/MatchingReglages';
import { SuiviQualifications, DemanderQualification } from './components/Qualification';
import SuiviDocuments from './components/SuiviDocuments';
import ListeNoire from './components/ListeNoire';
import JournalActivite from './components/JournalActivite';
import ProfilsProposes from './components/ProfilsProposes';
import { useEnvoiNda } from './components/EnvoiNda';
import { ComparaisonScoresModal } from './components/MatchingComparaison';
import { isAoAdmin } from './components/AoSociete';
import ScanVivier from './components/ScanVivier';
import { loadFeatures, useFeature, useFeatureApp, useFeatureOptIn, useModuleApp, moduleAllowed, installFeatureDisabledInterceptor } from './services/features';
import PiecesJointesManager from './components/PiecesJointes';
import { TestQuestionsManager, TestSession, TestReport, TestSessionsHistory } from './components/TestModule';
import { BatchCallButton, CallAgentModal } from './components/CallAgent';
import { ScheduleCallModal, ScheduledCallsList } from './components/ScheduleCallModal';
import ImportCandidats from './components/ImportCandidats';
import KanbanView from './components/KanbanView';
import VivierRH from './components/VivierRH';
import ConfigPage from './components/ConfigPage';
import { SkillsMatrixModal } from './components/SkillsMatrix';
import { TraitementsCvProvider, useTraitementsCv } from './components/TraitementsCv';
import PastilleSourcingAuto from './components/PastilleSourcingAuto';
import PublierOffreLinkedIn from './components/annonces/PublierOffreLinkedIn';
import CriteresEditeur, { CRITERES_DEPART, nettoyerCriteres, useRegistreCriteres } from './components/annonces/CriteresEditeur';
import BoutonAnnonce from './components/annonces/BoutonAnnonce';
import PublicAnnonce from './components/PublicAnnonce';
import PublicValiderCv from './components/PublicValiderCv';
import VueCandidats from './components/VueCandidats';
import AtsSidebar from './components/AtsSidebar';
import TatLease from './components/TatLease';
import { motifSessionExpiree, detailSessionExpiree } from './services/authInterceptor';
import ChampExtensible from './components/ChampExtensible';
import SessionQuiSeFerme from './components/SessionQuiSeFerme';
import BesoinsList from './components/BesoinsList';
import DossiersAO from './components/DossiersAO';
import AgentChat from './components/AgentChat';
import ErpiaBrand from './components/ErpiaBrand';
import CandidatPreviewDrawers from './components/CandidatPreviewDrawers';
import Marketplace from './components/Marketplace';
import Roadmap from './components/Roadmap';
import ClientsErpia from './components/ClientsErpia';
import Sonde from './components/Sonde';
import { useTeam, MentionArea, mentionedUsers, isInternal } from './components/Mentions';
import { useDiffusion, DiffusionHeaderButton, DiffusionModal, DiffusionContextCard, PropositionsTab } from './components/DiffusionSourceurs';
import { SourceurPage } from './components/SourcingLinkedIn';
import { BadgeNePasContacter } from './components/SourceurV2Suivi';
import { definirNePasContacter, confirmationLever } from './services/nePasContacter';
import Ressources from './components/Ressources';
import CRM from './components/CRM';
import MonEspace from './components/MonEspace';
import EntretienCandidat from './components/EntretienCandidat';
import Forms from './components/Forms';
import BesoinEntretiens from './components/BesoinEntretiens';
import Calendrier from './components/Calendrier';
import PublicJDPage from './components/PublicJD';
import PublicFormulaire from './components/PublicFormulaire';
import PublicEntretien from './components/PublicEntretien';
import BarreOnglets from './components/BarreOnglets';
import './ats-theme.css';
import { ancre } from './tutoriel/ancres';
import { TutorielProvider, useTutoriel } from './tutoriel/useTutoriel';
import TutorielBulle from './tutoriel/TutorielBulle';
import TutorielPanneau from './tutoriel/TutorielPanneau';
import { TutorielBanniere } from './tutoriel/TutorielLanceur';
import BienvenueTeaser, { dejaVu as teaserDejaVu } from './components/BienvenueTeaser';

const BASE = 'https://besoins-tat-production.up.railway.app';

/**
 * UN PROFIL ÉCARTÉ PASSE EN BAS. Le serveur range déjà la liste qu'il sert —
 * cette copie ne sert QU'À l'instant du clic, avant le prochain chargement :
 * sans elle, le profil qu'on vient d'écarter garde sa coupe de premier avec
 * son motif de refus à côté, et la liste dit deux choses contraires en même
 * temps (vécu 22.09).
 *
 * Tri STABLE : à statut égal, rien ne bouge. L'ordre voulu (la poignée de
 * classement) n'est jamais réécrit — lever la marque remet le profil
 * exactement où il était.
 */
const ecartesEnBas = (liste) => (Array.isArray(liste) ? liste : [])
  .map((c, i) => ({ c, i }))
  .sort((a, b) => ((a.c?.ne_pas_envoyer === true) - (b.c?.ne_pas_envoyer === true)) || (a.i - b.i))
  .map(x => x.c);

// Bootstrap Icons helper
const BI = ({ icon, className = '' }) => <i className={`bi bi-${icon} ${className}`} />;

// ─── Styles Swiss de l'écran détail besoin (scopés via préfixe bd-) ──────────
const BD_STYLES = `
.bd-wrap { font-family:'IBM Plex Sans',system-ui,sans-serif; display:flex; flex-direction:column; gap:16px; }
.bd-card { background:var(--surface); border:1px solid var(--border); border-radius:12px; }
/* Le bandeau du besoin passe à la ligne AVANT d'écraser le titre. Vécu :
   console ouverte (ou écran étroit), les actions — qui refusaient de céder un
   pixel — poussaient le titre jusqu'à sa largeur de MOT LE PLUS LONG :
   « QA / Specialist / IT – / Secteur / Horloger » sur cinq lignes. La règle
   tient à toutes les largeurs, pas seulement sous le point de rupture. */
.bd-header { display:flex; align-items:flex-start; justify-content:space-between; gap:16px; padding:18px 22px; flex-wrap:wrap; }
.bd-back { background:transparent; border:1px solid var(--input-border); width:36px; height:36px; border-radius:9px; display:flex; align-items:center; justify-content:center; color:var(--text-2); cursor:pointer; flex:none; }
.bd-back:hover { background:var(--ghost-bg-hover); color:var(--text); }
.bd-h1 { margin:0; font-family:'Archivo',sans-serif; font-size:26px; font-weight:800; letter-spacing:-0.025em; color:var(--text-strong); display:flex; align-items:center; gap:8px; cursor:pointer; line-height:1.2; overflow-wrap:anywhere; }
.bd-h1:hover .pen { color:var(--text-2); }
.bd-h1 .pen { font-size:13px; color:var(--text-faint); }
.bd-sub { margin:5px 0 0; font-size:13.5px; color:var(--text-2); cursor:pointer; }
.bd-sub:hover { color:var(--text); }
.bd-title-input { font-size:20px; font-weight:700; color:var(--text); background:var(--input-bg); border:1px solid var(--input-border); border-radius:8px; padding:4px 10px; outline:none; width:100%; font-family:inherit; box-sizing:border-box; }
.bd-title-input:focus { border-color:var(--text-strong); box-shadow:0 0 0 3px var(--accent-soft-bg); }
.bd-sub-input { font-size:13.5px; color:var(--text); background:var(--input-bg); border:1px solid var(--input-border); border-radius:7px; padding:3px 9px; outline:none; width:100%; margin-top:5px; font-family:inherit; box-sizing:border-box; }
.bd-sub-input:focus { border-color:var(--text-strong); box-shadow:0 0 0 3px var(--accent-soft-bg); }
.bd-dates { text-align:right; font-size:12px; color:var(--text-faint); font-family:'IBM Plex Mono',monospace; white-space:nowrap; line-height:1.5; }
.bd-btn { display:inline-flex; align-items:center; gap:7px; padding:8px 14px; border:1px solid var(--input-border); background:var(--ghost-bg); color:var(--text); border-radius:8px; font-size:13px; font-weight:500; font-family:inherit; cursor:pointer; white-space:nowrap; }
.bd-btn:hover { background:var(--ghost-bg-hover); }
.bd-btn-primary { display:inline-flex; align-items:center; gap:7px; padding:8px 16px; border:none; background:var(--accent); color:var(--accent-fg); border-radius:8px; font-size:13px; font-weight:600; font-family:inherit; cursor:pointer; white-space:nowrap; }
.bd-btn-primary:disabled { opacity:.5; cursor:not-allowed; }
.bd-btn-success { display:inline-flex; align-items:center; gap:7px; padding:10px 18px; border:none; background:#16a34a; color:#fff; border-radius:9px; font-size:13.5px; font-weight:600; font-family:inherit; cursor:pointer; }
.bd-btn-success:hover { background:#15803d; }
.bd-sect { background:var(--surface); border:1px solid var(--border); border-radius:12px; overflow:hidden; }
.bd-sect-head { display:flex; align-items:center; justify-content:space-between; gap:12px; padding:12px 18px; border-bottom:1px solid var(--hair); background:var(--ghost-bg); }
.bd-sect-title { display:flex; align-items:center; gap:9px; font-size:13.5px; font-weight:700; color:var(--text-strong); margin:0; }
.bd-sect-title i { color:var(--text-2); }
.bd-sect-hint { font-size:12px; color:var(--text-faint); }
.bd-chip { font-size:11px; font-weight:600; padding:2px 9px; border-radius:6px; background:var(--chip-bg); color:var(--chip-fg); }
.bd-chip-accent { font-size:11px; font-weight:600; padding:2px 9px; border-radius:6px; background:var(--accent-soft-bg); color:var(--accent-soft-fg); }
.bd-count { font-family:'IBM Plex Mono',monospace; font-size:11px; font-weight:600; padding:2px 8px; border-radius:6px; background:var(--chip-bg); color:var(--text-2); }
.bd-textarea { width:100%; border:none; background:transparent; color:var(--text); font-size:13.5px; font-family:inherit; padding:14px 18px; outline:none; resize:vertical; line-height:1.55; box-sizing:border-box; }
.bd-textarea::placeholder { color:var(--text-faint); }
.bd-link-mini { background:transparent; border:1px solid var(--input-border); color:var(--text-2); font-size:11.5px; font-weight:500; padding:4px 9px; border-radius:7px; cursor:pointer; display:inline-flex; align-items:center; gap:5px; font-family:inherit; }
.bd-link-mini:hover { background:var(--ghost-bg-hover); color:var(--text); }
.bd-saving { font-size:11px; color:var(--text-faint); }
.bd-saved { font-size:11px; color:#16a34a; display:inline-flex; align-items:center; gap:4px; }
.bd-drop { border:1.5px dashed var(--border); border-radius:10px; padding:34px 16px; text-align:center; transition:all .13s; }
.bd-drop:hover { border-color:var(--row-hover-bd); background:var(--ghost-bg); }
.bd-drop.is-drop { border-color:var(--text-strong); border-style:solid; background:var(--accent-soft-bg); }
.bd-drop-ico { font-size:38px; color:var(--text-faint); display:inline-block; margin-bottom:10px; }
.bd-label { display:flex; align-items:center; gap:6px; font-size:11px; font-weight:600; text-transform:uppercase; letter-spacing:.04em; color:var(--text-3); margin-bottom:5px; }
.bd-input { width:100%; border:1px solid var(--input-border); background:var(--input-bg); color:var(--text); border-radius:8px; padding:8px 11px; font-size:13px; font-family:inherit; outline:none; box-sizing:border-box; }
.bd-input:focus { border-color:var(--text-strong); box-shadow:0 0 0 3px var(--accent-soft-bg); }
.bd-input-mono { font-family:'IBM Plex Mono',monospace; }
.bd-cand { border:1px solid var(--border); border-radius:11px; background:var(--surface); transition:border-color .13s; }
.bd-cand.valide { border-color:rgba(22,163,74,0.4); }
.bd-cand-head { display:flex; align-items:center; justify-content:space-between; gap:12px; padding:13px 16px 9px; }
.bd-cand-idx { font-family:'IBM Plex Mono',monospace; font-size:12px; font-weight:600; color:var(--text-faint); flex:none;
  display:inline-flex; align-items:center; justify-content:flex-end; gap:4px; min-width:30px; }
/* LA COUPE — posée À LA MAIN (23.09), plus déduite du rang. Le NUMÉRO dit où
   le profil se trouve dans la liste ; la coupe dit ce qu'on en pense. Deux
   questions : elles ne se déduisent plus l'une de l'autre.
   La largeur de la colonne reste RÉSERVÉE pour tout le monde : sans ça, les
   lignes décorées se décalent de 14 px et la liste ondule.
   Pas d'or/argent/bronze : la charte est monochrome + UN rouge, et trois
   teintes de médaille la casseraient sur tous les autres écrans. La
   hiérarchie se fait donc en VALEUR — le rouge de la marque au premier
   choix, puis deux gris décroissants : l'œil trouve le meilleur avant de
   lire. */
.bd-cand-idx .bi-trophy-fill { color:var(--brand); font-size:12px; }
.bd-cand-idx .bi-trophy { font-size:11px; }
.bd-cand-idx[data-coupe="2"] .bi-trophy { color:var(--text-strong); }
.bd-cand-idx[data-coupe="3"] .bi-trophy { color:var(--text-2); }
/* Le rang EST le bouton : cliquer le numéro ouvre le choix des coupes. Rien
   n'est ajouté à une ligne déjà chargée — et la colonne du rang est
   exactement l'endroit où l'on cherche la distinction. */
.bd-coupe { position:relative; display:inline-flex; }
.bd-coupe > .bd-cand-idx { cursor:pointer; border-radius:6px; padding:2px 3px; border:1px dashed var(--hair); }
.bd-coupe > .bd-cand-idx:hover { border-style:solid; border-color:var(--text-3); background:var(--ghost-bg-hover); }
.bd-coupe > .bd-cand-idx:focus-visible { outline:2px solid var(--erp-accent); outline-offset:1px; }
/* L'EMPLACEMENT SE VOIT, MÊME VIDE (23.09 : « je ne vois pas le bouton pour
   mettre une coupe, comment on sait qu'il faut appuyer là ? »). Un bouton
   qu'on ne voit pas n'est pas un bouton : la coupe non posée laisse une
   silhouette pâle à sa place, et le contour pointillé dit « il y a quelque
   chose à remplir ici ». Rien ne bouge quand la vraie coupe arrive — la
   place était déjà tenue. */
.bd-coupe-vide { opacity:.3; }
.bd-coupe > .bd-cand-idx:hover .bd-coupe-vide,
.bd-coupe > .bd-cand-idx:focus-visible .bd-coupe-vide { opacity:1; color:var(--text-2); }
.bd-coupe-pop { position:absolute; left:0; top:calc(100% + 6px); width:210px; background:var(--surface);
  border:1px solid var(--border); border-radius:12px; box-shadow:0 12px 32px var(--hover-shadow); padding:6px; z-index:60; }

.bd-cand-body { padding:0 16px 16px; display:flex; flex-direction:column; gap:14px; }
.bd-grid2 { display:grid; grid-template-columns:1fr 1fr; gap:14px; }
.bd-mini { display:inline-flex; align-items:center; gap:6px; padding:7px 12px; border-radius:8px; font-size:12.5px; font-weight:600; font-family:inherit; cursor:pointer; border:1px solid var(--input-border); background:var(--surface, #fff); color:var(--text-2); white-space:nowrap; transition:background .15s ease, border-color .15s ease, color .15s ease; }
.bd-mini:hover { background:var(--ghost-bg-hover); border-color:var(--text-faint); color:var(--text-strong); }
@keyframes bd-indet { 0% { left:-35%; } 100% { left:100%; } }
.bd-mini-accent { border:none; background:var(--accent); color:var(--accent-fg); }
.bd-ok-chip { display:inline-flex; align-items:center; gap:5px; font-size:11.5px; font-weight:600; color:#16a34a; background:rgba(22,163,74,0.12); padding:3px 9px; border-radius:6px; }
.bd-icon-btn { background:transparent; border:none; width:30px; height:30px; border-radius:7px; display:flex; align-items:center; justify-content:center; color:var(--text-3); cursor:pointer; flex:none; }
.bd-icon-btn:hover { background:var(--ghost-bg-hover); color:var(--text); }
.bd-icon-btn.danger:hover { background:var(--danger-bg); color:var(--danger-fg); }
.bd-cv-row { display:flex; align-items:center; justify-content:space-between; gap:12px; background:var(--ghost-bg); border:1px solid var(--border); border-radius:9px; padding:10px 14px; }
.bd-cv-row.empty { border-style:dashed; }
.bd-cv-name { display:flex; align-items:center; gap:7px; font-size:13px; color:var(--text); min-width:0; }
.bd-cv-name i { color:var(--text-faint); flex:none; }
.bd-cv-link { background:none; border:none; padding:0; font-size:12.5px; font-weight:600; cursor:pointer; display:inline-flex; align-items:center; gap:5px; font-family:inherit; color:var(--text-2); }
.bd-cv-link:hover { color:var(--text-strong); }
.bd-cv-link.danger { color:var(--danger-fg); }
.bd-cv-link:disabled { opacity:.5; cursor:not-allowed; }
.bd-tag-kdrive { font-size:10px; color:#e11d48; background:rgba(225,29,72,0.1); padding:1px 6px; border-radius:5px; flex:none; }
.bd-mention-pop { position:absolute; left:0; bottom:100%; margin-bottom:6px; width:210px; background:var(--surface); border:1px solid var(--border); border-radius:10px; box-shadow:0 8px 28px var(--hover-shadow); overflow:hidden; z-index:50; }
.bd-mention-item { width:100%; text-align:left; padding:8px 11px; background:transparent; border:none; cursor:pointer; display:flex; align-items:center; gap:8px; font-size:13px; color:var(--text); font-family:inherit; }
.bd-mention-item:hover { background:var(--ghost-bg-hover); }
.bd-mention-av { width:24px; height:24px; border-radius:6px; background:var(--accent-soft-bg); color:var(--text-strong); display:flex; align-items:center; justify-content:center; font-size:11px; font-weight:600; font-family:'IBM Plex Mono',monospace; flex:none; }
.bd-cols { display:flex; gap:16px; align-items:flex-start; }
.bd-main { flex:1; min-width:0; display:flex; flex-direction:column; gap:16px; }
.bd-aside { width:280px; flex:none; position:sticky; top:16px; }
@media (max-width:1100px) { .bd-cols { flex-direction:column; } .bd-aside { width:100%; position:static; } }
.bd-float { display:flex; flex-direction:column; gap:12px; }
.bd-panel { background:var(--surface); border:1px solid var(--border); border-radius:12px; box-shadow:0 8px 28px var(--hover-shadow); overflow:hidden; }
.bd-panel-head { width:100%; padding:10px 14px; border:none; border-bottom:1px solid var(--hair); background:var(--ghost-bg); display:flex; align-items:center; justify-content:space-between; cursor:pointer; font-family:inherit; }
.bd-panel-head:hover { background:var(--ghost-bg-hover); }
.bd-panel-title { display:flex; align-items:center; gap:7px; font-size:13px; font-weight:700; color:var(--text-strong); }
.bd-panel-title i { color:var(--text-2); }
.bd-panel-count { font-family:'IBM Plex Mono',monospace; font-size:11px; font-weight:600; padding:1px 7px; border-radius:6px; background:var(--accent-soft-bg); color:var(--accent-soft-fg); }
.bd-panel-body { }
.bd-empty-mini { font-size:12px; color:var(--text-faint); text-align:center; padding:16px; }
.bd-mr-row { padding:11px 14px; border-bottom:1px solid var(--hair); }
.bd-mr-row:last-child { border-bottom:none; }
.bd-mr-head { display:flex; align-items:center; justify-content:space-between; gap:8px; margin-bottom:8px; }
.bd-mr-name { font-size:12.5px; font-weight:600; color:var(--text-strong); }
.bd-mr-check { display:flex; align-items:center; gap:8px; cursor:pointer; user-select:none; font-size:12px; color:var(--text-2); padding:2px 0; }
.bd-mr-check input { accent-color:var(--accent); width:14px; height:14px; cursor:pointer; flex:none; }
.bd-mr-check.done span { text-decoration:line-through; color:var(--text-faint); }
/* SANS OBJET — la case n'a pas lieu d'être sur ce dossier. Elle reste LISIBLE
   (la cacher ferait croire qu'elle n'existe pas) mais sort du compte, et le
   survol dit pourquoi. Barrée comme une case faite, elle raconterait un geste
   qui n'a pas eu lieu : on la met en retrait, pas en travers. */
.bd-mr-line { display:flex; align-items:center; gap:6px; }
.bd-mr-line .bd-mr-check { flex:1; min-width:0; }
.bd-mr-check--hs { color:var(--text-faint); cursor:default; font-style:italic; }
/* Constaté par l'ERP : la case est faite, elle ne se coche pas. */
.bd-mr-check--auto { cursor:default; color:var(--erp-success); }
.bd-mr-check--auto span { text-decoration:line-through; color:var(--text-faint); }
/* À RELIRE (24.09) — la pièce existe, personne ne l'a relue, ou elle a changé
   depuis la relecture. Ni vide (on la redéposerait), ni barrée (elle ne compte
   pas encore) : en attente, avec le geste qui la règle toujours visible. */
.bd-mr-check--fixe { cursor:default; }
.bd-mr-check--relire { cursor:default; color:var(--erp-warning); }
.bd-mr-check--relire small { font-size:10px; color:var(--text-3); margin-left:4px; }
.bd-mr-relire { flex:none; font-size:10px; font-family:'IBM Plex Mono',monospace; letter-spacing:.02em;
  color:var(--text-strong); background:none; border:1px solid var(--hair); padding:1px 6px; border-radius:6px;
  cursor:pointer; transition:background .12s ease; }
.bd-mr-relire:hover, .bd-mr-relire:focus-visible { background:var(--chip-bg); }
.bd-mr-relire:disabled { opacity:.5; cursor:default; }
@media (prefers-reduced-motion: reduce) { .bd-mr-relire { transition:none; } }
/* La ligne est un BOUTON : le détail se déplie au clic. Sans ça, 21 candidats
   × 7 cases faisaient une page sans fin (vécu 23.09). */
.bd-mr-head--btn { width:100%; background:none; border:none; padding:0; margin:0 0 8px; cursor:pointer;
  font:inherit; text-align:left; color:inherit; gap:8px; }
.bd-mr-head--btn:hover .bd-mr-name { color:var(--accent); }
.bd-mr-chev { font-size:10px; color:var(--text-faint); flex:none; }
.bd-mr-jauge { flex:1; min-width:26px; height:3px; border-radius:2px; background:var(--chip-bg); overflow:hidden; }
.bd-mr-jauge > span { display:block; height:100%; background:var(--text-3); transition:width .12s ease; }
.bd-mr-filtre { display:flex; gap:5px; padding:9px 14px 4px; }
.bd-mr-f { font-size:10.5px; font-family:'IBM Plex Mono',monospace; padding:3px 8px; border-radius:6px;
  border:1px solid var(--hair); background:none; color:var(--text-3); cursor:pointer; }
.bd-mr-f.on { border-color:var(--text-strong); color:var(--text-strong); font-weight:700; }
@media (prefers-reduced-motion: reduce) { .bd-mr-jauge > span { transition:none; } }
.bd-mr-so { flex:none; font-size:10px; font-family:'IBM Plex Mono',monospace; letter-spacing:.02em;
  color:var(--text-faint); background:none; border:none; padding:1px 3px; border-radius:4px;
  cursor:pointer; opacity:0; transition:opacity .12s ease, color .12s ease; }
.bd-mr-line:hover .bd-mr-so, .bd-mr-check--hs .bd-mr-so, .bd-mr-so:focus-visible { opacity:1; }
.bd-mr-so:hover, .bd-mr-so:focus-visible { color:var(--text-strong); background:var(--chip-bg); }
.bd-mr-motif { margin-top:9px; padding-top:9px; border-top:1px solid var(--hair); }
.bd-mr-motif-t { font-size:11.5px; color:var(--text-2); margin:0 0 6px; }
.bd-mr-motif-a { display:flex; justify-content:flex-end; gap:6px; margin-top:7px; }
.bd-mr-err { font-size:11px; color:var(--danger-fg,#e2231a); margin:7px 0 0; }
@media (prefers-reduced-motion: reduce) { .bd-mr-so { transition:none; } }
.bd-call-row { padding:10px 14px; border-bottom:1px solid var(--hair); }
.bd-call-row:last-child { border-bottom:none; }
.bd-call-name { font-size:12px; font-weight:600; color:var(--text-strong); }
.bd-call-meta { font-size:11px; color:var(--text-faint); font-family:'IBM Plex Mono',monospace; display:inline-flex; align-items:center; gap:4px; }
.bd-call-metas { display:flex; flex-wrap:wrap; align-items:center; gap:2px 12px; min-width:0; }
.bd-call-tel { color:var(--text-2); text-decoration:none; white-space:nowrap; }
.bd-call-tel:hover, .bd-call-tel:focus-visible { color:var(--text-strong); text-decoration:underline; text-underline-offset:2px; }
.bd-status { font-size:10px; font-weight:600; padding:1px 7px; border-radius:5px; display:inline-flex; align-items:center; gap:4px; flex:none; }
.bd-cancel-link { font-size:11px; color:var(--danger-fg); background:transparent; border:none; cursor:pointer; padding:1px 6px; border-radius:5px; font-family:inherit; }
.bd-cancel-link:hover { background:var(--danger-bg); }
.bd-spin { animation:bdSpin .7s linear infinite; border:2px solid var(--hair); border-bottom-color:var(--accent); border-radius:50%; width:36px; height:36px; }
@keyframes bdSpin { to { transform:rotate(360deg); } }
.bd-modal-jd { font-family:'IBM Plex Mono',monospace; line-height:1.6; }
.bd-prio { font-size:11px; font-weight:600; padding:2px 9px; border-radius:6px; white-space:nowrap; }
.bd-meta { margin:6px 0 0; font-size:13px; color:var(--text-2); display:flex; align-items:center; gap:8px; flex-wrap:wrap; }
.bd-pilot { display:flex; background:var(--surface); border:1px solid var(--border); border-radius:12px; overflow:hidden; }
.bd-pilot-cell { flex:1; padding:13px 16px; border-left:1px solid var(--hair); min-width:0; }
.bd-pilot-cell:first-child { border-left:none; }
.bd-pilot-l { font-size:10.5px; font-weight:600; text-transform:uppercase; letter-spacing:.05em; color:var(--text-3); }
.bd-pilot-v { margin-top:5px; font-size:15px; font-weight:600; color:var(--text-strong); white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.bd-pilot-v.mono { font-family:'IBM Plex Mono',monospace; }
.bd-progress { height:5px; border-radius:3px; background:var(--chip-bg); overflow:hidden; margin-top:8px; }
.bd-progress > span { display:block; height:100%; background:var(--accent); transition:width .2s; }
.bd-body { display:grid; grid-template-columns:300px 1fr; gap:16px; align-items:start; }
@media (max-width:1000px) { .bd-body { grid-template-columns:1fr; } .bd-rail { position:static !important; } }
.bd-rail { display:flex; flex-direction:column; gap:14px; position:sticky; top:8px; }
.bd-rail-card { background:var(--surface); border:1px solid var(--border); border-radius:12px; padding:14px 16px; }
.bd-rail-title { font-size:11px; font-weight:600; text-transform:uppercase; letter-spacing:.05em; color:var(--text-3); margin-bottom:11px; }
.bd-kv { display:flex; flex-direction:column; gap:9px; }
.bd-kv-row { display:flex; justify-content:space-between; gap:10px; font-size:12.5px; }
.bd-kv-row .k { color:var(--text-3); }
.bd-kv-row .v { color:var(--text); font-weight:500; text-align:right; }
.bd-kv-edit { background:none; border:0; padding:0; font:inherit; font-weight:500; color:var(--text); cursor:pointer; display:inline-flex; align-items:center; gap:6px; text-align:right; }
.bd-kv-edit .bi { font-size:11px; color:var(--text-3); }
.bd-kv-edit:hover, .bd-kv-edit:focus-visible { color:var(--brand); outline:none; }
.bd-kv-edit:hover .bi, .bd-kv-edit:focus-visible .bi { color:var(--brand); }
.bd-kv-edit--vide { color:var(--text-3); font-weight:400; font-style:italic; }
.bd-kv-row .v.bd-kv-vide { color:var(--text-3); font-weight:400; font-style:italic; }
.bd-kv-input { font:inherit; font-size:12.5px; padding:4px 8px; border:1px solid var(--border); border-radius:6px; background:var(--surface); color:var(--text-strong); max-width:190px; text-align:right; }
.bd-kv-input:focus { outline:2px solid var(--brand); outline-offset:1px; }
.bd-tabs { display:flex; gap:0; border-bottom:1px solid var(--border); margin-bottom:16px; overflow-x:auto; overflow-y:hidden; scrollbar-width:none; -ms-overflow-style:none; }
.bd-tabs::-webkit-scrollbar { display:none; height:0; }
.bd-tab { padding:10px 11px; background:transparent; border:none; border-bottom:2px solid transparent; margin-bottom:-1px; color:var(--text-2); font-size:13.5px; font-weight:600; font-family:inherit; cursor:pointer; display:inline-flex; align-items:center; gap:7px; white-space:nowrap; }
.bd-tab:hover { color:var(--text); }
.bd-tab.active { color:var(--text-strong); border-bottom-color:var(--text-strong); }
.bd-tab-count { font-family:'IBM Plex Mono',monospace; font-size:11px; font-weight:600; padding:0 6px; border-radius:5px; background:var(--chip-bg); color:var(--text-2); }
/* Ce qui manque à l'écran se dit en ambre : ce n'est pas une erreur (rien
   n'a échoué pour l'utilisateur), c'est une liste dont on ne peut pas
   garantir qu'elle est complète. */
.bd-avert { display:flex; align-items:center; gap:9px; padding:10px 13px; border-radius:9px;
  border:1px solid var(--erp-warning); background:var(--erp-warning-soft);
  color:var(--erp-warning); font-size:12.5px; }
.bd-work { display:flex; flex-direction:column; gap:14px; }
.bd-cand-row { display:flex; align-items:center; flex-wrap:wrap; justify-content:flex-end; gap:11px; row-gap:8px; padding:11px 14px; cursor:pointer; border-radius:11px; transition:box-shadow .12s ease, background .12s ease; }
/* LE NOM NE DISPARAÎT JAMAIS (02.10 : « regarde comment le nom est caché »).
   Les boutons de la ligne gardent leur largeur ; le nom, seul à pouvoir
   rétrécir, rétrécissait jusqu'à rien quand la place manquait. Il garde
   désormais de quoi se lire, et ce sont les boutons qui passent à la ligne. */
.bd-cand-ident { flex:1 1 180px; min-width:150px; }
.bd-cand-row:hover { background:var(--ghost-bg); }
/* BON À ENVOYER — le profil passe au vert (demande 22.09 : « je veux savoir
   d'un coup d'œil qu'il est prêt à être envoyé »). Le liseré de 3 px en inset
   est la signature de l'application (nav active) : on la reprend ici, en vert,
   plutôt que d'inventer un second langage pour dire « celui-là est prêt ».
   La teinte vient du token sémantique de succès — aucune couleur en dur. */
.bd-cand--pret > .bd-cand-row { box-shadow:inset 3px 0 0 var(--erp-success); background:var(--erp-success-soft); }
/* LE MOTEUR TRAVAILLE SUR CETTE LIGNE (23.09, revu le soir même).
   PAS DE COULEUR. Dans ce système une teinte dit l'état du DOSSIER : vert =
   prêt, rouge = danger ou refus, ambre = il manque quelque chose. « Le moteur
   calcule » n'est pas un état du dossier, c'est un état de l'ÉCRAN — il dure
   sept secondes et ne laisse aucune trace. Lui donner une teinte de plus sur
   une ligne qui porte déjà « Non intéressé » et « À qualifier par… », c'est
   une couleur qui ne veut plus rien dire. (Premier jet : le liseré en
   var(--accent) — quasi-noir dans le thème historique, mais ERP Shell remappe
   --accent sur le corail : la ligne qui calculait avait l'air en alarme.)
   Donc : le liseré de 3 px de la maison, en ENCRE, et un segment clair qui y
   DESCEND — le travail en cours est un mouvement, pas une couleur. Le fond
   passe à la surface sourde, neutre, juste assez pour retrouver la ligne dans
   une liste de douze. Rien d'autre ne bouge : le nom, le score et les boutons
   restent lisibles pendant le calcul.

   LA CARTE ENTIÈRE, pas la première ligne (23.09, retour : « ça serait
   possible d'entourer tout le truc du candidat et pas juste une ligne ? »).
   Le marqueur vivait sur la ligne d’en-tête : dépliée, la carte travaillait sur
   son en-tête et pas sur son corps — on ne savait plus si le bas de la fiche
   faisait partie du calcul. Il vit maintenant sur la carte : le rail court
   sur toute sa hauteur, sa bordure d'un pixel se fonce, et le fond sourd la
   couvre en entier. Aucun élément ajouté, aucune couleur de plus — la carte
   a déjà une bordure, on la met au travail. */
.bd-cand--scoring { position:relative; background:var(--erp-surface-muted);
  border-color:var(--erp-line-strong); box-shadow:inset 3px 0 0 var(--erp-line-strong); }
.bd-cand--scoring > .bd-cand-row { background:transparent; }
.bd-cand--scoring::after { content:''; position:absolute; left:0; top:0; bottom:0;
  width:3px; pointer-events:none; border-radius:11px 0 0 11px;
  background:linear-gradient(to bottom, transparent, var(--erp-ink), transparent);
  background-size:100% 45%; background-repeat:no-repeat;
  animation:bd-rail 1.5s ease-in-out infinite; }
@keyframes bd-rail { from { background-position:0 -60%; } to { background-position:0 160%; } }
/* Le chip qui dit ce que le moteur fait en ce moment. */
.bd-chip--vivant { max-width:220px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
.bd-tourne { animation:ats-spin .8s linear infinite; }
@media (prefers-reduced-motion: reduce) {
  /* Le rail s'arrête, il ne disparaît pas : la ligne dit encore qu'on
     travaille dessus — et le chip, lui, dit sur qui. */
  .bd-cand--scoring::after { animation:none; background:var(--erp-ink); }
  .bd-tourne { animation:none; }
}
.bd-cand--pret > .bd-cand-row:hover { background:var(--erp-success-soft); filter:brightness(.985); }
.bd-cand--pret .bd-cand-name { color:var(--erp-success); }
@media (prefers-reduced-motion: reduce) { .bd-cand-row { transition:none; } }
.bd-cand-av { width:34px; height:34px; border-radius:8px; flex:none; display:flex; align-items:center; justify-content:center; background:var(--accent-soft-bg); color:var(--text-strong); font-size:12px; font-weight:600; font-family:'IBM Plex Mono',monospace; }
.bd-cand-name { font-size:14px; font-weight:600; color:var(--text-strong); display:flex; align-items:center; gap:5px; min-width:0; }
.bd-cand-name-txt { white-space:nowrap; overflow:hidden; text-overflow:ellipsis; min-width:0; }
/* LE CRAYON DU NOM — la grammaire du panneau Détails (.bd-kv-edit) : discret
   au repos, la marque au survol. Il est toujours là : un geste qu'on ne voit
   qu'au survol, on ne le découvre pas. */
.bd-cand-crayon { flex:none; background:none; border:0; padding:2px 3px; border-radius:5px; cursor:pointer;
  color:var(--text-3); font-size:11px; line-height:1; display:inline-flex; align-items:center; }
.bd-cand-crayon:hover, .bd-cand-crayon:focus-visible { color:var(--brand); outline:none; }
.bd-cand-crayon:focus-visible { box-shadow:0 0 0 2px var(--erp-focus); }
.bd-cand-nomedit { display:flex; align-items:center; gap:6px; min-width:0; }
.bd-cand-nomedit-champ { text-align:left; font-size:13px; font-weight:600; max-width:none; width:auto; min-width:0; flex:1 1 110px; }
.bd-cand-nomedit-nom { flex:1.4 1 140px; }
.bd-cand-meta { font-size:12px; color:var(--text-2); white-space:nowrap; overflow:hidden; text-overflow:ellipsis; margin-top:1px; }
/* La raison d'un refus, sous le nom : pleine largeur, elle ne rogne rien. */
.bd-cand-motif { display:flex; align-items:center; gap:5px; margin-top:2px; font-size:11.5px;
  color:var(--danger-fg); white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
/* LA TRACE : qui a mis ce profil sur ce besoin, et par quel chemin. Sous la
   méta, en retrait — c'est ce qu'on va chercher, pas ce qu'on lit d'abord.
   Le mot AJOUTÉ est un label, pas du décor : il dit que la suite est une
   provenance, y compris quand aucune personne n'est nommée (« par le moteur
   de sourcing » EST la réponse). */
.bd-cand-trace { font-size:11px; color:var(--text-faint); white-space:nowrap; overflow:hidden; text-overflow:ellipsis; margin-top:2px; }
.bd-cand-trace b { font-family:'IBM Plex Mono',monospace; font-size:9.5px; font-weight:700; letter-spacing:0.09em; text-transform:uppercase; color:var(--text-3); margin-right:6px; }
.bd-mr-chip { font-family:'IBM Plex Mono',monospace; font-size:11px; font-weight:600; padding:2px 7px; border-radius:6px; background:var(--code-bg); color:var(--text-2); flex:none; }
.bd-mr-chip.ready { background:rgba(22,163,74,0.14); color:#16a34a; }
.bd-cand.open { border-color:var(--row-hover-bd); }
.bd-cand.open .bd-cand-body { border-top:1px solid var(--hair); padding-top:14px; }
.bd-cand-tools { display:flex; align-items:center; justify-content:flex-end; gap:7px; flex-wrap:wrap; margin-bottom:14px; }
.bd-acts { position:relative; flex:none; }
.bd-acts-pop { position:absolute; right:0; top:calc(100% + 6px); width:256px; background:var(--surface); border:1px solid var(--border); border-radius:12px; box-shadow:0 12px 32px var(--hover-shadow); padding:6px; z-index:60; }
.bd-acts-sec { font-family:'IBM Plex Mono',monospace; font-size:10px; font-weight:600; text-transform:uppercase; letter-spacing:.07em; color:var(--text-faint); padding:8px 10px 4px; }
.bd-acts-item { width:100%; display:flex; align-items:center; gap:10px; padding:8px 10px; border:none; background:transparent; border-radius:8px; font-size:13px; font-weight:500; color:var(--text); cursor:pointer; font-family:inherit; text-align:left; }
.bd-acts-item:hover { background:var(--ghost-bg-hover); }
.bd-acts-item:disabled { opacity:.45; cursor:not-allowed; }
.bd-acts-item i { color:var(--text-2); font-size:14px; width:16px; text-align:center; flex:none; }
.bd-acts-item.danger { color:var(--danger-fg); }
.bd-acts-item.danger i { color:var(--danger-fg); }
.bd-acts-item.danger:hover { background:var(--danger-bg); }
.bd-acts-div { height:1px; background:var(--hair); margin:6px 4px; }

/* ERP Shell — fiche besoin */
.bd-wrap { width:100%; max-width:1520px; margin:0 auto; gap:14px; }
.bd-header { position:relative; overflow:hidden; padding:24px 26px; border-radius:16px; box-shadow:0 8px 28px var(--hover-shadow); }
.bd-header::before { content:''; position:absolute; left:0; top:0; bottom:0; width:4px; background:var(--brand); }
.bd-eyebrow { margin:0 0 7px; font-family:'IBM Plex Mono',monospace; font-size:10.5px; font-weight:700; letter-spacing:.1em; text-transform:uppercase; color:var(--text-3); }
.bd-eyebrow span { color:var(--brand); }
.bd-h1 { font-size:30px; line-height:1.12; letter-spacing:-.035em; }
.bd-meta { margin-top:9px; }
.bd-back { width:40px; height:40px; border-radius:10px; background:var(--ghost-bg); }
.bd-pilot { display:grid; grid-template-columns:1.15fr repeat(4,1fr); border-radius:14px; box-shadow:0 3px 14px var(--hover-shadow); }
.bd-pilot-cell { padding:16px 18px; }
.bd-pilot-l { letter-spacing:.075em; }
.bd-pilot-v { font-size:16px; }
.bd-body { grid-template-columns:286px minmax(0,1fr); gap:18px; }
.bd-rail { gap:12px; top:18px; }
.bd-rail-card { border-radius:14px; padding:17px 18px; box-shadow:0 2px 10px var(--hover-shadow); }
.bd-rail-title { margin-bottom:13px; letter-spacing:.08em; }
.bd-kv-row { padding:9px 0; }
.bd-main-panel { min-width:0; overflow:hidden; background:var(--surface); border:1px solid var(--border); border-radius:16px; padding:0 18px 18px; box-shadow:0 4px 18px var(--hover-shadow); }
.bd-main-panel .bd-tabs { margin:0 -18px 18px; padding:0 18px; background:var(--panel); }
.bd-main-panel .bd-work { min-height:360px; }
.bd-sect { border-radius:13px; }
.bd-cand { border-radius:12px; }
/* Fiche besoin — hiérarchie et responsive ERP */
.bd-header { background:linear-gradient(135deg,var(--surface) 0%,var(--ghost-bg) 100%); }
/* margin-left:auto — les actions restent à droite AUSSI quand elles passent
   à la ligne (sans lui, elles reviendraient se coller à gauche). */
.bd-header-actions { display:flex; align-items:center; justify-content:flex-end; gap:8px; flex-wrap:wrap; margin-left:auto; }
.bd-header-actions > * { min-height:38px; }
.bd-header-actions .bd-btn-primary { box-shadow:0 5px 14px rgba(226,35,26,.16); }
.bd-header-actions .bd-btn-primary:hover { filter:brightness(1.05); transform:translateY(-1px); }
.bd-status-stepper { display:inline-flex; align-items:center; gap:5px; flex-wrap:wrap; }
.bd-status-step { display:inline-flex; align-items:center; gap:7px; padding:5px 12px; border-radius:99px; border:1px dashed var(--input-border); background:transparent; color:var(--text-3); font-size:12px; font-weight:500; cursor:pointer; font-family:inherit; transition:background .15s ease,border-color .15s ease,color .15s ease; }
.bd-status-step:hover { background:var(--ghost-bg-hover); color:var(--text); border-style:solid; }
.bd-status-step.active { color:var(--text-strong); font-weight:700; border-style:solid; }
.bd-status-step.bd-status-encours.active { background:rgba(56,132,255,.14); border-color:rgba(91,157,255,.42); }
.bd-status-step.bd-status-pret.active { background:rgba(234,160,30,.16); border-color:rgba(230,169,63,.45); }
.bd-status-step.bd-status-envoye.active { background:rgba(45,200,110,.15); border-color:rgba(86,217,140,.45); }
.bd-status-dot { width:6px; height:6px; border-radius:50%; flex:none; }
.bd-pilot-cell-primary { background:linear-gradient(135deg,var(--ghost-bg),transparent); }
.bd-pilot-cell-primary .bd-pilot-v { font-size:17px; }
.bd-pilot-cell-primary .bd-progress > span { background:var(--brand); }
.bd-tab.active { color:var(--text-strong); border-bottom-color:var(--brand); }
.bd-main-panel .bd-tabs { box-shadow:0 2px 8px var(--hover-shadow); }
.bd-cand { transition:border-color .15s ease,box-shadow .15s ease,transform .15s ease; }
.bd-cand:hover { border-color:var(--row-hover-bd); box-shadow:0 4px 12px var(--hover-shadow); }
.bd-cand.open { border-color:var(--brand); box-shadow:0 0 0 3px var(--accent-soft-bg); }
.bd-rail-card, .bd-panel { box-shadow:0 3px 14px var(--hover-shadow); }
@media (max-width:1180px) {
  .bd-header { flex-direction:column; }
  .bd-header > div:last-child { width:100%; flex-wrap:wrap; }
  .bd-pilot { grid-template-columns:repeat(3,1fr); }
  .bd-pilot-cell:nth-child(4) { border-left:none; border-top:1px solid var(--hair); }
  .bd-pilot-cell:nth-child(n+4) { border-top:1px solid var(--hair); }
}
@media (max-width:760px) {
  .bd-wrap { gap:10px; }
  .bd-header { padding:18px 16px 18px 18px; border-radius:12px; }
  .bd-h1 { font-size:23px; }
  .bd-header > div:last-child { display:grid !important; grid-template-columns:1fr 1fr; }
  .bd-header > div:last-child > * { justify-content:center; }
  .bd-pilot { grid-template-columns:1fr 1fr; border-radius:12px; }
  .bd-pilot-cell { border-top:1px solid var(--hair); padding:13px 14px; }
  .bd-pilot-cell:nth-child(-n+2) { border-top:none; }
  .bd-pilot-cell:nth-child(odd) { border-left:none; }
  .bd-body { grid-template-columns:1fr; gap:10px; }
  .bd-rail { position:static; }
  .bd-main-panel { border-radius:12px; padding:0 12px 12px; }
  .bd-main-panel .bd-tabs { margin:0 -12px 14px; padding:0 12px; }
}
`;
// Maps priorité / statut pour les pills (couleurs alignées sur BesoinsList)
// Date de démarrage et salaire max du besoin, tels que le serveur les sert
// (date ISO, entier CHF par an) — écrits comme on les lit en Suisse romande.
const jourIso = (v) => (v ? String(v).slice(0, 10) : '');
const dateCH = (v) => { const m = jourIso(v).match(/^(\d{4})-(\d{2})-(\d{2})$/); return m ? `${m[3]}.${m[2]}.${m[1]}` : null; };
const chf = (n) => (n == null || n === '' || !Number.isFinite(Number(n)) ? null : `${String(Math.round(Number(n))).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} CHF`);
const BD_PRIO = { high: { l: 'Haute', bg: 'rgba(226,35,26,0.14)', fg: '#f08a82' }, medium: { l: 'Moyenne', bg: 'rgba(234,160,30,0.16)', fg: '#e6a93f' }, low: { l: 'Basse', bg: 'rgba(45,200,110,0.15)', fg: '#56d98c' } };
const BD_STATUT = { encours: { l: 'En cours', bg: 'rgba(56,132,255,0.14)', fg: '#5b9dff' }, pret: { l: 'Prêt', bg: 'rgba(234,160,30,0.16)', fg: '#e6a93f' }, envoye: { l: 'Envoyé', bg: 'rgba(45,200,110,0.15)', fg: '#56d98c' } };
// LES CASES DE MARKET READY — un seul registre pour tout l'écran. Il y en
// avait trois (ce tableau, un tableau en dur dans l'en-tête du panneau, et
// MARKET_READY_ITEMS), et ils ne disaient pas la même chose : l'en-tête
// comptait cinq cases pendant que la ligne en comptait sept.
//
// `cle` est la colonne du couple, `item` le nom que le serveur donne à la
// case, `derogeable` dit si elle peut ne pas avoir lieu d'être ici.
// Les deux dernières (22.09) ne sont pas des pièces : ce qu'un client demande
// en premier sur un profil, ce n'est pas un fichier — c'est « vous l'avez
// vu ? » et « vous avez appelé ses références ? ». Elles se cochent toutes
// seules depuis le process de qualification.
//
// ⚠️ Ce tableau n'est plus qu'un REPLI (24.09) : le serveur SERT les cases du
// dossier avec la ligne (`market_ready.items` — nom, état, d'où ça vient,
// « à relire »), et ce sont celles de la qualification, avec les mêmes noms.
// On ne l'affiche que si la route n'a rien servi (ancien serveur).
const MARKET_READY_ITEMS = [
  { cle: 'mr_nda',        item: 'nda',           label: 'NDA signé' },
  { cle: 'mr_diplomes',   item: 'diplomes',      label: 'Diplômes' },
  { cle: 'mr_docs_admin', item: 'docs_admin',    label: 'Docs admin (CNI/Permis)' },
  { cle: 'mr_cv_tat',     item: 'cv_entreprise', label: 'CV format entreprise' },
  { cle: 'mr_test_tech',  item: 'test',          label: 'Test technique', derogeable: true },
  { cle: 'mr_itw_rh',     item: 'itw_rh',        label: 'Entretien RH', derogeable: true },
  { cle: 'mr_references', item: 'references',    label: 'Prises de référence', derogeable: true },
];

// Les cases déclarées SANS OBJET sur ce dossier, lues telles que le serveur
// les sert. Absentes ou abîmées → aucune dérogation : on exige la case plutôt
// que de la faire disparaître en silence.
const mrSansObjet = (candidat) => {
  const brut = candidat?.mr_sans_objet;
  if (!brut) return {};
  try { return typeof brut === 'string' ? JSON.parse(brut) : brut; } catch { return {}; }
};

// LE COMPTE — « 4/4, pas 5/6 ». Une case sans objet sort du dénominateur :
// la garder ferait chercher une pièce qui n'existe pas sur ce poste, et
// laisserait « Prêt à envoyer » verrouillé pour toujours (le serveur applique
// exactement la même règle, c'est lui qui décide).
// D'où vient une case cochée. Le serveur nomme la source ; l'écran la traduit
// une fois — un « genere » brut à l'écran est une donnée technique qui a fui.
const SOURCE_MR = {
  document: 'document du dossier', genere: 'document généré', fiche: 'pièce de la fiche',
  test: 'test technique passé', qualification: 'process de qualification',
};

const mrEtat = (candidat, checks = null) => {
  // LE COMPTE VIENT DU SERVEUR quand il l'a servi (23.09) : lui seul voit les
  // documents déposés, le test passé, et le compte rendu d'entretien qui coche
  // « Entretien RH » tout seul. Le recompte local ne connaît que les colonnes
  // `mr_*` — il disait 2/7 là où le dossier était à 3/7, et le recruteur
  // cherchait une case déjà faite.
  //
  // Le repli local reste : la route peut ne pas être déployée, et un panneau
  // sans compte vaut mieux qu'un panneau vide.
  const servi = candidat?.market_ready;
  if (servi && Number.isFinite(servi.total) && !checks) {
    return { done: servi.done, total: servi.total, ready: servi.ready === true,
      derogees: mrSansObjet(candidat), items: servi.items || null, servi: true };
  }
  const derogees = mrSansObjet(candidat);
  const lu = k => (checks ? checks[k] : candidat?.[k]) === true;
  const exigees = MARKET_READY_ITEMS.filter(i => !(i.derogeable && derogees[i.item]));
  const done = exigees.filter(i => lu(i.cle)).length;
  return { done, total: exigees.length, ready: done === exigees.length, derogees, items: null, servi: false };
};

// ===== LOGIN =====
// Lit le code client depuis l'URL (?customerCode=tat), en clair ou dans le hash.
const readCustomerCode = () => {
  try {
    const fromSearch = new URLSearchParams(window.location.search).get('customerCode');
    if (fromSearch) return fromSearch;
    const hash = window.location.hash || '';
    const qi = hash.indexOf('?');
    if (qi >= 0) return new URLSearchParams(hash.slice(qi + 1)).get('customerCode');
  } catch { /* noop */ }
  return '';
};

// ── Champ d'étoiles du login (SPEC_login_cosmique §1b) ──
// Une seule boucle rAF, montée avec l'écran login et coupée au démontage.
// 130 étoiles avec profondeur (parallaxe), scintillement, dérive bas-gauche,
// étoile filante occasionnelle. prefers-reduced-motion → rendu statique unique.
const LoginStarfield = () => {
  const ref = React.useRef(null);
  React.useEffect(() => {
    const cv = ref.current;
    if (!cv) return undefined;
    const reduced = typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
    let raf = null, stars = null, meteor = null, t = 0;
    const tick = () => {
      raf = requestAnimationFrame(tick);
      const w = cv.clientWidth, h = cv.clientHeight;
      if (!w || !h) return;
      if (cv.width !== w || cv.height !== h) { cv.width = w; cv.height = h; stars = null; }
      if (!stars) {
        stars = Array.from({ length: 130 }, () => ({
          x: Math.random() * w, y: Math.random() * h,
          z: 0.3 + Math.random() * 0.7,
          r: 0.5 + Math.random() * 1.6,
          tw: Math.random() * Math.PI * 2,
          vx: -(0.05 + Math.random() * 0.2), vy: 0.03 + Math.random() * 0.11,
        }));
        meteor = null; t = 0;
      }
      const ctx = cv.getContext('2d');
      t += 0.016;
      ctx.clearRect(0, 0, w, h);
      for (const s of stars) {
        if (!reduced) {
          s.x += s.vx * s.z * 2.2; s.y += s.vy * s.z * 2.2;
          if (s.x < -4) s.x = w + 4;
          if (s.y > h + 4) s.y = -4;
        }
        ctx.globalAlpha = reduced ? 0.55 * s.z : (0.22 + 0.68 * Math.abs(Math.sin(t * 1.5 + s.tw))) * s.z;
        ctx.fillStyle = '#fff';
        ctx.beginPath(); ctx.arc(s.x, s.y, s.r * s.z, 0, 6.283); ctx.fill();
      }
      if (!reduced) {
        if (!meteor && Math.random() < 0.005) {
          meteor = { x: w * (0.25 + Math.random() * 0.65), y: -20, vx: -(3 + Math.random() * 2.5), vy: 2.2 + Math.random() * 1.6, life: 1 };
        }
        if (meteor) {
          const m = meteor;
          m.x += m.vx * 3; m.y += m.vy * 3; m.life -= 0.016;
          ctx.globalAlpha = Math.max(m.life, 0) * 0.9;
          const g = ctx.createLinearGradient(m.x, m.y, m.x + m.vx * 14, m.y + m.vy * 14);
          g.addColorStop(0, 'rgba(255,255,255,0.95)'); g.addColorStop(1, 'rgba(255,255,255,0)');
          ctx.strokeStyle = g; ctx.lineWidth = 1.6;
          ctx.beginPath(); ctx.moveTo(m.x, m.y); ctx.lineTo(m.x + m.vx * 14, m.y + m.vy * 14); ctx.stroke();
          if (m.life <= 0 || m.x < -60 || m.y > h + 60) meteor = null;
        }
      }
      ctx.globalAlpha = 1;
      if (reduced && raf) { cancelAnimationFrame(raf); raf = null; } // rendu unique, boucle inerte
    };
    tick();
    return () => { if (raf) cancelAnimationFrame(raf); };
  }, []);
  return <canvas ref={ref} style={{ position: 'absolute', left: 0, top: 0, width: '100%', height: '100%' }} aria-hidden="true" />;
};

const LoginPage = ({ onLogin }) => {
  // Motif d'une déconnexion forcée (session expirée…) : affiché une fois,
  // au-dessus du formulaire — jamais en notification volante.
  const [infoSession] = useState(() => motifSessionExpiree());
  // Le détail de la fermeture — quel appel, quel code — à lire ICI plutôt que
  // dans le journal du serveur (vécu 27.09 : la personne éjectée nous
  // envoyait la mauvaise requête, faute de savoir laquelle regarder).
  const [detailSession] = useState(() => detailSessionExpiree());
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [customerCode, setCustomerCode] = useState(() => readCustomerCode());
  const [org, setOrg] = useState(null);          // { id, nom, slug } résolu
  const [orgError, setOrgError] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Résout l'organisation quand un code client est saisi/présent (debounce léger)
  useEffect(() => {
    const code = customerCode.trim();
    if (!code) { setOrg(null); setOrgError(''); return; }
    let cancelled = false;
    const t = setTimeout(async () => {
      try {
        const r = await APIService.getOrg(code);
        if (cancelled) return;
        if (r?.org) { setOrg(r.org); setOrgError(''); }
        else { setOrg(null); setOrgError('Code client inconnu'); }
      } catch (e) {
        if (!cancelled) { setOrg(null); setOrgError('Code client inconnu'); }
      }
    }, 350);
    return () => { cancelled = true; clearTimeout(t); };
  }, [customerCode]);

  const handleSubmit = async (e) => {
    e.preventDefault(); setError(''); setLoading(true);
    try {
      const result = await APIService.login(username, password, customerCode.trim() || undefined);
      if (result.success) { onLogin(result.user, result.organisation || org || null); }
      else { setError(result.message || 'Identifiants invalides'); }
    } catch (err) { setError(err.message || 'Erreur de connexion'); } finally { setLoading(false); }
  };

  const labelStyle = { display: 'block', fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--text-3)', marginBottom: '6px' };
  const inputStyle = { width: '100%', boxSizing: 'border-box', padding: '11px 13px', borderRadius: '9px', border: '1px solid var(--input-border)', background: 'var(--surface)', color: 'var(--text-strong)', fontFamily: 'inherit', fontSize: '13.5px', outline: 'none' };

  return (
    <div className="ats-scope" data-theme="dark" style={{ minHeight: '100vh', padding: 0, borderRadius: 0, display: 'flex', fontFamily: "'IBM Plex Sans', system-ui, sans-serif", background: 'var(--bg)' }}>
      {/* Panneau gauche : marque — fond « cosmique » animé (SPEC_login_cosmique).
          Texte blanc FIXE : le panneau reste sombre dans les deux thèmes. */}
      <div className="ats-login-brand" style={{ flex: '1 1 52%', minWidth: 0, background: '#06070d', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', padding: '44px 52px', position: 'relative', overflow: 'hidden' }}>
        {/* Nébuleuses (sous les étoiles) + champ d'étoiles canvas */}
        <div className="login-nebula-1" aria-hidden="true" />
        <div className="login-nebula-2" aria-hidden="true" />
        <div className="login-nebula-3" aria-hidden="true" />
        <LoginStarfield />

        <div style={{ position: 'relative' }}>
          <ErpiaBrand variant="hero" />         <div style={{ fontSize: '9.5px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.11em', color: 'var(--brand)', marginTop: '5px' }}>Du besoin à la facture</div>
        </div>

        <div style={{ position: 'relative' }}>
          <div style={{ fontFamily: "'Archivo',sans-serif", fontSize: 'clamp(44px,5.5vw,76px)', fontWeight: 900, letterSpacing: '-0.04em', lineHeight: 0.98, color: '#fff', textWrap: 'balance' }}>Le travail,<br />mieux orchestré<span style={{ display: 'inline-flex', width: '0.26em', height: '0.26em', marginLeft: '0.06em', verticalAlign: '0.02em' }} aria-hidden="true"><svg viewBox="0 0 32 32" style={{ width: '100%', height: '100%' }}><rect width="32" height="32" rx="4" fill="#E2231A" /><path d="M13.5 6.5H18.5V13.5H25.5V18.5H18.5V25.5H13.5V18.5H6.5V13.5H13.5Z" fill="#fff" /></svg></span></div>
          <div style={{ marginTop: '18px', fontSize: '14px', color: 'rgba(255,255,255,0.62)', maxWidth: '400px', lineHeight: 1.55 }}>Recrutement, missions, timesheets et facturation — réunis dans un seul espace de travail.</div>

          {/* Chips : AGENT IA en tête, puis les modules */}
          <div style={{ marginTop: '26px', display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '7px', fontFamily: "'IBM Plex Mono',monospace", fontSize: '11px', fontWeight: 600, letterSpacing: '0.05em', color: '#fff', border: '1px solid rgba(226,35,26,0.55)', background: 'rgba(226,35,26,0.16)', borderRadius: '99px', padding: '5px 12px', whiteSpace: 'nowrap' }}>
              <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="m12 2 2.1 5.9L20 10l-5.9 2.1L12 18l-2.1-5.9L4 10l5.9-2.1L12 2Z" /></svg>AGENT IA
            </span>
            {['ATS', 'CRM', 'GESTION AO', 'FACTURATION CLIENT'].map(t => (
              <span key={t} style={{ fontFamily: "'IBM Plex Mono',monospace", fontSize: '11px', fontWeight: 500, letterSpacing: '0.05em', color: 'rgba(255,255,255,0.75)', border: '1px solid rgba(255,255,255,0.35)', borderRadius: '99px', padding: '5px 12px', whiteSpace: 'nowrap' }}>{t}</span>
            ))}
          </div>

          {/* Carte ticker « Erpia Agent · en ce moment » (verre dépoli, point pulsant) */}
          <div style={{ marginTop: '24px', display: 'inline-flex', alignItems: 'center', gap: '13px', padding: '13px 17px', borderRadius: '12px', background: 'rgba(255,255,255,0.055)', border: '1px solid rgba(255,255,255,0.13)', backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)' }}>
            <span className="agent-pulse-dot" />
            <div>
              <div style={{ fontFamily: "'IBM Plex Mono',monospace", fontSize: '9.5px', fontWeight: 600, letterSpacing: '0.09em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.5)' }}>Erpia Agent · en ce moment</div>
              <div style={{ marginTop: '3px', height: '20px', overflow: 'hidden' }}>
                <div className="agent-ticker-col">
                  {['Trie 24 nouvelles candidatures…', 'Prépare 3 dossiers Market Ready…', 'Rédige la JD « Data Engineer » pour UBP…', 'Trie 24 nouvelles candidatures…'].map((msg, i) => (
                    <div key={i} style={{ height: '20px', fontSize: '13px', fontWeight: 500, color: '#fff' }}>{msg}</div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Pied : badges souveraineté + version */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap', fontFamily: "'IBM Plex Mono',monospace", fontSize: '11px', color: 'rgba(255,255,255,0.45)', position: 'relative' }}>
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: '7px', color: 'rgba(255,255,255,0.7)' }}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" /><path d="M12 8v6M9 11h6" /></svg>Hébergé en Suisse
          </span>
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: '7px', color: 'rgba(255,255,255,0.7)' }}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect x="5" y="11" width="14" height="9" rx="2" /><path d="M8 11V8a4 4 0 0 1 8 0v3" /></svg>IA souveraine — traitée en Suisse
          </span>
          <span className="login-dot-blink" />
          <span>erpia · Recrutement &amp; Services · v2</span>
        </div>
      </div>

      {/* Panneau droit : formulaire */}
      <div style={{ flex: '1 1 48%', minWidth: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px', background: 'var(--bg)' }}>
        <div style={{ width: 'min(360px, 100%)' }}>
          <div style={{ fontFamily: "'Archivo',sans-serif", fontSize: '26px', fontWeight: 800, letterSpacing: '-0.025em', color: 'var(--text-strong)' }}>Connexion<span style={{ color: 'var(--brand)' }}>.</span></div>
          <div style={{ marginTop: '6px', fontSize: '13px', color: 'var(--text-2)' }}>{org ? <>Espace <span style={{ fontWeight: 700, color: 'var(--text-strong)' }}>{org.nom}</span></> : 'Connectez-vous à votre espace de travail.'}</div>
          {error && <div style={{ marginTop: '16px', background: 'var(--danger-bg)', border: '1px solid var(--danger-bd)', color: 'var(--danger-fg)', padding: '9px 12px', borderRadius: '9px', fontSize: '12.5px', display: 'flex', alignItems: 'center', gap: '7px' }}><BI icon="exclamation-circle" /> {error}</div>}
          {infoSession && (
            <div style={{ marginTop: '18px', display: 'flex', gap: '9px', alignItems: 'flex-start', padding: '11px 13px', borderRadius: '10px', background: 'rgba(217,119,6,0.10)', border: '1px solid rgba(217,119,6,0.35)', color: '#b45309', fontSize: '12.5px', lineHeight: 1.5 }}>
              <BI icon="clock-history" style={{ marginTop: '1px', flex: 'none' }} />
              <span>
                {infoSession}
                {detailSession && (detailSession.appel || detailSession.code) && (
                  <span style={{ display: 'block', marginTop: '6px', fontFamily: "'IBM Plex Mono', monospace", fontSize: '10.5px', color: 'var(--text-faint)', wordBreak: 'break-all' }}>
                    Détail pour le support : {[detailSession.appel, detailSession.code ? `${detailSession.code}${detailSession.raison ? ` (${detailSession.raison})` : ''}` : null].filter(Boolean).join(' — ')}
                  </span>
                )}
              </span>
            </div>
          )}
          <form onSubmit={handleSubmit} style={{ marginTop: '26px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div>
              <label style={labelStyle}>Code client <span style={{ textTransform: 'none', fontWeight: 500, color: 'var(--text-faint)', letterSpacing: 0 }}>· optionnel</span></label>
              <input className="ats-login-input" type="text" name="organization" autoComplete="organization" value={customerCode} onChange={e => setCustomerCode(e.target.value)} placeholder="ex. tat" autoCapitalize="none" autoCorrect="off" spellCheck={false} style={inputStyle} />
              {org && <div style={{ marginTop: '6px', fontSize: '11.5px', color: '#16a34a', display: 'flex', alignItems: 'center', gap: '6px' }}><BI icon="check-circle-fill" /> {org.nom}</div>}
              {orgError && <div style={{ marginTop: '6px', fontSize: '11.5px', color: 'var(--danger-fg)', display: 'flex', alignItems: 'center', gap: '6px' }}><BI icon="exclamation-circle" /> {orgError}</div>}
            </div>
            <div>
              <label style={labelStyle}>Utilisateur</label>
              <input className="ats-login-input" type="text" name="username" autoComplete="username" value={username} onChange={e => setUsername(e.target.value)} placeholder="nom d'utilisateur" required autoFocus autoCapitalize="none" autoCorrect="off" spellCheck={false} style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Mot de passe</label>
              <input className="ats-login-input" type="password" name="password" autoComplete="current-password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required style={inputStyle} />
            </div>
            <button type="submit" disabled={loading} style={{ marginTop: '6px', width: '100%', padding: '12px', borderRadius: '9px', border: 'none', background: 'var(--brand)', color: '#fff', fontFamily: 'inherit', fontSize: '14px', fontWeight: 700, cursor: loading ? 'default' : 'pointer', opacity: loading ? 0.7 : 1 }}>{loading ? 'Connexion…' : 'Se connecter'}</button>
          </form>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', margin: '14px 0' }}>
            <span style={{ flex: 1, height: '1px', background: 'var(--hair)' }} />
            <span style={{ fontSize: '11px', color: 'var(--text-faint)' }}>ou</span>
            <span style={{ flex: 1, height: '1px', background: 'var(--hair)' }} />
          </div>
          <button type="button" onClick={() => setError('Connexion Microsoft 365 bientôt disponible.')} style={{ width: '100%', padding: '11px', borderRadius: '9px', border: '1px solid var(--input-border)', background: 'var(--ghost-bg)', color: 'var(--text)', fontFamily: 'inherit', fontSize: '13px', fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '9px' }}>
            <BI icon="microsoft" /> Continuer avec Microsoft 365
          </button>
          <div style={{ marginTop: '22px', fontSize: '11px', color: 'var(--text-faint)' }}>© 2026 · erpia</div>
        </div>
      </div>
    </div>
  );
};

// ===== CV HELPERS (kDrive proxy) =====
// Détecte si une URL CV pointe vers kDrive (importé depuis le Vivier RH)
// → ces URLs nécessitent une auth Basic côté serveur, donc on passe par /candidats/cv-proxy/:id
const isKDriveCV = (url) => !!url && /(?:connect\.drive\.infomaniak\.com|kdrive\.infomaniak\.com|\/dav\/files\/)/.test(url);

// Le CV se télécharge et s'ouvre depuis la rangée Documents, comme tout
// document : « CvDownloadSplit » (le bouton-texte à survol Word/PDF) et
// « CandidatCVModal » (qui devait retrouver le bon document à l'ouverture)
// n'ont plus d'appelant. Le choix Word/PDF existe toujours — il est porté par
// l'icône de téléchargement de la rangée, pour TOUS les documents
// bureautiques, pas seulement pour le CV.

// Menu « Actions » de la carte candidat : les actions secondaires (documents,
// entretien, suppression) regroupées derrière un seul bouton — la rangée ne
// s'empile plus quand des modules (NDA, matrice…) s'activent.
const CandActionsMenu = ({ sections }) => {
  const [open, setOpen] = useState(false);
  const ref = React.useRef(null);
  useEffect(() => {
    if (!open) return;
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, [open]);
  const secs = sections.map(s => ({ ...s, items: s.items.filter(Boolean) })).filter(s => s.items.length);
  if (!secs.length) return null;
  return (
    <div className="bd-acts" ref={ref}>
      <button className="bd-mini" onClick={() => setOpen(o => !o)} aria-expanded={open} aria-haspopup="menu">
        Actions <BI icon={open ? 'chevron-up' : 'chevron-down'} />
      </button>
      {open && (
        <div className="bd-acts-pop" role="menu">
          {secs.map((s, i) => (
            <React.Fragment key={s.title || `sec-${i}`}>
              {i > 0 && <div className="bd-acts-div" />}
              {s.title && <div className="bd-acts-sec">{s.title}</div>}
              {s.items.map(it => (
                <button key={it.label} role="menuitem" className={`bd-acts-item ${it.danger ? 'danger' : ''}`}
                  disabled={it.disabled} title={it.hint}
                  onClick={() => { setOpen(false); it.onClick(); }}>
                  <BI icon={it.icon} /> {it.label}
                </button>
              ))}
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
};

// ===== CANDIDAT CARD =====
/**
 * Disponibilité : une date, ou un délai en toutes lettres.
 *
 * Le mode s'ouvre sur ce que porte la fiche — une date si le serveur en a une
 * (ou si le texte en est une), le texte sinon. Choisir une date écrit
 * `date_disponibilite` (ISO, la donnée exploitable) ET `disponibilite` (la
 * phrase lisible), pour que rien de ce qui affiche déjà la disponibilité ne
 * régresse. Le serveur qui ignorerait encore `date_disponibilite` garde donc
 * une valeur juste.
 */
const DispoField = ({ candidat, onChange, saving }) => {
  const isoDe = (v) => {
    if (!v) return '';
    const s = String(v).trim();
    const iso = s.match(/^(\d{4}-\d{2}-\d{2})/);
    if (iso) return iso[1];
    // « 01/11/2026 » ou « à partir du 01.11.2026 » : la date se lit encore.
    const fr = s.match(/(\d{1,2})[/.](\d{1,2})[/.](\d{4})/);
    if (fr) return `${fr[3]}-${String(fr[2]).padStart(2, '0')}-${String(fr[1]).padStart(2, '0')}`;
    return '';
  };
  const dateServeur = isoDe(candidat.date_disponibilite);
  const dateTexte = isoDe(candidat.disponibilite);
  const texte = candidat.disponibilite || '';
  // La date est la forme cible : le calendrier s'ouvre d'emblée, même quand la
  // fiche porte encore un délai en toutes lettres — celui-ci reste affiché
  // dessous, et rien n'est écrasé tant qu'aucune date n'est choisie.
  const [modeDate, setModeDate] = React.useState(true);
  const valeur = dateServeur || dateTexte || '';

  const poserDate = (iso) => {
    if (!iso) { onChange('date_disponibilite', null); onChange('disponibilite', ''); return; }
    const [a, m, j] = iso.split('-');
    onChange('date_disponibilite', iso);
    onChange('disponibilite', `à partir du ${j}/${m}/${a}`);
  };

  return (
    <>
      {modeDate ? (
        <input type="date" value={valeur} onChange={e => poserDate(e.target.value)} className="bd-input" />
      ) : (
        <input type="text" value={texte}
          onChange={e => { if (dateServeur) onChange('date_disponibilite', null); onChange('disponibilite', e.target.value); }}
          className="bd-input" placeholder="Ex : immédiate, à négocier" />
      )}
      <button type="button" onClick={() => setModeDate(v => !v)}
        style={{ marginTop: '5px', padding: 0, border: 'none', background: 'none', color: 'var(--text-3)', fontFamily: 'inherit', fontSize: '11.5px', fontWeight: 600, textDecoration: 'underline', cursor: 'pointer' }}>
        {modeDate ? 'Indiquer un délai plutôt qu\'une date' : 'Choisir une date'}
      </button>
      {modeDate && texte.trim() && !dateServeur && !dateTexte && (
        <p style={{ margin: '4px 0 0', fontSize: '11.5px', color: 'var(--text-3)' }}>Indiqué jusqu'ici : {texte}</p>
      )}
      {(saving.disponibilite || saving.date_disponibilite) && <p className="bd-saving" style={{ marginTop: '4px' }}><BI icon="arrow-repeat" /> Sauvegarde…</p>}
    </>
  );
};

/* Le serveur ne rend plus les comptes supprimés : il ne reste qu'à écarter
   ceux qui sont désactivés. Plus de filtre sur le nom — deviner la
   suppression au suffixe « #supprime- » était une déduction, pas une lecture. */
const compteActif = (u) => u?.active !== false && !/inactif|disabled|suspendu/i.test(String(u?.status || ''));
/* Le responsable d'un besoin est un business manager. Le rôle se lit où le
   serveur le pose — le drapeau dédié, le rôle principal ou la liste cumulée. */
const estBusinessManager = (u) => u?.business_manager === true
  || String(u?.role || '') === 'business_manager'
  || (Array.isArray(u?.roles) && u.roles.includes('business_manager'));
/* Le nom qu'on montre est celui que le serveur a composé. */
const nomUtilisateur = (u) => u?.nom_affiche || [u?.prenom, u?.nom].filter(Boolean).join(' ') || u?.username || u?.email || 'Utilisateur';

const CandidatCard = ({ candidat, index, besoinId, matchInfo, enEvaluation = false, onEntretienEtat, onUpdate, onDelete, onUploadCV, onStartTest, onCallAgent, onMatrixBesoin, onOpenCandidat, onPrepareCv, showNotification, formatFileSize, sessionsRefreshKey, piecesRefreshAll, expanded, onToggle, flowStages = [], rang, total = 0, onRangDragStart, onRangDragEnd, onBonAEnvoyer, onNePasEnvoyer, distinctions = [], onCoupe }) => {
  const matriceOn = useFeature('matrice'); // feature flag org
  // LE CHOIX DE LA COUPE, ouvert depuis le numéro de la ligne. Il se referme
  // au clic dehors et à Échap : une liste de douze lignes avec un menu ouvert
  // qui suit le scroll est un menu qu'on ferme en rechargeant la page.
  const [coupeOuverte, setCoupeOuverte] = useState(false);
  const coupeRef = React.useRef(null);
  useEffect(() => {
    if (!coupeOuverte) return;
    const dehors = (e) => { if (coupeRef.current && !coupeRef.current.contains(e.target)) setCoupeOuverte(false); };
    const echap = (e) => { if (e.key === 'Escape') setCoupeOuverte(false); };
    document.addEventListener('mousedown', dehors);
    document.addEventListener('keydown', echap);
    return () => { document.removeEventListener('mousedown', dehors); document.removeEventListener('keydown', echap); };
  }, [coupeOuverte]);
  // NDA : module Marketplace « nda », dépendant du module « docsign » — le
  // bouton n'existe que si LES DEUX sont actifs. Il vit ici (candidat×besoin,
  // pas fiche candidat) car le NDA est lié à l'opportunité : le template
  // injecte le client du besoin.
  const ndaAppOn = useModuleApp('nda');
  const docsignAppOn = useModuleApp('docsign');
  // « Ne pas contacter » : la marque S'AFFICHAIT ici sans qu'on puisse la
  // lever — le seul bouton du produit vivait dans la fiche dépliée de la
  // liste Candidats (vécu 09.09 : « je peux plus l'enlever de cette liste »).
  // Or c'est ici qu'on propose d'appeler, de convoquer, d'inviter : c'est ici
  // qu'on découvre la marque, et donc ici qu'on veut la lever.
  // État LOCAL après succès : la liste du besoin ne se recharge pas à chaque
  // geste, et un badge qui reste rouge après un « Autorisé » fait recliquer.
  const [npcLeve, setNpcLeve] = useState(false);
  const [npcBusy, setNpcBusy] = useState(false);
  const npcCandidat = npcLeve ? { ...candidat, ne_pas_contacter: false } : candidat;
  const leverNePasContacter = async () => {
    const canonId = candidat.canonical_candidate_id ?? candidat.candidate_id ?? null;
    const nom = [candidat.prenom, candidat.nom].filter(Boolean).join(' ');
    if (!await confirmErpia(confirmationLever(nom, candidat.ne_pas_contacter_motif))) return;
    setNpcBusy(true);
    const out = await definirNePasContacter(canonId, false);
    setNpcBusy(false);
    if (!out.ok) return showNotification?.(out.error, 'error');
    setNpcLeve(true);
    showNotification?.(out.message, 'success');
  };
  // « NE PAS ENVOYER » — dire non, et dire pourquoi. La raison est
  // OBLIGATOIRE côté serveur : on la demande donc ici, dans la carte, plutôt
  // que d'envoyer un marquage qui se fera refuser. Le formulaire est fermé
  // par défaut : la question « pourquoi ? » ne s'affiche que quand on a
  // décidé de dire non.
  const [refusForm, setRefusForm] = useState(null); // null = fermé, '' = ouvert et vide
  const [refusBusy, setRefusBusy] = useState(false);
  const envoyerRefus = async () => {
    const motif = String(refusForm || '').trim();
    if (motif.length < 3) return;
    setRefusBusy(true);
    try { await onNePasEnvoyer?.({ actif: true, motif }); setRefusForm(null); }
    finally { setRefusBusy(false); }
  };
  // ENVOI DU NDA — le module partagé (components/EnvoiNda). Le même geste
  // existe dans le process de qualification : une seule implémentation, donc
  // un seul endroit où corriger le jour où l'envoi change.
  const nda = useEnvoiNda({
    candidateId: candidat.canonical_candidate_id ?? candidat.candidate_id ?? null,
    besoinId, emailConnu: candidat.email, showNotification,
  });
  const ouvrirNda = nda.ouvrir;
  const ndaBusy = nda.occupe;
  // « Pourquoi ce score ? » — détail critère par critère du score matching.
  const [scoreDetail, setScoreDetail] = useState(false);
  const { lancerCv } = useTraitementsCv();
  const [piecesRefreshKey, setPiecesRefreshKey] = React.useState(0);
  const refreshPieces = () => setPiecesRefreshKey(k => k + 1);
  // Modale ouverte depuis le menu « Actions » (les modales vivent ici, pas dans le
  // menu : le panneau se démonte à la fermeture, la modale doit lui survivre)
  const [modal, setModal] = useState(null); // 'call' | 'matrix' | 'cvproc'
  // @mentions dans le champ Commentaire : notification in-app au blur, et
  // uniquement pour les tagués AJOUTÉS pendant l'édition (le set est amorcé au
  // focus avec les mentions déjà présentes — pas de re-notification).
  const team = useTeam();
  const notifiedRef = React.useRef(null);
  const commentFocus = () => {
    if (notifiedRef.current === null) {
      notifiedRef.current = new Set(mentionedUsers(candidat.commentaire || '', team).map(u => u.id));
    }
  };
  const commentBlur = async () => {
    if (notifiedRef.current === null) return;
    const me = APIService.getCurrentUser();
    const fresh = mentionedUsers(candidat.commentaire || '', team)
      .filter(u => u.id !== me?.id && !notifiedRef.current.has(u.id));
    if (!fresh.length) return;
    fresh.forEach(u => notifiedRef.current.add(u.id));
    await Promise.all(fresh.map(u =>
      fetch(`${BASE}/notifications/inapp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${APIService.getToken()}` },
        body: JSON.stringify({
          user_id: u.id,
          message: `📌 ${me?.username || 'Un collègue'} vous a mentionné dans le commentaire de ${cardName || 'un candidat'} (besoin #${besoinId})`,
          type: 'mention',
          ref_type: 'besoin',
          ref_id: besoinId,
        }),
      }).catch(() => {})
    ));
    showNotification?.(`${fresh.length} personne(s) notifiée(s)`, 'success');
  };
  const [saving, setSaving] = useState({});
  const [deletingCV, setDeletingCV] = useState(false);
  const debounceRef = React.useRef({});

  const handleChange = (field, value) => {
    onUpdate(candidat.id, field, value);
    setSaving(s => ({ ...s, [field]: true }));
    clearTimeout(debounceRef.current[field]);
    debounceRef.current[field] = setTimeout(() => setSaving(s => ({ ...s, [field]: false })), 1200);
  };

  // LE PRÉNOM ET LE NOM (vécu 23.09 : « pourquoi je peux modifier qu'une
  // partie du nom ? », puis « je préfère un petit stylo ici »). Deux champs,
  // parce que ce sont deux colonnes : un champ unique qu'on redécouperait
  // devinerait mal « Jean-Pierre De La Croix ».
  // Ils vivent DERRIÈRE UN CRAYON, à côté du nom, et non plus en permanence
  // au milieu de la carte dépliée : c'est la grammaire du panneau Détails
  // (Localisation ✎, Commercial ✎) — on modifie une valeur là où on la LIT.
  // Un seul enregistrement quand on QUITTE l'édition (Entrée, ou clic
  // ailleurs) : vider le nom pour le retaper ne déclenche pas le refus du
  // serveur au milieu de la saisie. Échap annule les DEUX champs.
  const [nomEdit, setNomEdit] = useState(false);
  const [prenomSaisi, setPrenomSaisi] = useState('');
  const [nomSaisi, setNomSaisi] = useState('');
  const ouvrirNom = () => {
    setPrenomSaisi(candidat.prenom || '');
    setNomSaisi(candidat.nom || '');
    setNomEdit(true);
  };
  const enregistrerNom = () => {
    const propre = (x) => String(x || '').replace(/\s+/g, ' ').trim();
    const prenom = propre(prenomSaisi), nom = propre(nomSaisi);
    if (!nom) {
      showNotification('Le nom ne peut pas être vide — sans lui, la fiche ne se retrouve plus.', 'error');
      return;                                   // on reste en édition : la saisie n'est pas perdue
    }
    if (prenom !== propre(candidat.prenom)) handleChange('prenom', prenom);
    if (nom !== propre(candidat.nom)) handleChange('nom', nom);
    setNomEdit(false);
  };
  const clavierNom = (e) => {
    if (e.key === 'Enter') { e.preventDefault(); enregistrerNom(); }
    else if (e.key === 'Escape') { e.preventDefault(); setNomEdit(false); }
  };

  const handleDeleteCV = async () => {
    if (!await confirmErpia({ message: 'Supprimer le CV ?' })) return;
    setDeletingCV(true);
    try {
      // LE CV RETENU POUR CE BESOIN est une ligne de la fiche (cv_choisi_id,
      // servi par le serveur depuis le 29.10) : on supprime CE document — le
      // serveur retire aussi son jumeau du positionnement et la désignation.
      // Avant : un PUT cv_url: null, ignoré pour une fiche canonique, suivi
      // d'un « CV retiré » qui ne retirait rien.
      const ficheId = candidat.canonical_candidate_id ?? candidat.candidate_id ?? null;
      if (candidat.cv_choisi_id != null && ficheId != null) {
        const res = await fetch(`${BASE}/candidates/${ficheId}/documents/${candidat.cv_choisi_id}`,
          { method: 'DELETE', headers: { 'Authorization': `Bearer ${APIService.getToken()}` } });
        const data = await res.json().catch(() => ({}));
        if (!res.ok || data.success === false) throw new Error(data.error || `La suppression a été refusée (${res.status}).`);
        onUpdate(candidat.id, 'cv_url', null);
        onUpdate(candidat.id, 'cv_original_name', null);
        onUpdate(candidat.id, 'cv_size', null);
        showNotification('CV supprimé — il ne sert plus ni sur ce besoin, ni dans le dossier AO', 'success');
        return;
      }
      // Fiche canonique sans document identifié : le serveur ignorerait le
      // retrait — on le dit au lieu d'annoncer un succès.
      if (Number(candidat.id) < 0) {
        showNotification('Ce CV se supprime depuis la liste des documents du candidat.', 'info');
        return;
      }
      // Cas kDrive (importé du Vivier RH) : pas de cv_public_id Cloudinary
      // → on nettoie juste les champs CV en DB côté candidat
      if (isKDriveCV(candidat.cv_url) || !candidat.cv_public_id) {
        await fetch(`${BASE}/candidats/${candidat.id}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${APIService.getToken()}` },
          body: JSON.stringify({ cv_url: null, cv_original_name: null, cv_size: null, cv_public_id: null })
        });
        onUpdate(candidat.id, 'cv_url', null);
        onUpdate(candidat.id, 'cv_original_name', null);
        onUpdate(candidat.id, 'cv_size', null);
        showNotification('CV retiré du candidat', 'success');
      } else {
        // CV Cloudinary classique
        const res = await fetch(`${BASE}/upload/cv/${encodeURIComponent(candidat.cv_public_id)}`,
          { method: 'DELETE', headers: { 'Authorization': `Bearer ${APIService.getToken()}` } });
        const data = await res.json();
        if (data.success) {
          onUpdate(candidat.id, 'cv_url', null);
          onUpdate(candidat.id, 'cv_original_name', null);
          onUpdate(candidat.id, 'cv_size', null);
          showNotification('CV supprimé', 'success');
        }
      }
    } catch (e) { showNotification(e?.message || 'La suppression du CV a échoué.', 'error'); } finally { setDeletingCV(false); }
  };

  const mr = mrEtat(candidat);
  const mrDone = mr.done, mrTotal = mr.total, allReady = mr.ready;
  // Nom complet : les candidats positionnés depuis le vivier ont prénom/nom séparés
  // (la carte n'affichait que `nom` → « DAGHBOUJ » au lieu de « Hatem DAGHBOUJ »).
  const cardName = [candidat.prenom, candidat.nom].filter(Boolean).join(' ').trim();
  const initials = (cardName || '?').trim().split(/\s+/).map(w => w[0]).slice(0, 2).join('').toUpperCase() || '?';

  return (
    // `pret` : l'avis « bon à envoyer » est posé ET le profil n'est pas écarté.
    // Les deux sont exclusifs côté serveur, mais un état local d'un instant
    // (on vient de cliquer) pourrait porter les deux — et une ligne verte
    // marquée « ne pas envoyer » serait la pire chose à lire.
    <div className={`bd-cand ${candidat.valide ? 'valide' : ''} ${expanded ? 'open' : ''}`
      + `${candidat.bon_a_envoyer && !candidat.ne_pas_envoyer ? ' bd-cand--pret' : ''}`
      // Le moteur travaille SUR CETTE LIGNE : on le montre là où on regarde,
      // pas seulement dans un compteur en haut de page.
      + `${enEvaluation ? ' bd-cand--scoring' : ''}`}>
      <div className="bd-cand-row" onClick={onToggle}>
        {/* Le rang EST la poignée : 1 = le meilleur profil. On l'attrape pour
            déplacer la ligne ; le reste de la carte reste cliquable. */}
        {(() => {
          // LE RANG ET LA COUPE, DEUX CHOSES (23.09). Le NUMÉRO dit où le
          // profil se trouve dans la liste — c'est lui la poignée qu'on
          // attrape pour reclasser. La COUPE dit ce qu'on en pense, et elle
          // est POSÉE PAR QUELQU'UN : elle se déduisait du rang, donc du
          // score, et personne ne l'avait décidée.
          // Le libellé et l'icône viennent du serveur : rien n'est recomposé
          // ici depuis la clé.
          const r = rang ?? index + 1;
          const coupe = candidat.podium ? {
            cle: candidat.podium,
            libelle: candidat.podium_libelle || null,
            icone: candidat.podium_icone || 'trophy',
            rang: candidat.podium_rang || null,
          } : null;
          const badge = (
            <span className="bd-cand-idx" draggable={!!onRangDragStart} data-coupe={coupe?.rang ?? undefined}
              role={onCoupe ? 'button' : undefined} tabIndex={onCoupe ? 0 : undefined}
              aria-haspopup={onCoupe ? 'menu' : undefined} aria-expanded={onCoupe ? coupeOuverte : undefined}
              onDragStart={e => { e.stopPropagation(); onRangDragStart && onRangDragStart(); }}
              onDragEnd={e => { e.stopPropagation(); onRangDragEnd && onRangDragEnd(); }}
              onClick={onCoupe ? (e => { e.stopPropagation(); setCoupeOuverte(o => !o); }) : undefined}
              onKeyDown={onCoupe ? (e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); setCoupeOuverte(o => !o); } }) : undefined}
              title={[
                coupe ? coupe.libelle : null,
                onCoupe ? (coupe ? 'Cliquer pour changer ou retirer la coupe'
                                 : 'Cliquer pour donner une coupe : premier, deuxième ou troisième choix') : null,
                onRangDragStart ? 'Glisser pour classer' : null,
              ].filter(Boolean).join(' · ') || undefined}
              style={onRangDragStart && !onCoupe ? { cursor: 'grab' } : undefined}>
              {coupe
                ? <BI icon={coupe.icone} />
                /* La place est tenue même vide : sans elle, rien ne dit qu'on
                   peut cliquer, et la ligne sauterait de 14 px à la pose. */
                : (onCoupe ? <BI icon="trophy" className="bd-coupe-vide" /> : null)}
              {r}
            </span>
          );
          if (!onCoupe) return badge;
          return (
            <span className="bd-coupe" ref={coupeRef}>
              {badge}
              {coupeOuverte && (
                <div className="bd-coupe-pop" role="menu" onClick={e => e.stopPropagation()}>
                  <div className="bd-acts-sec">Coupe</div>
                  {(distinctions || []).map(d => (
                    <button key={d.cle} role="menuitem" className="bd-acts-item" title={d.aide || undefined}
                      onClick={() => { setCoupeOuverte(false); onCoupe(candidat.podium === d.cle ? null : d.cle); }}>
                      <BI icon={d.icone} /> {d.libelle}
                      {candidat.podium === d.cle && <BI icon="check2" style={{ marginLeft: 'auto' }} />}
                    </button>
                  ))}
                  {/* Le retrait n'apparaît que s'il y a quelque chose à retirer :
                      un bouton qui ne fait rien apprend à ne plus lire le menu. */}
                  {candidat.podium && (
                    <button role="menuitem" className="bd-acts-item"
                      onClick={() => { setCoupeOuverte(false); onCoupe(null); }}>
                      <BI icon="x-lg" /> Retirer la coupe
                    </button>
                  )}
                </div>
              )}
            </span>
          );
        })()}
        {/* LE VISAGE (24.09) : la case portait déjà les initiales, mais jamais
            la photo — la liste du besoin, là où on passe la journée, ne la
            demandait pas au serveur. Elle l'a maintenant ; sans photo, les
            initiales comme avant. */}
        <AvatarCandidat cand={candidat} url={candidat.photo_preview_url || null} texte={initials} className="bd-cand-av"
          av={{ bg: 'var(--accent-soft-bg)', color: 'var(--text-strong)' }}
          size="34px" radius="8px" fontSize="12px" />
        <div className="bd-cand-ident">
          {nomEdit ? (
            // L'édition prend la place du nom — on modifie là où on lit. Le
            // clic ne replie pas la carte, et quitter le GROUPE (pas passer
            // d'un champ à l'autre) enregistre.
            <div className="bd-cand-nomedit" onClick={e => e.stopPropagation()}
              onBlur={e => { if (!e.currentTarget.contains(e.relatedTarget)) enregistrerNom(); }}>
              <input autoFocus className="bd-kv-input bd-cand-nomedit-champ" value={prenomSaisi} placeholder="Prénom"
                aria-label="Prénom du candidat" maxLength={200}
                onChange={e => setPrenomSaisi(e.target.value)} onKeyDown={clavierNom} />
              <input className="bd-kv-input bd-cand-nomedit-champ bd-cand-nomedit-nom" value={nomSaisi} placeholder="Nom"
                aria-label="Nom du candidat" maxLength={200}
                onChange={e => setNomSaisi(e.target.value)} onKeyDown={clavierNom} />
            </div>
          ) : (
            <div className="bd-cand-name">
              <span className="bd-cand-name-txt"
                style={candidat.flow_etape === 'non_interesse' ? { textDecoration: 'line-through', color: 'var(--text-3)' } : undefined}>
                {cardName || <span style={{ color: 'var(--text-faint)', fontStyle: 'italic', fontWeight: 400 }}>Sans nom</span>}
              </span>
              <button type="button" className="bd-cand-crayon" title="Modifier le prénom et le nom"
                aria-label="Modifier le prénom et le nom" onClick={e => { e.stopPropagation(); ouvrirNom(); }}>
                <BI icon="pencil" />
              </button>
            </div>
          )}
          <div className="bd-cand-meta">{[candidat.experience ? `${candidat.experience} ans` : null, candidat.localisation, candidat.disponibilite].filter(Boolean).join(' · ') || '—'}</div>
          {/* « NON INTÉRESSÉ », sous le nom (vécu 02.10 : « regarde comment le
              nom est caché à cause de non intéressé »). Posée à côté du nom,
              la pastille lui prenait sa largeur : « Jim… » au lieu du nom.
              Même règle que le motif du refus juste dessous — le nom barré
              dit déjà l'état, la ligne le dit en toutes lettres. */}
          {candidat.flow_etape === 'non_interesse' && (
            <div className="bd-cand-motif"><BI icon="hand-thumbs-down" /> Non intéressé</div>
          )}
          {/* LA RAISON DU REFUS, sous le nom. Un « écarté » sans motif fait
              reposer la question au premier qui relit le dossier : il reste
              affiché — mais là où il ne mange le nom de personne. */}
          {candidat.ne_pas_envoyer && candidat.ne_pas_envoyer_motif && (
            <div className="bd-cand-motif" title={candidat.ne_pas_envoyer_motif}>
              <BI icon="send-slash" /> {candidat.ne_pas_envoyer_motif}
            </div>
          )}
          {/* LE MOTIF DU « NE PAS CONTACTER », sous le nom — même règle que
              le refus ci-dessus (vécu 26.09) : dans la barre d'actions, un
              motif long effaçait le nom et poussait les boutons hors de
              l'écran. Ici il se tronque proprement ; l'infobulle le donne
              entier. */}
          {npcCandidat.ne_pas_contacter === true && npcCandidat.ne_pas_contacter_motif && (
            <div className="bd-cand-motif" title={`Ne pas contacter — ${npcCandidat.ne_pas_contacter_motif}`}>
              <BI icon="slash-circle" /> <span style={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}>{npcCandidat.ne_pas_contacter_motif}</span>
            </div>
          )}
          {/* QUI A MIS CE PROFIL LÀ. La phrase vient du serveur entière — le
              front ne recompose rien à partir d'une clé. Absente sur les
              positionnements d'avant la trace : la ligne disparaît plutôt que
              d'afficher « inconnu ». La fiche, elle, a son propre créateur —
              en infobulle, parce que c'est une deuxième question. */}
          {candidat.positionne_lisible && (
            <div className="bd-cand-trace"
              title={candidat.created_by_name ? `Fiche créée par ${candidat.created_by_name}` : undefined}>
              <b>Ajouté</b>{candidat.positionne_lisible}
            </div>
          )}
        </div>
        {/* « Ne pas contacter » : la marque vit sur la FICHE, mais c'est ICI
            qu'on propose d'appeler, de convoquer, d'inviter. Le serveur
            refuse déjà ces gestes — sans ce badge, on ne l'apprenait qu'en
            se faisant refuser l'action. Même badge que le sourcing : une
            seule forme pour un seul fait. */}
        <BadgeNePasContacter candidat={npcCandidat} style={{ flex: 'none' }} compact
          onLever={leverNePasContacter} leverEnCours={npcBusy} />
        {/* Score matching s9 (identique Dossier AO pour la même paire candidat×besoin).
            Cliquer ouvre « Pourquoi ce score ? » : le détail critère par critère. */}
        {matchInfo && (matchInfo.score != null ? (() => {
          const v = Math.round(Number(matchInfo.score));
          const fg = v >= 75 ? '#16a34a' : v >= 50 ? '#d97706' : 'var(--brand)';
          const bg = v >= 75 ? 'rgba(22,163,74,0.12)' : v >= 50 ? 'rgba(217,119,6,0.12)' : 'rgba(226,35,26,0.10)';
          // Réserve de niveau (contrat s9) : niveau_fit < 1 signale un écart de
          // séniorité À QUALIFIER en entretien — jamais un rejet. Champs absents
          // = ancienne évaluation : rien de plus n'apparaît.
          const reserve = matchInfo.niveauFit != null && Number(matchInfo.niveauFit) < 1 && matchInfo.niveauEcart;
          return <>
            <span {...(index === 0 ? ancre('score-chip') : {})} className="bd-mr-chip" title={`Adéquation au poste : ${v}/100${matchInfo.niveau ? ' · ' + matchInfo.niveau : ''}${matchInfo.perso ? ' · poids ajustés pour ce lancement' : ''} — cliquer : pourquoi ce score ?`}
              onClick={e => { e.stopPropagation(); setScoreDetail(true); }}
              style={{ background: bg, color: fg, cursor: 'pointer' }}><BI icon="intersect" /> {v}{matchInfo.perso ? <BI icon="sliders" style={{ fontSize: '10px' }} /> : null}</span>
            {reserve && (
              <span className="bd-mr-chip"
                title={matchInfo.niveauEcartDetail || "Réserve de niveau — à qualifier en entretien, ce n'est pas un rejet"}
                style={{ background: 'var(--erp-warning-soft)', color: 'var(--erp-warning)' }}>
                <BI icon="question-circle" /> {matchInfo.niveauEcart}
              </span>
            )}
            <StatutAo statut={matchInfo.statutAo} libelle={matchInfo.statutAoLibelle} enLEtat={matchInfo.enLEtat} potentiel={matchInfo.potentiel} aConfirmer={matchInfo.aConfirmer}
              confirmations={matchInfo.confirmations} besoinId={besoinId} candidateId={candidat.canonical_candidate_id ?? candidat.candidate_id ?? null} showNotification={showNotification} />
          </>;
        })() : (
          // « NE » ne veut rien dire (demande 23.09 : « c'est quoi ce truc ? »).
          // Ce n'est pas un mauvais score : c'est un CV que le moteur n'a pas
          // pu LIRE. Le dire, plutôt qu'une abréviation que personne ne décode
          // sans survoler — et le dire en nommant ce qui s'est passé.
          <span className="bd-mr-chip" style={{ background: 'var(--erp-warning-soft)', color: 'var(--erp-warning)' }}
            title={matchInfo.motif || "Le texte de ce CV n'a pas pu être lu — le profil n'est pas mauvais, il n'a pas pu être évalué."}>
            <BI icon="file-earmark-x" /> CV illisible
          </span>
        ))}
        {scoreDetail && besoinId != null && (
          <ScoreDetailModal candidateId={candidat.candidate_id ?? candidat.id} besoinId={besoinId}
            nom={candidat.nom} onClose={() => setScoreDetail(false)} />
        )}
        {/* AVIS DU COMMERCIAL sur le PROFIL — à ne pas confondre avec
            « Prêt à envoyer » juste à côté, qui dit que le DOSSIER est complet.
            Celui-ci n'est verrouillé par aucune checklist : c'est justement
            avant d'avoir fini le dossier qu'on veut pouvoir dire « lui il est
            bon », pour savoir sur qui le finir. */}
        {/* LES DEUX RÉPONSES, au même endroit — jamais les deux à la fois.
            Écarté : le badge PORTE la raison (un « écarté » sans motif fait
            reposer la question au premier qui relit le dossier) et le seul
            geste offert est de lever. Sinon : l'avis positif, et la porte
            pour dire non. */}
        {candidat.ne_pas_envoyer ? (
          <span onClick={e => e.stopPropagation()} style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', flex: 'none' }}>
            <span {...(index === 0 ? ancre('bon-a-envoyer') : {})}
              title={`Ne pas envoyer${candidat.ne_pas_envoyer_motif ? ` — ${candidat.ne_pas_envoyer_motif}` : ''} : ce profil ne partira pas dans la livraison du dossier, même si son lot est validé.`}
              style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', fontSize: '10.5px', fontWeight: 800, letterSpacing: '0.05em', textTransform: 'uppercase', padding: '2px 8px', borderRadius: '6px', border: '1px solid var(--danger-fg)', color: 'var(--danger-fg)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {/* LE MOTIF N'EST PLUS ICI (23.09 : « le nom est caché à cause du
                  texte de ne pas envoyer »). Collé au badge, il prenait la
                  moitié de la ligne et rognait le NOM — or le nom est ce qu'on
                  lit en premier. Il descend sous le nom, où il a toute la
                  largeur ; il reste donc visible, ce qui était le point. */}
              <BI icon="send-slash" /> Ne pas envoyer
            </span>
            <button type="button" disabled={refusBusy} title="Lever la marque : le profil peut repartir dans la livraison"
              onClick={e => { e.stopPropagation(); setRefusBusy(true); Promise.resolve(onNePasEnvoyer && onNePasEnvoyer({ actif: false })).finally(() => setRefusBusy(false)); }}
              style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '5px 9px', borderRadius: '7px', border: '1px solid var(--input-border)', background: 'transparent', color: 'var(--text-3)', fontSize: '11.5px', fontWeight: 600, cursor: 'pointer', flex: 'none', fontFamily: 'inherit' }}>
              <BI icon={refusBusy ? 'arrow-repeat' : 'arrow-counterclockwise'} /> Lever
            </button>
          </span>
        ) : (<>
        <button {...(index === 0 ? ancre('bon-a-envoyer') : {})} onClick={e => { e.stopPropagation(); onBonAEnvoyer && onBonAEnvoyer(!candidat.bon_a_envoyer); }}
          title={candidat.bon_a_envoyer
            ? 'Vous avez jugé ce profil bon à envoyer — cliquer pour retirer'
            : 'Dire que ce profil est bon à envoyer (votre avis, indépendant du dossier)'}
          style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '5px 9px', borderRadius: '7px',
            // Posé, l'avis se lit en VERT — la même teinte que le liseré de la
            // ligne : un seul signal, deux endroits, pas deux couleurs à
            // apprendre.
            border: candidat.bon_a_envoyer ? '1px solid var(--erp-success)' : '1px solid var(--input-border)',
            background: candidat.bon_a_envoyer ? 'var(--erp-success-soft)' : 'transparent',
            color: candidat.bon_a_envoyer ? 'var(--erp-success)' : 'var(--text-3)',
            fontSize: '11.5px', fontWeight: candidat.bon_a_envoyer ? 700 : 600,
            cursor: 'pointer', flex: 'none', fontFamily: 'inherit' }}>
          <BI icon={candidat.bon_a_envoyer ? 'hand-thumbs-up-fill' : 'hand-thumbs-up'} /> Bon à envoyer
        </button>
        <button type="button" onClick={e => { e.stopPropagation(); setRefusForm(refusForm == null ? '' : null); }}
          title="Écarter ce profil de l'envoi sur ce besoin — la raison est demandée, et elle reste sur le dossier"
          className="bd-icon-btn" style={{ flex: 'none', color: refusForm != null ? 'var(--danger-fg)' : undefined }}>
          <BI icon="send-slash" />
        </button>
        </>)}
        {/* QUALIFICATION — « à qualifier par qui ». Trois états dans le même
            emplacement : le bouton qui confie, le nom de celle qui l'a en
            main, ou le verdict signé. Un état par ligne, jamais deux, sinon
            on relance une demande déjà en cours. */}
        {besoinId != null && (candidat.candidate_id ?? candidat.canonical_candidate_id) != null && (
          <span {...(index === 0 ? ancre('faire-qualifier') : {})} onClick={e => e.stopPropagation()} style={{ display: 'inline-flex', flex: 'none' }}>
            <DemanderQualification
              candidateId={candidat.candidate_id ?? candidat.canonical_candidate_id}
              besoinId={besoinId}
              showNotification={showNotification} />
          </span>
        )}
        {/* Action « Prêt à envoyer » — dans la ligne, 3 états (le vert n'est jamais une action).
            Verrouillé <5/5, primaire à 5/5, chip d'état + Annuler une fois marqué. */}
        {candidat.valide ? (
          <>
            <span {...(index === 0 ? ancre('pret-a-envoyer') : {})} className="bd-ok-chip" style={{ flex: 'none' }}><BI icon="check-circle-fill" /> Prêt à envoyer</span>
            <button onClick={e => { e.stopPropagation(); onUpdate(candidat.id, 'valide', false); showNotification?.('Marquage annulé', 'success'); }} title="Annuler le marquage"
              style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '5px 8px', borderRadius: '7px', border: 'none', background: 'transparent', color: 'var(--text-3)', fontSize: '11.5px', fontWeight: 600, cursor: 'pointer', flex: 'none', fontFamily: 'inherit' }}><BI icon="arrow-counterclockwise" /> Annuler</button>
          </>
        ) : allReady ? (
          <>
            <span {...(index === 0 ? ancre('pret-a-envoyer') : {})} className="bd-mr-chip ready" title="Market Ready — complet" style={{ flex: 'none' }}>{mrDone}/{mrTotal}</span>
            <button onClick={e => { e.stopPropagation(); onUpdate(candidat.id, 'valide', true); showNotification?.(`${cardName || 'Candidat'} marqué « Prêt à envoyer »`, 'success'); }}
              style={{ display: 'flex', alignItems: 'center', gap: '7px', padding: '6px 11px', borderRadius: '8px', border: 'none', background: 'var(--accent)', color: 'var(--accent-fg)', fontSize: '12px', fontWeight: 600, cursor: 'pointer', flex: 'none', fontFamily: 'inherit' }}><BI icon="check-lg" /> Marquer prêt</button>
          </>
        ) : (
          <>
            <span {...(index === 0 ? ancre('pret-a-envoyer') : {})} className="bd-mr-chip" title="Market Ready" style={{ flex: 'none' }}>{mrDone}/{mrTotal}</span>
            <button disabled title={`Complétez la checklist Market Ready (${mrDone}/${mrTotal}) pour débloquer l'envoi`}
              style={{ display: 'flex', alignItems: 'center', gap: '7px', padding: '6px 11px', borderRadius: '8px', border: '1px solid var(--hair)', background: 'var(--code-bg)', color: 'var(--text-faint)', fontSize: '12px', fontWeight: 600, cursor: 'not-allowed', flex: 'none', fontFamily: 'inherit' }}><BI icon="lock-fill" /> Marquer prêt</button>
          </>
        )}
        {onOpenCandidat && (() => {
          // Navigation UNIQUEMENT par l'id canonique — jamais l'id de ligne (espaces d'ids
          // qui se chevauchent). Fiche pas encore mirrorée (canonique null) → bouton désactivé.
          const canonId = candidat.canonical_candidate_id ?? candidat.candidate_id ?? null;
          return (
            <button onClick={e => { e.stopPropagation(); if (canonId != null) onOpenCandidat(canonId); }} disabled={canonId == null}
              className="bd-icon-btn" title={canonId != null ? 'Ouvrir la fiche candidat' : 'Fiche pas encore synchronisée — réessayez dans un instant'}
              style={{ flex: 'none', opacity: canonId == null ? 0.4 : 1, cursor: canonId == null ? 'not-allowed' : 'pointer' }}>
              <BI icon="person-badge" />
            </button>
          );
        })()}
        <BI icon={expanded ? 'chevron-up' : 'chevron-down'} style={{ color: 'var(--text-faint)', flex: 'none' }} />
      </div>

      {/* POURQUOI CE PROFIL NE PART PAS. Le serveur REFUSE un marquage sans
          raison : on la demande donc ici, et le bouton reste éteint tant
          qu'elle est vide — plutôt qu'un aller-retour pour se faire dire non.
          C'est cette phrase qu'on relira le jour où le profil revient. */}
      {refusForm != null && !candidat.ne_pas_envoyer && (
        <div onClick={e => e.stopPropagation()}
          style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '9px 13px', borderTop: '1px solid var(--hair)', background: 'var(--code-bg)' }}>
          <label htmlFor={`npe-${candidat.id}`} style={{ fontSize: '11.5px', fontWeight: 600, color: 'var(--text-2)', flex: 'none' }}>
            Pourquoi ce profil ne part pas
          </label>
          <input id={`npe-${candidat.id}`} value={refusForm} autoFocus
            onChange={e => setRefusForm(e.target.value)}
            onKeyDown={e => { if (e.key === 'Escape') setRefusForm(null); if (e.key === 'Enter' && refusForm.trim().length >= 3) envoyerRefus(); }}
            placeholder="Prétentions hors budget, indisponible avant janvier, test raté…"
            className="erp-field" style={{ flex: 1, minWidth: 0, fontSize: '12px' }} />
          <button type="button" disabled={refusBusy || refusForm.trim().length < 3} onClick={envoyerRefus}
            style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '6px 11px', borderRadius: '7px', border: 'none',
              background: 'var(--danger-fg)', color: '#fff', fontSize: '11.5px', fontWeight: 600, flex: 'none', fontFamily: 'inherit',
              opacity: refusForm.trim().length >= 3 ? 1 : 0.45, cursor: refusForm.trim().length >= 3 ? 'pointer' : 'not-allowed' }}>
            <BI icon={refusBusy ? 'arrow-repeat' : 'send-slash'} /> Écarter de l'envoi
          </button>
          <button type="button" onClick={() => setRefusForm(null)} className="bd-icon-btn" title="Annuler" style={{ flex: 'none' }}><BI icon="x-lg" /></button>
        </div>
      )}

      {expanded && (
      <div className="bd-cand-body">
        {/* L'entretien est un ÉTAT du couple candidat × besoin : il vit ici,
            dans la carte, et n'est lu qu'à l'ouverture — une liste de cent
            candidats ne doit pas déclencher cent requêtes. */}
        {besoinId != null && (candidat.candidate_id ?? candidat.canonical_candidate_id ?? candidat.id) != null && (
          <span {...(index === 0 ? ancre('entretien') : {})} style={{ display: 'inline-flex', flex: 'none' }}>
            <EntretienCandidat besoinId={besoinId}
              candidatId={candidat.candidate_id ?? candidat.canonical_candidate_id ?? candidat.id}
              nomCandidat={candidat.nom || candidat.name || ''}
              showNotification={showNotification} onEtat={onEntretienEtat} />
          </span>
        )}
        {/* 2 actions au plus restent visibles (Test = primaire, Appel IA = terrain) ;
            tout le reste vit dans le menu « Actions » groupé — la rangée ne s'empile
            plus sur deux lignes quand des modules s'activent. */}
        <div className="bd-cand-tools">
          {onStartTest && (
            <button onClick={onStartTest} className="bd-mini bd-mini-accent"><BI icon="ui-checks" /> Test</button>
          )}
          {onCallAgent && onCallAgent.questions?.length > 0 && (
            <button onClick={() => setModal('call')} className="bd-mini" title="Appeler le candidat avec l'agent IA"><BI icon="telephone" /> Appel IA</button>
          )}
          <CandActionsMenu sections={[
            { title: 'Documents', items: [
              onPrepareCv && { icon: 'magic', label: 'Optimiser le CV (besoin)', onClick: onPrepareCv,
                hint: 'Optimiser le CV (IA) pour ce besoin : diff, écarts à challenger, validation candidat' },
              { icon: 'file-earmark-person', label: 'CV format entreprise',
                onClick: () => lancerCv({
                  // id CANONIQUE : les documents générés vont sur la fiche
                  // candidat, et la détection « CV entreprise déjà présent »
                  // lit la même liste.
                  candidat: { ...candidat, id: candidat.candidate_id ?? candidat.canonical_candidate_id ?? candidat.id },
                  besoinId, onUpdate: refreshPieces,
                }),
                hint: 'Mettre le CV au format entreprise' },
              matriceOn && { icon: 'bar-chart', label: 'Matrice de compétences', onClick: () => setModal('matrix'),
                hint: 'Générer la matrice de compétences PowerPoint' },
              ndaAppOn && docsignAppOn && { icon: ndaBusy ? 'arrow-repeat' : 'file-earmark-lock',
                label: ndaBusy ? 'NDA en préparation…' : 'Envoyer le NDA', disabled: ndaBusy,
                onClick: ouvrirNda,
                hint: 'Préparer le NDA de cette opportunité (template du module NDA, client du besoin injecté) et l\'envoyer en signature' },
            ] },
            { title: 'Entretien', items: [
              onCallAgent?.onSchedule && { icon: 'calendar2-event', label: 'Planifier un appel', onClick: () => onCallAgent.onSchedule(candidat) },
            ] },
            { items: [
              { icon: 'trash3', label: 'Supprimer le candidat', danger: true, onClick: () => onDelete(candidat.id) },
            ] },
          ]} />
        </div>
        {nda.panneau}
        {modal === 'call' && onCallAgent && (
          <CallAgentModal candidat={candidat} besoin={onCallAgent.besoin} questions={onCallAgent.questions}
            showNotification={showNotification} onClose={() => setModal(null)} onCallComplete={onCallAgent.onComplete} />
        )}
        {modal === 'matrix' && (
          <SkillsMatrixModal candidat={candidat} besoin={onMatrixBesoin || {}} showNotification={showNotification}
            onClose={() => setModal(null)} onUpdate={refreshPieces} />
        )}
        {/* Le traitement CV est confié à l'hôte global (voir TraitementsCv) :
            réduit en pastille, il survit à un changement d'écran. */}
        {flowStages.length > 0 && (
          <div>
            <label className="bd-label"><BI icon="diagram-3" /> Étape — flow du besoin</label>
            <div className="flex" style={{ flexWrap: 'wrap', gap: '6px', alignItems: 'center' }}>
              {flowStages.map(s => {
                const current = (candidat.flow_etape || flowStages[0]?.id) === s.id;
                return <button key={s.id} onClick={() => onUpdate(candidat.id, 'flow_etape', s.id)} className={current ? 'bd-mini bd-mini-accent' : 'bd-mini'}>{s.label}</button>;
              })}
              {/* Issue terminale hors pipeline : le candidat décline. Re-cliquer
                  le remet à la première étape. */}
              <span style={{ width: '1px', height: '18px', background: 'var(--hair)', flex: 'none', margin: '0 2px' }} />
              {(() => {
                const ni = candidat.flow_etape === 'non_interesse';
                return (
                  <button
                    onClick={() => {
                      onUpdate(candidat.id, 'flow_etape', ni ? (flowStages[0]?.id || '') : 'non_interesse');
                      showNotification?.(ni ? `${cardName || 'Candidat'} remis dans le flow.` : `${cardName || 'Candidat'} marqué « Non intéressé ».`, 'success');
                    }}
                    className="bd-mini"
                    title={ni ? 'Annuler — remettre le candidat dans le flow' : 'Le candidat décline l\'opportunité'}
                    style={ni
                      ? { background: 'var(--danger-bg)', borderColor: 'var(--danger-bd)', color: 'var(--danger-fg)' }
                      : { color: 'var(--danger-fg)' }}>
                    <BI icon="hand-thumbs-down" /> Non intéressé
                  </button>
                );
              })()}
            </div>
          </div>
        )}
        <div className="bd-grid2">
          <div>
            <label className="bd-label">Expérience</label>
            <div className="flex items-center gap-2">
              <input type="number" value={candidat.experience || 0} onChange={e => handleChange('experience', parseInt(e.target.value) || 0)}
                className="bd-input" style={{ width: '80px' }} min="0" max="50" />
              <span style={{ fontSize: '13px', color: 'var(--text-2)' }}>ans</span>
            </div>
            {saving.experience && <p className="bd-saving" style={{ marginTop: '4px' }}><BI icon="arrow-repeat" /> Sauvegarde…</p>}
          </div>
          <div>
            <label className="bd-label">Permis</label>
            <ErpiaSelect value={candidat.permis || 'a definir'} onChange={e => handleChange('permis', e.target.value)}
              className="bd-input">
              <option value="a definir">À définir</option>
              <option value="B">Permis B</option>
              <option value="C">Permis C</option>
              <option value="G">Permis G</option>
              <option value="pas_de_permis">Pas de permis</option>
              <option value="UE">UE</option>
              <option value="autre">Autre</option>
            </ErpiaSelect>
          </div>
        </div>

        <div className="bd-grid2">
          <div>
            <label className="bd-label">Localisation</label>
            <input type="text" value={candidat.localisation || ''} onChange={e => handleChange('localisation', e.target.value)}
              className="bd-input" placeholder="Ville, pays" />
            {saving.localisation && <p className="bd-saving" style={{ marginTop: '4px' }}><BI icon="arrow-repeat" /> Sauvegarde…</p>}
          </div>
          <div>
            <label className="bd-label">Disponibilité</label>
            {/* La disponibilité est une DATE depuis que sourcia la publie ainsi :
                on la saisit au calendrier, et l'écriture porte les deux champs —
                date_disponibilite (la donnée) et disponibilite (la phrase que
                tous les autres écrans affichent déjà). Le délai en texte libre
                (« immédiate », « à négocier ») reste possible d'un clic : il y a
                des profils dont la disponibilité n'est pas une date. */}
            <DispoField candidat={candidat} onChange={handleChange} saving={saving} />
          </div>
        </div>

        <div className="bd-grid2">
        <div>
          <label className="bd-label"><BI icon="telephone-fill" /> Téléphone (utilisé pour l'appel IA)</label>
          <div className="flex items-center gap-2">
            <input type="tel" value={candidat.telephone || ''} onChange={e => handleChange('telephone', e.target.value)}
              className="bd-input bd-input-mono" style={{ flex: 1 }}
              placeholder="+41 78 642 90 35  ou  0786429035" />
            {candidat.telephone && (
              <>
                <a href={`tel:${candidat.telephone.replace(/[^\d+]/g, '')}`}
                  className="bd-icon-btn" style={{ width: '38px', height: '38px', border: '1px solid var(--input-border)' }}
                  title="Appeler depuis votre téléphone">
                  <BI icon="telephone-outbound" />
                </a>
                <a href={`https://wa.me/${candidat.telephone.replace(/[^\d]/g, '')}`} target="_blank" rel="noreferrer"
                  className="bd-icon-btn" style={{ width: '38px', height: '38px', border: '1px solid var(--input-border)', color: '#16a34a' }}
                  title="Ouvrir WhatsApp">
                  <BI icon="whatsapp" />
                </a>
              </>
            )}
          </div>
          {saving.telephone && <p className="bd-saving" style={{ marginTop: '4px' }}><BI icon="arrow-repeat" /> Sauvegarde… · normalisé en E.164 côté serveur</p>}
        </div>
        {/* L'EMAIL, à côté du téléphone (demande 21.09) : c'est l'adresse
            que les envois lisent — fiche de poste, convocation, offre. Le
            serveur la valide et la normalise ; une adresse refusée revient
            avec sa phrase, la liste se relit. Écrit sur la fiche canonique,
            y compris pour une ligne ancienne. */}
        <div>
          <label className="bd-label"><BI icon="envelope-fill" /> Email</label>
          <div className="flex items-center gap-2">
            <input type="email" value={candidat.email || ''} onChange={e => handleChange('email', e.target.value)}
              className="bd-input bd-input-mono" style={{ flex: 1 }}
              placeholder="prenom.nom@domaine.ch" autoComplete="off" spellCheck={false} />
            {candidat.email && (
              <a href={`mailto:${candidat.email}`}
                className="bd-icon-btn" style={{ width: '38px', height: '38px', border: '1px solid var(--input-border)' }}
                title="Écrire depuis votre messagerie">
                <BI icon="envelope-arrow-up" />
              </a>
            )}
          </div>
          {saving.email && <p className="bd-saving" style={{ marginTop: '4px' }}><BI icon="arrow-repeat" /> Sauvegarde…</p>}
        </div>
        </div>

        <div>
          <label className="bd-label">Commentaire</label>
          <MentionArea value={candidat.commentaire || ''} onChange={v => handleChange('commentaire', v)}
            team={team} rows={4} onFocus={commentFocus} onBlur={commentBlur}
            style={{ fontSize: '13px', padding: '8px 11px' }}
            placeholder="Points forts, expériences clés… tapez @ pour mentionner un collègue" />
          {saving.commentaire && <p className="bd-saving" style={{ marginTop: '4px' }}><BI icon="arrow-repeat" /> Sauvegarde…</p>}
        </div>

        {/* CR de l'entretien : pré-rempli par sourcia quand le candidat vient
            d'une proposition sourceur acceptée (le back le copie à
            l'acceptation), complétable ensuite après vos propres entretiens. */}
        <div>
          <label className="bd-label"><BI icon="chat-left-text" /> CR d'entretien</label>
          {/* Un compte rendu se lit et s'écrit en entier (vécu 28.09 : « trop
              petit ») : le champ part de six lignes et grandit avec le texte. */}
          <ChampExtensible value={candidat.cr_entretien || ''} onChange={e => handleChange('cr_entretien', e.target.value)}
            minLignes={6} className="bd-input" style={{ minHeight: '132px', fontSize: '13px', padding: '8px 11px', lineHeight: 1.5 }}
            placeholder="Compte rendu de l'entretien — pré-rempli quand la proposition sourceur en portait un" />
          {saving.cr_entretien && <p className="bd-saving" style={{ marginTop: '4px' }}><BI icon="arrow-repeat" /> Sauvegarde…</p>}
        </div>

        {/* Zone Documents unifiée. Le CV n'a plus sa propre barre d'actions :
            il passe par la MÊME rangée que les autres documents (œil, crayon,
            téléchargement, corbeille) — vécu 11.09 : « pourquoi je n'ai pas le
            même menu avec l'œil partout ». La carte fournit les DONNÉES du CV
            de la fiche, pas son rendu : deux barres, c'était deux endroits où
            corriger la même chose. */}
        <PiecesJointesManager candidat={candidat} besoinId={besoinId} showNotification={showNotification}
          refreshKey={`${piecesRefreshKey}-${piecesRefreshAll}`}
          cvFiche={candidat.cv_url ? {
            url: candidat.cv_url,
            nom: candidat.cv_original_name || 'CV du candidat',
            publicId: candidat.cv_public_id || null,
            size: candidat.cv_size || null,
            ajouteLe: candidat.cv_ajoute_le || null,
            ajoutePar: candidat.cv_ajoute_par || null,
            // cv_est_entreprise (contrat back) : true = préparé au format de
            // l'entreprise, false/absent = fichier d'origine.
            estEntreprise: candidat.cv_est_entreprise === true,
            kdrive: isKDriveCV(candidat.cv_url),
          } : null}
          onSupprimerCvFiche={handleDeleteCV}
          suppressionCvEnCours={deletingCV}
          onUploadCvFiche={async (f) => {
            try { await onUploadCV(candidat.id, f); }
            catch { showNotification('Erreur upload CV', 'error'); }
          }} />
        <TestSessionsHistory candidatId={candidat.id} refreshKey={sessionsRefreshKey} />
      </div>
      )}
    </div>
  );
};

// ===== LISTE DES BESOINS =====
// ===== MENTION TEXTAREA — supporte @mentions avec autocomplete =====
const MentionTextarea = ({ value, onChange, onBlur, onMention, users = [], placeholder, rows = 5, className = '' }) => {
  const [showSuggest, setShowSuggest] = useState(false);
  const [mentionQuery, setMentionQuery] = useState('');
  const [mentionPos, setMentionPos] = useState(0);
  const ref = React.useRef(null);

  const handleChange = (e) => {
    const val = e.target.value;
    const pos = e.target.selectionStart;
    onChange(val);

    // Detect @mention — \p{L} : les usernames accentués (françois, jérôme…)
    // ne cassent pas la détection en plein mot
    const textBefore = val.slice(0, pos);
    const mentionMatch = textBefore.match(/@([\p{L}\p{N}._-]*)$/u);
    if (mentionMatch) {
      setMentionQuery(mentionMatch[1].toLowerCase());
      setMentionPos(pos - mentionMatch[0].length);
      setShowSuggest(true);
    } else {
      setShowSuggest(false);
    }
  };

  const insertMention = (user) => {
    const before = value.slice(0, mentionPos);
    const after = value.slice(ref.current.selectionStart);
    const displayName = user.prenom || user.username;
    const newVal = `${before}@${displayName} ${after}`;
    onChange(newVal);
    setShowSuggest(false);
    if (onMention) onMention(user);
    ref.current.focus();
  };

  const filtered = users.filter(u =>
    (u.prenom || u.username || '').toLowerCase().startsWith(mentionQuery) ||
    (u.username || '').toLowerCase().startsWith(mentionQuery)
  ).slice(0, 5);

  return (
    <div className="relative">
      <textarea ref={ref} value={value} onChange={handleChange} onBlur={onBlur}
        placeholder={placeholder} rows={rows}
        className={className || "bd-input"} style={!className ? { resize: 'none' } : undefined} />
      {showSuggest && filtered.length > 0 && (
        <div className="bd-mention-pop">
          {filtered.map(u => (
            <button key={u.id} onMouseDown={e => { e.preventDefault(); insertMention(u); }}
              className="bd-mention-item">
              <span className="bd-mention-av">
                {(u.prenom || u.username || '?')[0].toUpperCase()}
              </span>
              <span>{u.prenom || u.username}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};



// ===== CREATION BESOIN =====
const CreateBesoinModal = ({ onClose, onSuccess, showNotification, initialClient = '' }) => {
  const [formData, setFormData] = useState({ titre: '', client: initialClient, description: '', localisation: '', priorite: 'medium', lien_boond: '', responsableId: '', recruteuseId: '', sourcing_auto: false, publier_linkedin: false, dateDemarrage: '', salaireMax: '', reference_interne: '', ao_id: '' });
  const [loading, setLoading] = useState(false);
  // DOSSIER AO DÈS LA CRÉATION (27.10 : « on peut aussi choisir un AO si on
  // veut le lier »). La liste est celle de l'écran Dossiers AO (cloisonnée
  // par le serveur) ; vide ou absente, le champ ne s'affiche pas.
  const [aoListe, setAoListe] = useState([]);
  useEffect(() => {
    let annule = false;
    fetch(`${BASE}/ao`, { headers: { Authorization: `Bearer ${APIService.getToken()}` } })
      .then(r => r.json()).then(j => { if (!annule && j?.success) setAoListe(Array.isArray(j.data) ? j.data : []); })
      .catch(() => {});
    return () => { annule = true; };
  }, []);
  const [users, setUsers] = useState([]);
  // LA RECRUTEUSE DÈS LA CRÉATION (23.09 : « pourquoi je ne peux pas
  // choisir la recruteuse d'un nouveau besoin ? »). Même condition que la
  // ligne de la fiche : l'organisation a le sourcing, qui lui proposera les
  // profils trouvés. Tous les internes actifs sont proposés.
  const sourcingOrgCreation = useFeatureOptIn('sourcing_linkedin');
  // PUBLIER SUR LINKEDIN DÈS LA CRÉATION (12.10) : la case n'existe que si
  // l'organisation a le module LinkedIn ET l'agent du moteur — c'est lui qui
  // publie l'offre. Le serveur ouvre l'annonce et la confie à l'agent ; la
  // création ne bloque jamais dessus, la réponse dit ce qu'il en est.
  // « Publier sur LinkedIn » à la création : administrateur seulement (27.10).
  const linkedinCreation = useFeatureOptIn('linkedin_publication') && sourcingOrgCreation && isAoAdmin(APIService.getCurrentUser());
  // Les critères de l'offre, choisis sous la case (13.10) : l'autorisation de
  // travail en Suisse pour commencer, le reste au choix.
  const [critLinkedin, setCritLinkedin] = useState(CRITERES_DEPART);
  const { registre: registreCriteres, absent: sansRegistreCriteres } = useRegistreCriteres(linkedinCreation && formData.publier_linkedin === true);
  const [internes, setInternes] = useState([]);
  const [seulsCommerciaux, setSeulsCommerciaux] = useState(true);
  const [libelleRole, setLibelleRole] = useState('Business manager');

  useEffect(() => {
    // Responsable commercial : ce sont les COMMERCIAUX (business managers)
    // qui portent un besoin. Les autres rôles internes restent proposés tant
    // qu'aucun commercial n'existe — un besoin doit rester créable.
    //
    // Un compte supprimé garde son nom, suffixé « #supprime-<n> » côté
    // serveur : sans ce filtre, la liste proposait des gens partis depuis
    // des mois.
    APIService.getUsers().then((d) => {
      const tous = (d.users || []).filter(u => compteActif(u) && !(u.role === 'ressource' || u.ressource === true));
      const bm = tous.filter(estBusinessManager);
      setUsers(bm.length ? bm : tous);
      setInternes(tous);
      setSeulsCommerciaux(bm.length > 0);
      // Le libellé du rôle vient du serveur : la note ne le code plus en dur.
      const admis = Array.isArray(d.roles_admis) ? d.roles_admis : [];
      const r = admis.find(x => (x?.cle ?? x?.key) === 'business_manager');
      if (r?.libelle) setLibelleRole(r.libelle);
    }).catch(() => {});
  }, []);

  // IMPORTER UNE FICHE DE POSTE (11.09) : le document PRÉ-REMPLIT le
  // formulaire, il ne crée pas le besoin dans son coin. Un besoin a besoin
  // d'un responsable commercial, et aucune annonce ne le nomme — c'est la
  // personne qui complète, et la création reste celle de ce bouton.
  const [importJd, setImportJd] = useState(null);   // { titre_devine, contexte, missions, profil }
  const [importEnCours, setImportEnCours] = useState(false);
  const jdFileRef = React.useRef(null);

  const importerJd = async (file) => {
    if (!file) return;
    setImportEnCours(true);
    try {
      const fd = new FormData();
      fd.append('fichier', file);
      const r = await fetch(`${BASE}/besoins/jd/lire`, {
        method: 'POST', headers: { Authorization: `Bearer ${APIService.getToken()}` }, body: fd });
      if (r.status === 404 || r.status === 501) {
        showNotification("L'import de fiche de poste arrive côté serveur.", 'info');
        return;
      }
      const j = await r.json().catch(() => ({}));
      // Le message du serveur fait foi (« document scanné en image »,
      // « format non pris en charge ») : il dit quoi faire.
      if (!r.ok || j.success === false) throw new Error(j.error || `HTTP ${r.status}`);
      const d = j.data || {};
      // Ce que le document dit REMPLIT ce qui est vide ; ce que la personne a
      // déjà tapé n'est jamais écrasé.
      setFormData(f => ({ ...f,
        titre: f.titre || d.titre || '',
        client: f.client || d.client || '',
        localisation: f.localisation || d.lieu || '',
        description: f.description || d.texte || '',
      }));
      setImportJd({ titre_devine: d.titre_devine === true, contexte: d.contexte,
        missions: d.missions || [], profil: d.profil || [], fichier: file.name });
      showNotification(`« ${file.name} » lu — vérifiez le titre et le client, puis créez le besoin.`, 'success');
    } catch (e) { showNotification(`Import impossible : ${e.message}`, 'error'); }
    finally { setImportEnCours(false); }
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      const publierLk = linkedinCreation && formData.publier_linkedin === true;
      const { ao_id: aoChoisi, reference_interne: refInterne, ...reste } = formData;
      const result = await APIService.createBesoin({ ...reste, publier_linkedin: publierLk, ...(publierLk && registreCriteres ? { linkedin_criteres: nettoyerCriteres(critLinkedin) } : {}),
        ...(refInterne.trim() ? { reference_interne: refInterne.trim() } : {}),
        ...(aoChoisi ? { ao_id: Number(aoChoisi) } : {}) });
      // Serveur pas encore à jour (il ignore ao_id et ne rend pas `ao`) : le
      // rattachement passe par la route du dossier AO, mêmes contrôles.
      let aoIssue = result?.ao || null;
      if (aoChoisi && result?.id && result.ao === undefined) {
        try {
          const r = await fetch(`${BASE}/ao/${aoChoisi}/besoins`, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${APIService.getToken()}` },
            body: JSON.stringify({ besoin_id: result.id }),
          });
          const j = await r.json().catch(() => ({}));
          aoIssue = r.ok && j.success !== false ? { ok: true, message: j.message } : { ok: false, error: j.error || `HTTP ${r.status}` };
        } catch (e) { aoIssue = { ok: false, error: 'rattachez-le depuis le dossier AO.' }; }
      }
      if (aoIssue && !aoIssue.ok) showNotification(`Besoin créé, mais il n'est pas rattaché au dossier AO : ${aoIssue.error}`, 'error');
      // Serveur pas encore à jour (il ignore recruteuseId et ne rend pas
      // `recruteuse`) : la recruteuse passe par la route de la fiche, qui
      // vérifie le compte et la prévient de la même façon.
      if (formData.recruteuseId && result?.id && result.recruteuse === undefined) {
        try {
          const r = await fetch(`${BASE}/besoins/${result.id}/recruteuse`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${APIService.getToken()}` },
            body: JSON.stringify({ user_id: Number(formData.recruteuseId) }),
          });
          const j = await r.json().catch(() => ({}));
          if (!r.ok || j.success === false) showNotification(`Besoin créé, mais le recrutement n'a pas pu être attribué : ${j.error || `HTTP ${r.status}`}. Attribuez-le sur la fiche.`, 'error');
        } catch (e) { showNotification("Besoin créé, mais le recrutement n'a pas pu être attribué — attribuez-le sur la fiche.", 'error'); }
      }
      // La fiche de poste STRUCTURÉE lue à l'import suit la création — par le
      // même chemin que l'édition manuelle. Sans elle, le premier affichage la
      // re-découperait depuis la description : un appel de plus pour un
      // résultat qu'on a déjà.
      if (importJd && result?.id) {
        try {
          await fetch(`${BASE}/besoins/${result.id}/jd`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${APIService.getToken()}` },
            body: JSON.stringify({ contexte: importJd.contexte, missions: importJd.missions, profil: importJd.profil }),
          });
        } catch (e) { console.warn('Fiche de poste structurée non enregistrée:', e); }
      }
      try {
        await fetch(`${BASE}/tests/generate`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${APIService.getToken()}` },
          body: JSON.stringify({ besoinId: result.id, titre: formData.titre, client: formData.client, description: formData.description })
        });
      } catch (e) { console.warn('Questions non générées:', e); }
      // L'issue LinkedIn est DITE (publiée par l'agent, ou pourquoi pas).
      const lk = result?.linkedin;
      if (lk) showNotification(lk.ok ? `Besoin créé. ${lk.message}` : `Besoin créé, mais l'offre LinkedIn n'est pas partie : ${lk.error}`, lk.ok ? 'success' : 'error');
      else showNotification('Besoin créé avec questions techniques !', 'success');
      onSuccess(result); onClose();
    } catch (error) { showNotification(error.message || 'Erreur création', 'error'); } finally { setLoading(false); }
  };

  const lbl = { display: 'block', fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', color: 'var(--text-3)', marginBottom: '6px' };
  const PRIOS = [
    { v: 'low', label: 'Basse', dot: '#16a34a' },
    { v: 'medium', label: 'Moyenne', dot: '#d97706' },
    { v: 'high', label: 'Haute', dot: 'var(--brand)' },
  ];

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(4,6,11,0.55)', backdropFilter: 'blur(2px)', zIndex: 500, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', fontFamily: "'IBM Plex Sans', system-ui, sans-serif" }} onClick={() => !loading && onClose()}>
      <style>{BD_STYLES}</style>
      <div className="bd-card" style={{ width: '100%', maxWidth: '560px', maxHeight: '88vh', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
        <div className="bd-sect-head" style={{ borderRadius: '12px 12px 0 0', flexShrink: 0 }}>
          <span className="bd-sect-title"><BI icon="briefcase" /> Nouveau besoin<span style={{ color: 'var(--brand)' }}>.</span></span>
          <button onClick={onClose} className="bd-icon-btn" disabled={loading}><BI icon="x-lg" /></button>
        </div>
        <form onSubmit={handleSubmit} style={{ padding: '18px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '15px' }}>
          {/* Partir d'une annonce plutôt que d'une page blanche. */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', padding: '11px 13px', border: '1px dashed var(--input-border)', borderRadius: '10px' }}>
            <BI icon="file-earmark-arrow-up" style={{ color: 'var(--text-3)' }} />
            <span style={{ flex: 1, minWidth: '180px', fontSize: '12.5px', color: 'var(--text-2)' }}>
              {importJd
                ? `« ${importJd.fichier} » lu — ${importJd.missions.length} mission(s), ${importJd.profil.length} ligne(s) de profil.`
                : "Vous avez la fiche de poste en PDF ou en Word ? Importez-la, les champs se remplissent."}
            </span>
            <button type="button" onClick={() => jdFileRef.current?.click()} disabled={importEnCours || loading}
              className="bd-btn-ghost"
              style={{ padding: '7px 12px', borderRadius: '8px', fontSize: '12.5px', fontWeight: 600, border: '1px solid var(--input-border)', background: 'var(--ghost-bg)', color: 'var(--text)', fontFamily: 'inherit', cursor: 'pointer' }}>
              <BI icon={importEnCours ? 'arrow-repeat' : 'upload'} style={importEnCours ? { display: 'inline-block', animation: 'ats-spin .7s linear infinite' } : undefined} />
              {importEnCours ? ' Lecture…' : (importJd ? ' Remplacer' : ' Importer une fiche de poste')}
            </button>
            <input ref={jdFileRef} type="file" accept=".pdf,.doc,.docx,.odt,.txt,.md" style={{ display: 'none' }}
              onChange={e => { const f = e.target.files?.[0]; e.target.value = ''; importerJd(f); }} />
          </div>
          {/* Le titre est DEVINÉ quand le document n'a pas pu être lu par
              l'IA : on le dit, plutôt que de laisser créer un besoin nommé
              d'après un en-tête de page. */}
          {importJd?.titre_devine && (
            <p style={{ margin: '-6px 0 0', fontSize: '11.5px', color: 'var(--erp-warning)' }}>
              L'intitulé du poste n'a pas pu être lu avec certitude — vérifiez-le avant de créer.
            </p>
          )}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
            <div>
              <label style={lbl}>Titre du poste *</label>
              <input className="bd-input" autoFocus value={formData.titre} onChange={e => setFormData({ ...formData, titre: e.target.value })} placeholder="Ex: Développeur React Senior" required />
            </div>
            <div>
              <label style={lbl}>Client *</label>
              <input className="bd-input" value={formData.client} onChange={e => setFormData({ ...formData, client: e.target.value })} placeholder="Ex: BNP Paribas" required />
            </div>
          </div>
          <div>
            <label style={lbl}>Responsable commercial *</label>
            <ErpiaSelect className="bd-input" value={formData.responsableId} onChange={e => setFormData({ ...formData, responsableId: e.target.value })} required>
              <option value="">Sélectionner un responsable</option>
              {users.map(u => <option key={u.id} value={u.id}>{nomUtilisateur(u)}{u.email ? ` (${u.email})` : ''}</option>)}
            </ErpiaSelect>
            {!seulsCommerciaux && users.length > 0 && (
              <p style={{ margin: '5px 0 0', fontSize: '11px', color: 'var(--text-3)' }}>
                Aucun compte n'a le rôle {libelleRole} — tous les internes sont proposés. Attribuez-le dans Configuration → Utilisateurs.
              </p>
            )}
          </div>
          {sourcingOrgCreation && (
            <div>
              <label style={lbl} htmlFor="nouveau-besoin-recruteuse">Recrutement</label>
              <ErpiaSelect id="nouveau-besoin-recruteuse" className="bd-input" value={formData.recruteuseId} onChange={e => setFormData({ ...formData, recruteuseId: e.target.value })}>
                <option value="">Personne pour l'instant</option>
                {internes.map(u => <option key={u.id} value={u.id}>{nomUtilisateur(u)}</option>)}
              </ErpiaSelect>
              <p style={{ margin: '5px 0 0', fontSize: '11px', color: 'var(--text-3)' }}>
                La personne choisie est prévenue, et les profils trouvés par le sourcing lui seront proposés à trier. Modifiable ensuite sur la fiche.
              </p>
            </div>
          )}
          {/* DATE DE DÉMARRAGE et SALAIRE MAX (02.10) : obligatoires — le
              serveur refuse sans eux et dit lequel manque. Le salaire est
              annuel, et reste interne. */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '12px' }}>
            <div>
              <label style={lbl} htmlFor="nouveau-besoin-demarrage">Démarrage souhaité *</label>
              <input id="nouveau-besoin-demarrage" type="date" className="bd-input" required
                value={formData.dateDemarrage} onChange={e => setFormData({ ...formData, dateDemarrage: e.target.value })} />
            </div>
            <div>
              <label style={lbl} htmlFor="nouveau-besoin-salaire">Salaire max (CHF brut / an) *</label>
              <input id="nouveau-besoin-salaire" className="bd-input" required inputMode="numeric" placeholder="Ex: 120 000"
                value={formData.salaireMax} onChange={e => setFormData({ ...formData, salaireMax: e.target.value })} />
            </div>
          </div>
          <p style={{ margin: '-8px 0 0', fontSize: '11px', color: 'var(--text-3)' }}>
            Le salaire max reste interne : il n'apparaît jamais sur la fiche de poste envoyée. Les deux se changent ensuite sur la fiche du besoin.
          </p>
          {/* LA VILLE DE LA MISSION. Elle était éditable sur la fiche mais
              absente d'ici — or le sourcing part DANS LA FOULÉE de la
              création : sans elle, la première recherche ratisse partout, et
              personne ne revient la saisir après coup. */}
          <div>
            <label style={lbl}>Ville de la mission</label>
            <input className="bd-input" value={formData.localisation}
              onChange={e => setFormData({ ...formData, localisation: e.target.value })}
              placeholder="Ex: Genève — la ville que le sourcing visera" />
          </div>
          {/* RÉFÉRENCE INTERNE et DOSSIER AO (27.10). La référence est un
              repère pour l'équipe : jamais sur LinkedIn, jamais sur le lien
              envoyé au candidat. */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '12px' }}>
            <div>
              <label style={lbl} htmlFor="nouveau-besoin-ref">Référence interne</label>
              <input id="nouveau-besoin-ref" className="bd-input" maxLength={120} value={formData.reference_interne}
                onChange={e => setFormData({ ...formData, reference_interne: e.target.value })}
                placeholder="Ex: Réf AO OCSIN 26-04" />
            </div>
            {aoListe.length > 0 && (
              <div>
                <label style={lbl} htmlFor="nouveau-besoin-ao">Dossier AO</label>
                <ErpiaSelect id="nouveau-besoin-ao" className="bd-input" value={formData.ao_id} onChange={e => setFormData({ ...formData, ao_id: e.target.value })}>
                  <option value="">Aucun</option>
                  {aoListe.map(a => <option key={a.id} value={String(a.id)}>{a.titre}{a.client ? ` — ${a.client}` : ''}</option>)}
                </ErpiaSelect>
              </div>
            )}
          </div>
          <p style={{ margin: '-8px 0 0', fontSize: '11px', color: 'var(--text-3)' }}>
            La référence reste dans ERPIA : elle n'apparaît ni sur LinkedIn, ni sur la fiche de poste envoyée au candidat.
          </p>
          <div>
            <label style={lbl}>Description / JD</label>
            <textarea className="bd-input" value={formData.description} onChange={e => setFormData({ ...formData, description: e.target.value })}
              rows={6} style={{ resize: 'vertical', lineHeight: 1.5 }}
              placeholder="Collez ici le JD reçu — il servira à générer les questions techniques automatiquement…" />
          </div>
          <div>
            <label style={lbl}>Priorité</label>
            <div style={{ display: 'flex', gap: '6px' }}>
              {PRIOS.map(p => {
                const on = formData.priorite === p.v;
                return (
                  <button key={p.v} type="button" onClick={() => setFormData({ ...formData, priorite: p.v })}
                    style={{ display: 'inline-flex', alignItems: 'center', gap: '7px', padding: '7px 13px', borderRadius: '8px', fontFamily: 'inherit', fontSize: '12.5px', fontWeight: 600, cursor: 'pointer', border: '1px solid', borderColor: on ? 'var(--text-strong)' : 'var(--input-border)', background: on ? 'var(--accent-soft-bg)' : 'var(--ghost-bg)', color: on ? 'var(--text-strong)' : 'var(--text-2)' }}>
                    <span style={{ width: '7px', height: '7px', borderRadius: '50%', background: p.dot, flex: 'none' }} /> {p.label}
                  </button>
                );
              })}
            </div>
          </div>
          {/* À la demande (décision 01.10) : la case est décochée, et le
              serveur ne lance la recherche que si elle est cochée
              (sourcing_auto: true dans le POST). Sinon le besoin est créé sans
              rien lancer, et la recherche reste lançable depuis le besoin. */}
          <div>
            <label style={lbl}>Sourcing automatique</label>
            <label style={{ display: 'flex', alignItems: 'flex-start', gap: '9px', fontSize: '12.5px', lineHeight: 1.5, color: 'var(--text-2)', cursor: 'pointer' }}>
              <input type="checkbox" checked={formData.sourcing_auto} onChange={e => setFormData({ ...formData, sourcing_auto: e.target.checked })} style={{ marginTop: '3px' }} />
              <span>Lancer la recherche automatique dès la création — top du vivier interne, et LinkedIn si le module est actif. Laissez décoché pour créer le besoin sans rien lancer.</span>
            </label>
          </div>
          {linkedinCreation && (
            <div>
              <label style={lbl}>LinkedIn</label>
              <label style={{ display: 'flex', alignItems: 'flex-start', gap: '9px', fontSize: '12.5px', lineHeight: 1.5, color: 'var(--text-2)', cursor: 'pointer' }}>
                <input type="checkbox" checked={formData.publier_linkedin} onChange={e => setFormData({ ...formData, publier_linkedin: e.target.checked })} style={{ marginTop: '3px' }} />
                <span>Publier l'offre sur LinkedIn dès la création. La fiche de poste doit faire quelques phrases.</span>
              </label>
              {formData.publier_linkedin && !sansRegistreCriteres && (
                <div className="lk-creation__criteres">
                  <h3 className="ann-sous-titre">Critères éliminatoires</h3>
                  <CriteresEditeur valeur={critLinkedin} onChange={setCritLinkedin} registre={registreCriteres} lieuDefaut={formData.localisation} />
                </div>
              )}
            </div>
          )}
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '9px', paddingTop: '6px', borderTop: '1px solid var(--hair)' }}>
            <button type="button" onClick={onClose} disabled={loading} className="bd-mini" style={{ padding: '9px 16px', fontSize: '12.5px' }}>Annuler</button>
            <button type="submit" disabled={loading}
              style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '9px 18px', borderRadius: '8px', border: 'none', background: 'var(--accent)', color: 'var(--accent-fg)', fontFamily: 'inherit', fontSize: '13px', fontWeight: 700, cursor: loading ? 'default' : 'pointer', opacity: loading ? 0.6 : 1 }}>
              <BI icon={loading ? 'arrow-repeat' : 'plus-lg'} style={loading ? { animation: 'bdSpin .8s linear infinite' } : undefined} />
              {loading ? 'Création…' : 'Créer le besoin'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

// ===== DETAIL BESOIN =====
// ── Panneaux flottants (Market Ready + Appels planifiés) ──────────────────
// LE JETON SE LIT AU MOMENT DE L'APPEL, JAMAIS EN PROP (27.09).
//
// Vécu : « à chaque fois je suis déconnecté ». Ce panneau relit le serveur
// toutes les trente secondes avec un en-tête construit UNE FOIS, à partir du
// jeton reçu en prop au premier rendu. Depuis la session glissante (22.09), le
// serveur REMPLACE le jeton passé la moitié de sa vie — l'ancien reste valable
// jusqu'à sa propre échéance, puis meurt. Un onglet laissé ouvert sur un
// besoin continuait donc d'interroger avec le jeton de la veille : à son
// échéance, « session expirée » — alors que la session, elle, avait été
// renouvelée et que le jeton frais était dans le stockage. Éjection chaque
// matin, pour tous ceux qui laissent un onglet ouvert.
const FloatingPanels = ({ candidats, besoinId, BASE, onMrSync }) => {
  // REPLIÉ PAR DÉFAUT (24.09 : « réduis par défaut les listes Ready, elles
  // prennent beaucoup d'espace et allongent la page »). L'en-tête garde le
  // compte des dossiers prêts : l'information tient sur une ligne, le détail
  // s'ouvre au clic.
  const [mrOpen, setMrOpen] = useState(false);
  // Par défaut, seuls les dossiers qui demandent un geste.
  const [mrFiltre, setMrFiltre] = useState('a_faire');
  const [callsOpen, setCallsOpen] = useState(true);
  const [scheduledCalls, setScheduledCalls] = useState([]);
  const [agentCalls, setAgentCalls] = useState([]);   // appels IA réellement lancés
  // Track all checks in FloatingPanels so counter updates in real time
  const [checksMap, setChecksMap] = useState({});

  // Re-sync checksMap when candidats props change (reload)
  useEffect(() => {
    const map = {};
    candidats.forEach(c => {
      map[c.id] = {
        mr_nda: c.mr_nda || false,
        mr_diplomes: c.mr_diplomes || false,
        mr_docs_admin: c.mr_docs_admin || false,
        mr_cv_tat: c.mr_cv_tat || false,
        mr_test_tech: c.mr_test_tech || false,
      };
    });
    setChecksMap(map);
  }, [candidats]);
  const onCheckChange = (candidatId, key, val) => {
    setChecksMap(prev => ({ ...prev, [candidatId]: { ...prev[candidatId], [key]: val } }));
    // Propage au parent : la ligne candidat lit candidat[key] pour son compteur x/5 et
    // le déverrouillage « Marquer prêt ». Sans ça, cocher ici laissait la ligne à 3/5 verrouillée.
    onMrSync?.(candidatId, key, val);
  };

  // DEUX SOURCES, un seul panneau. La file `scheduled_calls` ne raconte que
  // l'attente : dès que le cron déclenche l'appel, la ligne passe à « done »
  // et disparaît — et un appel lancé à la main depuis la fiche candidat n'y
  // entre jamais. Le suivi de ce qui se passe VRAIMENT au téléphone vient de
  // /calls/besoin. Sans lui, le panneau affichait « Aucun appel planifié ou
  // en cours » pendant que l'agent appelait.
  useEffect(() => {
    const load = () => {
      // Relu à CHAQUE passage : c'est le jeton du moment, pas celui du rendu.
      const auth = { headers: { 'Authorization': `Bearer ${APIService.getToken()}` } };
      fetch(`${BASE}/schedule/besoin/${besoinId}`, auth)
        .then(r => r.json()).then(d => { if (d.success) setScheduledCalls(d.data); }).catch(() => {});
      // Route absente (ancien serveur) : le panneau garde ses appels
      // planifiés et n'annonce rien de faux.
      fetch(`${BASE}/calls/besoin/${besoinId}`, auth)
        .then(r => r.ok ? r.json() : { success: false })
        .then(d => { if (d.success) setAgentCalls(d.data || []); }).catch(() => {});
    };
    load();
    const interval = setInterval(load, 30000);
    return () => clearInterval(interval);
  }, [besoinId]);

  const cancelCall = async (id) => {
    await fetch(`${BASE}/schedule/${id}/cancel`, { method: 'PUT', headers: { 'Authorization': `Bearer ${APIService.getToken()}` } });
    setScheduledCalls(prev => prev.map(c => c.id === id ? {...c, status: 'cancelled'} : c));
  };

  const statusCfg = {
    pending:   { style: { color: '#d97706', background: 'rgba(217,119,6,0.12)' },     icon: 'clock-fill',        label: 'Planifié' },
    running:   { style: { color: '#2563eb', background: 'rgba(37,99,235,0.12)' },      icon: 'arrow-repeat',      label: 'En cours' },
    done:      { style: { color: '#16a34a', background: 'rgba(22,163,74,0.12)' },      icon: 'check-circle-fill', label: 'Effectué' },
    failed:    { style: { color: '#dc2626', background: 'rgba(220,38,38,0.12)' },      icon: 'x-circle-fill',     label: 'Échoué' },
    cancelled: { style: { color: 'var(--text-faint)', background: 'var(--chip-bg)' },  icon: 'slash-circle',      label: 'Annulé' },
  };

  // Statuts du côté APPEL (agent_calls) — ce que fait le téléphone, pas ce
  // que fait la file d'attente. Les COULEURS sont celles déjà posées
  // au-dessus : un appel en cours se lit comme un « en cours », un entretien
  // terminé comme un « effectué » — aucune nouvelle teinte pour un état qui
  // existe déjà.
  const statutAppelCfg = {
    en_cours:         { style: statusCfg.running.style,   icon: 'arrow-repeat',       label: 'Appel en cours' },
    termine:          { style: statusCfg.done.style,      icon: 'check-circle-fill',  label: 'Entretien terminé' },
    evalue:           { style: statusCfg.done.style,      icon: 'check-circle-fill',  label: 'Rapport prêt' },
    rapport_manquant: { style: statusCfg.pending.style,   icon: 'exclamation-circle', label: 'Rapport non produit' },
    sans_reponse:     { style: statusCfg.pending.style,   icon: 'telephone-x',        label: 'Sans réponse' },
    issue_inconnue:   { style: statusCfg.cancelled.style, icon: 'question-circle',    label: 'Issue non reçue' },
  };

  // L'ÉTAT d'un appel, pas son statut brut. Vécu : trois appels du 02.09
  // affichés « Appel en cours » six jours plus tard — la ligne était restée à
  // `initiated` parce que l'issue n'était jamais revenue. Le serveur calcule
  // désormais `etat` ; tant qu'il ne le donne pas (transition), on applique
  // ici la MÊME règle : un appel lancé il y a plus d'une heure n'est plus en
  // cours, et un statut inconnu n'est JAMAIS « en cours ».
  const EN_COURS_MAX_MS = 60 * 60 * 1000;
  const etatAppel = (c) => {
    if (c.etat) return c.etat;
    const depuis = new Date(c.updated_at || c.created_at || 0).getTime();
    switch (String(c.statut || '').toLowerCase()) {
      case 'initiated': return (Date.now() - depuis) > EN_COURS_MAX_MS ? 'issue_inconnue' : 'en_cours';
      case 'completed': return 'termine';
      case 'evaluated': return 'evalue';
      case 'evaluation_echouee': return 'rapport_manquant';
      case 'sans_reponse': return 'sans_reponse';
      default: return 'termine';
    }
  };

  const pendingCalls = scheduledCalls.filter(c => c.status === 'pending').length;
  const enCours = agentCalls.filter(c => etatAppel(c) === 'en_cours').length;
  // Un appel déclenché depuis la file a son pendant dans agent_calls : on
  // garde la ligne qui dit l'état RÉEL, jamais les deux.
  const idsLances = new Set(agentCalls.map(c => c.elevenlabs_call_id).filter(Boolean));
  const attente = scheduledCalls
    .filter(c => ['pending', 'running', 'failed'].includes(c.status))
    .filter(c => !(c.call_id && idsLances.has(c.call_id)))
    .map(c => ({ cle: `s${c.id}`, nom: c.candidat_nom, quand: c.scheduled_at, tel: c.phone_lisible || c.phone || null, telBrut: c.phone || null,
      cfg: statusCfg[c.status] || statusCfg.pending, annulable: c.status === 'pending' ? c.id : null }));
  // Les appels lancés dans les 24 h : au-delà, c'est de l'archive — elle vit
  // sur la fiche du candidat, pas dans un panneau de suivi.
  const recent = Date.now() - 24 * 3600 * 1000;
  const lances = agentCalls
    .filter(c => etatAppel(c) === 'en_cours' || new Date(c.updated_at || c.created_at).getTime() > recent)
    .map(c => ({ cle: `a${c.id}`, nom: c.candidat_nom, quand: c.created_at, tel: c.phone_lisible || c.phone || null, telBrut: c.phone || null,
      cfg: statutAppelCfg[etatAppel(c)] || statutAppelCfg.termine, annulable: null }));
  const activeCalls = [...lances, ...attente];

  return (
    <div className="bd-float">

      {/* Market Ready */}
      {candidats.length > 0 && (
        <div className="bd-panel">
          <button onClick={() => setMrOpen(v => !v)} className="bd-panel-head" aria-expanded={mrOpen}
            title={mrOpen ? 'Replier la liste' : 'Voir les dossiers à compléter'}>
            <span className="bd-panel-title">
              <BI icon="patch-check" /> Market Ready
              <span className="bd-panel-count">
                {candidats.filter(c => mrEtat({ ...c, ...(checksMap[c.id] || {}) }).ready).length}/{candidats.length}
              </span>
            </span>
            <BI icon={mrOpen ? 'chevron-up' : 'chevron-down'} className="text-sm" />
          </button>
          {mrOpen && (
            <div className="bd-panel-body">
              {/* VINGT ET UN CANDIDATS × SEPT CASES DÉPLIÉES : la page n'en
                  finissait plus (vécu 23.09). Le panneau répond à « quels
                  dossiers sont prêts ? » — la LISTE est la réponse, les cases
                  sont le détail. Une ligne par candidat, le détail au clic.
                  Et par défaut on ne montre que ce qui demande un geste : un
                  dossier complet n'a rien à dire ici. */}
              <div className="bd-mr-filtre">
                {[['a_faire', 'À compléter'], ['prets', 'Prêts'], ['tout', 'Tous']].map(([v, lib]) => (
                  <button key={v} type="button" className={`bd-mr-f${mrFiltre === v ? ' on' : ''}`}
                    onClick={() => setMrFiltre(v)}>{lib}</button>
                ))}
              </div>
              {(() => {
                const vus = candidats.filter(c => {
                  const e = mrEtat({ ...c, ...(checksMap[c.id] || {}) });
                  return mrFiltre === 'tout' || (mrFiltre === 'prets' ? e.ready : !e.ready);
                });
                if (!vus.length) return (
                  <p className="bd-empty-mini">
                    {mrFiltre === 'prets' ? 'Aucun dossier complet pour l\'instant.'
                      : mrFiltre === 'a_faire' ? 'Tous les dossiers sont complets.'
                      : 'Aucun candidat sur ce besoin.'}
                  </p>
                );
                return vus.map(c => (
                  <MarketReadyRow key={c.id} candidat={c} BASE={BASE} onCheckChange={onCheckChange} />
                ));
              })()}
            </div>
          )}
        </div>
      )}

      {/* Appels planifiés */}
      <div className="bd-panel">
        <button onClick={() => setCallsOpen(v => !v)} className="bd-panel-head">
          <span className="bd-panel-title">
            <BI icon="telephone" /> Appels IA
            {(pendingCalls + enCours) > 0 && (
              <span className="bd-panel-count">{pendingCalls + enCours}</span>
            )}
          </span>
          <BI icon={callsOpen ? 'chevron-up' : 'chevron-down'} className="text-sm" />
        </button>
        {callsOpen && (
          <div className="bd-panel-body">
            {activeCalls.length === 0 ? (
              <p className="bd-empty-mini">Aucun appel planifié ou en cours</p>
            ) : activeCalls.map(call => {
              const date = new Date(call.quand);
              return (
                <div key={call.cle} className="bd-call-row">
                  <div className="flex items-center justify-between gap-2">
                    <p className="bd-call-name truncate">{call.nom}</p>
                    <span className="bd-status" style={call.cfg.style}>
                      <BI icon={call.cfg.icon} /> {call.cfg.label}
                    </span>
                  </div>
                  <div className="flex items-center justify-between mt-1">
                    <div className="bd-call-metas">
                      <p className="bd-call-meta">
                        <BI icon="clock" />
                        {date.toLocaleDateString('fr-FR')} {date.toLocaleTimeString('fr-FR', {hour:'2-digit', minute:'2-digit'})}
                      </p>
                      {/* LE NUMÉRO COMPOSÉ (13.10) : lisible quand le serveur
                          l'écrit (phone_lisible), tel quel sinon — et cliquable
                          pour qui rappelle depuis son poste. */}
                      {call.tel && (
                        <p className="bd-call-meta">
                          <BI icon="telephone" />
                          <a href={`tel:${String(call.tel.startsWith('+') ? call.tel : (call.telBrut || call.tel)).replace(/\s+/g, '')}`} className="bd-call-tel" title="Appeler ce numéro">{call.tel}</a>
                        </p>
                      )}
                    </div>
                    {call.annulable != null && (
                      <button onClick={() => cancelCall(call.annulable)} className="bd-cancel-link">
                        Annuler
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

const MarketReadyRow = ({ candidat, BASE, onCheckChange }) => {
  const [checks, setChecks] = useState(
    Object.fromEntries(MARKET_READY_ITEMS.map(i => [i.cle, candidat[i.cle] || false])));
  // Les dérogations sont tenues ici pendant la session : le serveur les a
  // servies avec la ligne, et il les renvoie à chaque pose.
  const [derogees, setDerogees] = useState(() => mrSansObjet(candidat));
  // LE DOSSIER SERVI (24.09) — la même évaluation que le process de
  // qualification : une case cochée ici l'est là-bas, et inversement. Chaque
  // geste rend l'état recalculé par le serveur ; on l'affiche tel quel, sans
  // recompter de notre côté.
  const [servi, setServi] = useState(candidat.market_ready || null);
  useEffect(() => { if (candidat.market_ready) setServi(candidat.market_ready); }, [candidat.market_ready]);
  const [ouvert, setOuvert] = useState(false);    // le détail est REPLIÉ par défaut
  const [touche, setTouche] = useState(false);   // repli local : ancien serveur seulement
  const [demande, setDemande] = useState(null);   // { item, label } en cours de motif
  const [motif, setMotif] = useState('');
  const [erreur, setErreur] = useState(null);
  const [enCours, setEnCours] = useState(null);   // la case en cours d'écriture
  const cid = candidat.canonical_candidate_id || candidat.id;
  // Une FONCTION, pas une constante : la ligne vit longtemps, le jeton change.
  const auth = () => ({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${APIService.getToken()}` });

  // Ce que rend le serveur après un geste : le dossier, recalculé. Remonté au
  // parent pour que la carte du candidat et l'en-tête comptent la même chose.
  const recevoir = (mr) => {
    if (!mr) return;
    setServi(mr); setTouche(false);
    setDerogees(Object.fromEntries((mr.sans_objet || []).map(x => [x.key, { motif: x.motif, le: x.le, par: x.par }])));
    if (onCheckChange) onCheckChange(candidat.id, 'market_ready', mr);
  };

  // UN GESTE SUR UNE CASE, par la porte du dossier du couple — celle que le
  // process de qualification emprunte aussi. Rend `null` quand la route
  // n'existe pas (ancien serveur : réponse sans JSON) ; un 404 qui PARLE
  // (« positionnement introuvable ») est une vraie réponse.
  const geste = async (item, corps) => {
    const r = await fetch(`${BASE}/candidates/${cid}/dossier/${item}?besoin=${candidat.besoin_id}`,
      { method: 'PUT', headers: auth(), body: JSON.stringify(corps) });
    const j = await r.json().catch(() => null);
    if (!j && (r.status === 404 || r.status === 501)) return null;
    if (!r.ok || j?.success === false) return { error: j?.error || "Impossible d'enregistrer." };
    return j;
  };

  // Repli : l'ancienne écriture de la ligne, optimiste.
  const toggleLocal = async (key, newVal) => {
    setTouche(true);
    setChecks(prev => ({ ...prev, [key]: newVal }));
    if (onCheckChange) onCheckChange(candidat.id, key, newVal);
    try {
      await fetch(`${BASE}/candidats/${candidat.id}`, { method: 'PUT', headers: auth(), body: JSON.stringify({ [key]: newVal }) });
    } catch (e) {
      setChecks(prev => ({ ...prev, [key]: !newVal }));
      if (onCheckChange) onCheckChange(candidat.id, key, !newVal);
    }
  };

  const cocher = async (item, cle, coche) => {
    setErreur(null); setEnCours(item);
    try {
      const out = await geste(item, { coche });
      if (!out) {
        if (cle) await toggleLocal(cle, coche);
        else setErreur('Cette case se remplit depuis le dossier du besoin, elle ne se coche pas.');
        return;
      }
      if (out.error) { setErreur(out.error); return; }
      recevoir(out.market_ready);
    } catch (e) { setErreur("Impossible d'enregistrer."); }
    finally { setEnCours(null); }
  };

  // « JE L'AI RELU » — le CV qui part chez le client doit être celui qu'on a
  // lu. Le serveur refuse s'il n'y a rien à relire, et le dit.
  const relire = async (item) => {
    setErreur(null); setEnCours(item);
    try {
      const out = await geste(item, { relu: true });
      if (!out) { setErreur('Cette action arrive côté serveur.'); return; }
      if (out.error) { setErreur(out.error); return; }
      recevoir(out.market_ready);
    } catch (e) { setErreur("Impossible d'enregistrer."); }
    finally { setEnCours(null); }
  };

  // SANS OBJET — la case n'a pas lieu d'être sur CE dossier. Le motif est
  // exigé par le serveur : un refus sans raison se redemande la semaine
  // d'après. La route peut ne pas être déployée (404/501) : on le dit, on
  // n'écrit rien.
  const poser = async (item, sansObjet, raison) => {
    setErreur(null);
    try {
      const r = await fetch(`${BASE}/candidates/${cid}/market-ready/sans-objet?besoin=${candidat.besoin_id}`, {
        method: 'PUT', headers: auth(),
        body: JSON.stringify({ item, sans_objet: sansObjet, motif: raison }),
      });
      if (r.status === 404 || r.status === 501) { setErreur("Cette action arrive côté serveur."); return; }
      const j = await r.json().catch(() => ({}));
      if (!r.ok) { setErreur(j.error || "Impossible d'enregistrer."); return; }
      recevoir(j.market_ready);
      setDemande(null); setMotif('');
    } catch (e) { setErreur("Impossible d'enregistrer."); }
  };

  // Le compte servi fait foi ; le recompte local ne reprend la main que si
  // l'ancien serveur n'a rien rendu.
  const etat = touche
    ? mrEtat({ ...candidat, mr_sans_objet: derogees, market_ready: null }, checks)
    : mrEtat({ ...candidat, mr_sans_objet: derogees, market_ready: servi });

  // LES CASES À AFFICHER : celles que le serveur sert (nom, état, d'où ça
  // vient). Le registre local n'est qu'un repli.
  const cases = !touche && servi?.items?.length
    ? servi.items.map(i => ({ ...i, cle: (MARKET_READY_ITEMS.find(m => m.item === i.key) || {}).cle || null }))
    : MARKET_READY_ITEMS.map(m => ({ key: m.item, label: m.label, cle: m.cle, derogeable: !!m.derogeable,
        manuel: true, done: !!checks[m.cle], source: checks[m.cle] ? 'manuel' : null,
        sans_objet: m.derogeable ? derogees[m.item] || null : null }));

  return (
    <div className="bd-mr-row">
      <button type="button" className="bd-mr-head bd-mr-head--btn" onClick={() => setOuvert(o => !o)}
        aria-expanded={ouvert} title={ouvert ? 'Replier le détail' : 'Voir ce qui manque'}>
        <p className="bd-mr-name truncate">{candidat.prenom} {candidat.nom}</p>
        <span className="bd-mr-jauge" aria-hidden="true">
          <span style={{ width: `${etat.total ? Math.round((etat.done / etat.total) * 100) : 0}%` }} />
        </span>
        {etat.ready
          ? <span className="bd-ok-chip"><BI icon="check-circle-fill" /> Ready</span>
          : <span style={{ fontSize: '10px', color: 'var(--text-faint)', fontFamily: "'IBM Plex Mono',monospace" }}>{etat.done}/{etat.total}</span>
        }
        <BI icon={ouvert ? 'chevron-up' : 'chevron-down'} className="bd-mr-chev" />
      </button>
      <div className="flex flex-col gap-1" hidden={!ouvert}>
        {cases.map(item => {
          if (item.sans_objet) return (
            <div key={item.key} className="bd-mr-check bd-mr-check--hs"
              title={item.sans_objet.motif ? `Sans objet — ${item.sans_objet.motif}` : 'Sans objet sur ce dossier'}>
              <BI icon="dash-circle" />
              <span className="truncate">{item.label}</span>
              <button type="button" className="bd-mr-so" onClick={() => poser(item.key, false, null)}>
                Rétablir
              </button>
            </div>
          );
          // À RELIRE : la pièce existe, elle ne compte qu'une fois relue —
          // c'est elle qui part chez le client. Ni case vide (on la
          // redéposerait), ni case barrée (elle ne compte pas encore).
          if (item.a_relire) return (
            <div key={item.key} className="bd-mr-line">
              <span className="bd-mr-check bd-mr-check--relire"
                title={item.relu_perime ? 'Le document a changé depuis la dernière relecture' : 'Présent, pas encore relu'}>
                <BI icon="eye" />
                <span className="truncate">{item.label}<small>{item.relu_perime ? 'modifié depuis la relecture' : 'à relire'}</small></span>
              </span>
              <button type="button" className="bd-mr-relire" disabled={enCours === item.key}
                onClick={() => relire(item.key)}>
                {enCours === item.key ? <BI icon="arrow-repeat" style={{ animation: 'bdSpin .8s linear infinite' }} /> : null} Je l'ai relu
              </button>
            </div>
          );
          // CE QUE LE SERVEUR A CONSTATÉ ne se recoche pas à la main : un
          // document déposé, un test passé, un compte rendu d'entretien
          // écrit. La case est FAITE, et elle dit d'où elle vient — cliquer
          // dessus n'aurait aucun sens, et laisser croire qu'elle est vide
          // faisait refaire un geste déjà fait (vécu 23.09 : « quand on
          // saisit un CR d'entretien on doit avoir le CR coché »).
          const constate = item.done && item.source && item.source !== 'manuel';
          if (constate) return (
            <div key={item.key} className="bd-mr-check done bd-mr-check--auto"
              title={`Constaté par l'ERP (${item.source_libelle || SOURCE_MR[item.source] || 'document du dossier'}) — rien à cocher`}>
              <BI icon="check-circle-fill" />
              <span className="truncate">{item.label}</span>
            </div>
          );
          // Une case qui ne se coche pas (la matrice se génère) : on la montre,
          // sans case à cocher qui ne mènerait nulle part.
          if (item.manuel === false) return (
            <div key={item.key} className="bd-mr-check bd-mr-check--fixe"
              title="Se génère depuis le dossier du besoin">
              <BI icon="circle" />
              <span className="truncate">{item.label}</span>
            </div>
          );
          const coche = item.done === true;
          return (
            <div key={item.key} className="bd-mr-line">
              <label className={`bd-mr-check ${coche ? 'done' : ''}`}
                title={coche && item.coche_a_la_main ? 'Coché à la main' : undefined}>
                <input type="checkbox" checked={coche} disabled={enCours === item.key}
                  onChange={() => cocher(item.key, item.cle, !coche)} />
                <span className="truncate">{item.label}</span>
              </label>
              {item.derogeable && !coche && (
                <button type="button" className="bd-mr-so"
                  title="Cette case n'a pas lieu d'être sur ce dossier — elle sortira du compte"
                  onClick={() => { setDemande({ item: item.key, label: item.label }); setMotif(''); setErreur(null); }}>
                  Sans objet
                </button>
              )}
            </div>
          );
        })}
      </div>

      {/* Le motif : ce qui distingue « il n'y a pas de test sur ce poste » de
          « on a sauté le test ». Le serveur le refuse vide — on le demande
          ici plutôt que de laisser partir un refus qui reviendra. */}
      {demande && (
        <div className="bd-mr-motif">
          <p className="bd-mr-motif-t">Pourquoi « {demande.label} » n'a pas lieu d'être ici ?</p>
          <input className="erp-field" value={motif} autoFocus
            placeholder="Poste en régie, le client mène l'entretien…"
            onChange={e => setMotif(e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter' && motif.trim()) poser(demande.item, true, motif.trim());
                              if (e.key === 'Escape') { setDemande(null); setErreur(null); } }} />
          <div className="bd-mr-motif-a">
            <button type="button" className="erp-btn erp-btn--secondary"
              onClick={() => { setDemande(null); setErreur(null); }}>Annuler</button>
            <button type="button" className="erp-btn erp-btn--primary" disabled={!motif.trim()}
              onClick={() => poser(demande.item, true, motif.trim())}>Déclarer sans objet</button>
          </div>
        </div>
      )}
      {erreur && <p className="bd-mr-err">{erreur}</p>}
    </div>
  );
};

// Modale d'ajout de candidat à un besoin : import CV ou sélection dans la base
function AddCandidatModal({ besoin, dejaSur, onClose, onUploadFiles, onAttach, showNotification }) {
  const [tab, setTab] = useState('base'); // 'base' | 'cv'
  const [drop, setDrop] = useState(false); // survol de la zone de dépôt
  const [base, setBase] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState('');
  const [busy, setBusy] = useState(false);

  // Recherche côté SERVEUR (?search=) — sinon on ne verrait que les fiches les plus récentes
  // (dont les fiches-poubelles issues de noms de fichiers), pas la vraie fiche recherchée.
  useEffect(() => {
    let cancelled = false;
    const t = setTimeout(() => {
      setLoading(true);
      const params = new URLSearchParams({ limit: '50' });
      if (q.trim()) params.set('search', q.trim());
      fetch(`${BASE}/candidats/vue?${params.toString()}`, { headers: { Authorization: `Bearer ${APIService.getToken()}` } })
        .then(r => r.json()).then(j => { if (!cancelled) setBase(j.data || []); }).catch(() => {}).finally(() => { if (!cancelled) setLoading(false); });
    }, q.trim() ? 300 : 0);
    return () => { cancelled = true; clearTimeout(t); };
  }, [q]);

  const fname = (c) => [c.prenom, c.nom].filter(Boolean).join(' ');
  const list = base; // déjà filtré côté serveur
  const pick = async (c) => { setBusy(true); await onAttach(c); setBusy(false); onClose(); };
  // Une fiche déjà sur le besoin reste visible (on la cherche peut-être pour
  // vérifier) mais ne s'ajoute pas une seconde fois.
  const estDeja = (c) => !!dejaSur?.has(Number(c.candidate_id ?? c.canonical_candidate_id ?? c.id));

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(4,6,11,0.55)', backdropFilter: 'blur(2px)', zIndex: 500, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }} onClick={onClose}>
      <div className="bd-card" style={{ width: '100%', maxWidth: '560px', maxHeight: '82vh', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
        <div className="bd-sect-head" style={{ borderRadius: '12px 12px 0 0', flexShrink: 0 }}>
          <span className="bd-sect-title"><BI icon="person-plus" /> Ajouter un candidat</span>
          <button onClick={onClose} className="bd-icon-btn"><BI icon="x-lg" /></button>
        </div>
        <div className="bd-tabs" style={{ padding: '0 16px', marginBottom: 0, flexShrink: 0 }}>
          <button className={`bd-tab ${tab === 'base' ? 'active' : ''}`} onClick={() => setTab('base')}><BI icon="people" /> Base de candidats</button>
          <button className={`bd-tab ${tab === 'cv' ? 'active' : ''}`} onClick={() => setTab('cv')}><BI icon="cloud-upload" /> Importer un CV</button>
        </div>
        {tab === 'base' ? (
          <div style={{ display: 'flex', flexDirection: 'column', minHeight: 0, flex: 1 }}>
            <div style={{ padding: '14px 16px 10px', flexShrink: 0 }}>
              <input className="bd-input" autoFocus value={q} onChange={e => setQ(e.target.value)} placeholder="Rechercher un nom, titre, ville…" />
            </div>
            <div style={{ overflowY: 'auto', flex: 1, padding: '0 16px 16px' }}>
              {loading ? (
                <div style={{ textAlign: 'center', padding: '24px', color: 'var(--text-faint)', fontSize: '13px' }}>Chargement…</div>
              ) : list.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '24px', color: 'var(--text-faint)', fontSize: '13px' }}>{q.trim() ? 'Aucune fiche trouvée — importez un CV pour créer le candidat.' : 'Aucun candidat dans la base'}</div>
              ) : list.map(c => { const deja = estDeja(c); return (
                <button key={c.id} disabled={busy || deja} onClick={() => pick(c)}
                  title={deja ? 'Ce candidat est déjà sur le besoin' : undefined}
                  style={{ width: '100%', textAlign: 'left', display: 'flex', alignItems: 'center', gap: '11px', padding: '10px 12px', border: '1px solid var(--border)', borderRadius: '9px', background: 'var(--surface)', cursor: deja ? 'default' : busy ? 'wait' : 'pointer', marginBottom: '7px', fontFamily: 'inherit' }}>
                  <span style={{ width: '34px', height: '34px', borderRadius: '8px', background: 'var(--accent-soft-bg)', color: 'var(--text-strong)', display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 'none', fontSize: '12px', fontWeight: 600, fontFamily: "'IBM Plex Mono',monospace" }}>{((c.prenom?.[0] || '') + (c.nom?.[0] || '')).toUpperCase() || '?'}</span>
                  <span style={{ flex: 1, minWidth: 0 }}>
                    <span style={{ display: 'block', fontSize: '13.5px', fontWeight: 600, color: 'var(--text-strong)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{fname(c) || '—'}</span>
                    <span style={{ display: 'block', fontSize: '12px', color: 'var(--text-2)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{c.titre || '—'}{c.ville ? ' · ' + c.ville : ''}</span>
                  </span>
                  {deja
                    ? <span style={{ flex: 'none', fontSize: '11.5px', color: 'var(--text-3)' }}><BI icon="check2" /> Déjà sur le besoin</span>
                    : <BI icon="plus-lg" />}
                </button>
              ); })}
            </div>
          </div>
        ) : (
          <div style={{ padding: '18px 16px' }}>
            {/* Le CV se dépose OU se choisit : les deux mènent au même import
                (la zone se contentait d'un clic, un fichier lâché dessus était
                ouvert par le navigateur). */}
            <label className={`bd-drop${drop ? ' is-drop' : ''}`} style={{ display: 'block', cursor: 'pointer' }}
              onDragOver={e => { e.preventDefault(); setDrop(true); }}
              onDragLeave={e => { e.preventDefault(); setDrop(false); }}
              onDrop={e => { e.preventDefault(); setDrop(false); const f = e.dataTransfer?.files; if (f?.length) { onUploadFiles(f); onClose(); } }}>
              <BI icon="cloud-upload" className="bd-drop-ico" />
              <div style={{ fontSize: '13.5px', fontWeight: 500, color: 'var(--text-2)', marginBottom: '3px' }}>Glissez-déposez un ou plusieurs CV</div>
              <div style={{ fontSize: '12px', color: 'var(--text-faint)' }}>ou cliquez pour les choisir · PDF, DOC, DOCX — analyse automatique</div>
              <input type="file" multiple accept=".pdf,.doc,.docx" className="hidden" onChange={(e) => { onUploadFiles(e.target.files); onClose(); }} />
            </label>
          </div>
        )}
      </div>
    </div>
  );
}

// Détection d'un doublon à l'import CV : « une fiche existe déjà, voulez-vous fusionner ? »
function DuplicateCandidateModal({ prompt, busy, onClose, onMerge, onCreate }) {
  const { cvInfo, matches } = prompt;
  const importe = `${cvInfo.prenom || ''} ${cvInfo.nom || ''}`.trim() || 'ce CV';
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(4,6,11,0.55)', backdropFilter: 'blur(2px)', zIndex: 520, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }} onClick={busy ? undefined : onClose}>
      <div className="bd-card" style={{ width: '100%', maxWidth: '540px', maxHeight: '82vh', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
        <div className="bd-sect-head" style={{ borderRadius: '12px 12px 0 0', flexShrink: 0 }}>
          <span className="bd-sect-title"><BI icon="exclamation-triangle" /> Une fiche existe peut-être déjà</span>
          <button onClick={onClose} className="bd-icon-btn" disabled={busy}><BI icon="x-lg" /></button>
        </div>
        <div style={{ padding: '16px', overflowY: 'auto', flex: 1 }}>
          <div style={{ fontSize: '13px', color: 'var(--text-2)', lineHeight: 1.55, marginBottom: '14px' }}>
            Le CV importé (<strong style={{ color: 'var(--text-strong)' }}>{importe}</strong>) correspond à {matches.length > 1 ? 'des fiches existantes' : 'une fiche existante'}. Réutilisez la fiche pour éviter un doublon, ou créez-en une nouvelle si ce n'est pas la même personne.
          </div>
          {matches.map((c, i) => (
            <div key={c.candidate_id ?? c.id ?? i} style={{ display: 'flex', alignItems: 'center', gap: '11px', padding: '10px 12px', border: '1px solid var(--border)', borderRadius: '9px', background: 'var(--surface)', marginBottom: '8px' }}>
              <span style={{ width: '34px', height: '34px', borderRadius: '8px', background: 'var(--accent-soft-bg)', color: 'var(--text-strong)', display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 'none', fontSize: '12px', fontWeight: 600, fontFamily: "'IBM Plex Mono',monospace" }}>{((c.prenom?.[0] || '') + (c.nom?.[0] || '')).toUpperCase() || '?'}</span>
              <span style={{ flex: 1, minWidth: 0 }}>
                <span style={{ display: 'block', fontSize: '13.5px', fontWeight: 600, color: 'var(--text-strong)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{[c.prenom, c.nom].filter(Boolean).join(' ') || '—'}</span>
                <span style={{ display: 'block', fontSize: '12px', color: 'var(--text-2)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{c.titre || '—'}{c.ville ? ' · ' + c.ville : ''}</span>
              </span>
              <button className="bd-mini bd-mini-accent" disabled={busy} onClick={() => onMerge(c)} style={{ flex: 'none' }}><BI icon="arrow-left-right" /> Fusionner</button>
            </div>
          ))}
        </div>
        <div style={{ padding: '12px 16px', borderTop: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', gap: '10px', flexShrink: 0 }}>
          <button className="bd-mini" disabled={busy} onClick={onClose}>Annuler</button>
          <button className="bd-mini" disabled={busy} onClick={onCreate}><BI icon="person-plus" /> Créer une nouvelle fiche quand même</button>
        </div>
      </div>
    </div>
  );
}

// Stepper de statut du besoin : 3 étapes cliquables (le vert n'est jamais une action —
// l'étape active est en accent système, le dot porte la couleur du statut).
const STATUT_STEPS = [
  { k: 'encours', l: 'En cours', dot: '#5b9dff' },
  { k: 'pret',    l: 'Prêt',     dot: '#e6a93f' },
  { k: 'envoye',  l: 'Envoyé',   dot: '#56d98c' },
];
const StatutStepper = ({ statut, onChange }) => (
  <span className="bd-status-stepper" role="group" aria-label="Statut du besoin">
    {STATUT_STEPS.map(s => {
      const active = s.k === (statut || 'encours');
      return (
        <button key={s.k} onClick={() => onChange(s.k)} title={`Passer en « ${s.l} »`}
          className={`bd-status-step ${active ? 'active' : ''} bd-status-${s.k}`} aria-pressed={active}>
          {active && <span className="bd-status-dot" style={{ background: s.dot }} />}{s.l}
        </button>
      );
    })}
  </span>
);

const BesoinDetail = ({ besoin, onBack, onUpdate, showNotification, onOpenCandidat, onOpenAo, canCvPrep, theme }) => {
  const [piecesRefreshAll, setPiecesRefreshAll] = React.useState(0);
  const [cvPrepFor, setCvPrepFor] = useState(null); // candidat pour lequel préparer le CV
  const [showScanVivier, setShowScanVivier] = useState(false); // panneau « Scan du vivier »
  // Feature flags org : masquent les fonctionnalités désactivées pour le lancement prod
  const scanVivierOn = useFeature('scan_vivier');
  const testsOn = useFeature('tests_techniques');
  const appelsIaOn = useFeature('appels_ia');
  // App Marketplace : état d'activation ORG, sans bypass admin — app désactivée
  // = bouton « Diffuser », onglet Propositions et carte de contexte cachés pour tous.
  const sourciaOn = useModuleApp('sourcia');
  const [candidats, setCandidats] = useState([]);
  // Avertissement servi quand la liste n'a pas pu être lue en entier.
  const [listePartielle, setListePartielle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [uploadingFiles, setUploadingFiles] = useState(false);
  const [dropCv, setDropCv] = useState(false); // survol de la zone de dépôt des CV
  // CLASSEMENT des candidats (1 = le meilleur) : on glisse une ligne sur une
  // autre pour l'y insérer. L'ordre part au serveur en UNE fois — un
  // classement à moitié écrit ferait croire à une liste rangée.
  const [rangDrag, setRangDrag] = useState(null);     // id de la ligne saisie
  const [rangSurvol, setRangSurvol] = useState(null); // id de la ligne survolée
  const [statut, setStatut] = useState(besoin.statut || 'encours'); // stepper de statut du besoin
  const changeStatutBesoin = async (s) => {
    if (s === statut) return;
    const prev = statut; setStatut(s);
    try { await APIService.updateBesoin(besoin.id, { statut: s }); onUpdate?.(); }
    catch { setStatut(prev); showNotification('Erreur mise à jour du statut', 'error'); }
  };
  const [dupPrompt, setDupPrompt] = useState(null); // { file, cvInfo, matches } : fiche existante détectée à l'import CV
  const [matchScores, setMatchScores] = useState({}); // score matching s9 par candidat (clé id ou nom:…)
  // Diffusion sourceurs (sourcia) : état diffusion + propositions du besoin.
  // enabled: flag coupé → aucun appel réseau (sinon 3 × 403 feature_disabled = 3 toasts).
  const diff = useDiffusion(besoin, { showNotification, onCandidatsChanged: () => loadCandidats(), enabled: sourciaOn });
  // Le catalogue des coupes vient du serveur avec la liste : l'écran ne code
  // aucune distinction. Vide tant que la liste n'est pas chargée — le menu
  // ne s'ouvre alors sur rien plutôt que sur des choix inventés.
  const [distinctions, setDistinctions] = useState([]);
  const [scoringMatch, setScoringMatch] = useState(false);
  const [scoreProg, setScoreProg] = useState(null); // { done, total } — progression réelle du scoring (1 évènement NDJSON par candidat)
  // Popup de pré-lancement : réglages par défaut, ou ajustés pour CE matching.
  const [matchModal, setMatchModal] = useState(false);
  // Diagnostic « local vs IA » : outil d'administration, jamais un second
  // score montré aux recruteurs.
  const [compareModal, setCompareModal] = useState(false);
  const adminScoring = isAoAdmin(APIService.getCurrentUser());
  // Label visible par tous : les scores affichés viennent d'un lancement à
  // poids ajustés, pas des réglages par défaut.
  const [scoresAjustes, setScoresAjustes] = useState(false);
  // QUI EST EN COURS D'ÉVALUATION, EN CE MOMENT (demande 23.09 : « on doit
  // savoir ce qu'il fait le moteur en ce moment »). Le serveur émettait déjà
  // un évènement `progress` par candidat AVANT de l'évaluer — le front le
  // jetait (`if (ev.type !== 'result') continue`). Un compteur « 3/21 » dit
  // combien, jamais QUI : sur un lot qui dure des minutes, on ne sait pas si
  // le moteur avance ou s'il est bloqué sur quelqu'un.
  //
  // C'est un ENSEMBLE, pas un seul : le serveur évalue plusieurs candidats en
  // parallèle. N'en montrer qu'un ferait clignoter un nom au hasard.
  const [scoreEnCours, setScoreEnCours] = useState({});   // id -> nom
  const [scoreTick, setScoreTick] = useState(0); // chrono (s) — garantit un mouvement visible même à 1 candidat
  useEffect(() => {
    if (!scoringMatch) return;
    setScoreTick(0);
    const t0 = Date.now();
    const iv = setInterval(() => setScoreTick(Math.round((Date.now() - t0) / 1000)), 1000);
    return () => clearInterval(iv);
  }, [scoringMatch]);
  const [showJDModal, setShowJDModal] = useState(false);
  const [genJdPdf, setGenJdPdf] = useState(false);
  const downloadJdPdf = async () => {
    setGenJdPdf(true);
    try {
      const r = await fetch(`${BASE}/besoins/${besoin.id}/jd.pdf?download=1`, { headers: { Authorization: `Bearer ${APIService.getToken()}` } });
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const blob = await r.blob(); const url = URL.createObjectURL(blob);
      const a = document.createElement('a'); a.href = url; a.download = `Fiche_de_poste_${(besoin.titre || 'besoin').replace(/\s+/g, '_')}.pdf`; a.click();
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (e) { showNotification('Erreur génération PDF : ' + e.message, 'error'); } finally { setGenJdPdf(false); }
  };
  const [showJDEditor, setShowJDEditor] = useState(false);
  const [jdEditContent, setJdEditContent] = useState(besoin.description || '');
  const [savingJD, setSavingJD] = useState(false);
  const [notesCommercial, setNotesCommercial] = useState(besoin.notes_commercial || '');
  const [candidatsContactes, setCandidatsContactes] = useState(besoin.candidats_contactes || '');
  const [savingNotes, setSavingNotes] = useState(false);
  const [notesFullscreen, setNotesFullscreen] = useState(false);
  const [besoinTab, setBesoinTab] = useState('candidats'); // dossier : onglet actif
  // Suivi des entretiens du besoin : chaque carte ouverte remonte son état.
  // On n'affiche que ce qu'on a réellement lu — jamais un total deviné.
  const [entretiens, setEntretiens] = useState({});
  const onEntretienEtat = useCallback((cid, statut) => {
    setEntretiens(prev => (prev[cid] === statut ? prev : { ...prev, [cid]: statut }));
  }, []);
  const [showAddCandidat, setShowAddCandidat] = useState(false);
  const [expandedCandIdx, setExpandedCandIdx] = useState(null);
  const [flowStages, setFlowStages] = useState([]); // étapes du flow de ce besoin (override sinon modèle général)
  const [allUsers, setAllUsers] = useState([]);
  const [scheduleModal, setScheduleModal] = useState(null); // candidat to schedule
  const [scheduleRefresh, setScheduleRefresh] = useState(0);

  useEffect(() => {
    // Annuaire des @mentions (notes du besoin) : internes uniquement — les
    // comptes ressource n'ont pas accès à ces écrans.
    fetch(`${BASE}/config/users/public`, { headers: { 'Authorization': `Bearer ${APIService.getToken()}` } })
      .then(r => r.json()).then(data => setAllUsers(Array.isArray(data) ? data.filter(isInternal) : [])).catch(() => {});
  }, []);
  const [editingTitle, setEditingTitle] = useState(false);
  const [detailTitre, setDetailTitre] = useState(besoin.titre || '');
  const [detailClient, setDetailClient] = useState(besoin.client || '');
  const [editingClient, setEditingClient] = useState(false);
  const [testSession, setTestSession] = useState(null);
  const [testReport, setTestReport] = useState(null);
  const [testQuestions, setTestQuestions] = useState([]);
  const [sessionsRefreshKey, setSessionsRefreshKey] = useState(0);

  useEffect(() => { loadCandidats(); loadTestQuestions(); }, [besoin.id]);

  // Flow du besoin : override sur le besoin sinon modèle général (Config), repli localStorage
  useEffect(() => {
    (async () => {
      if (Array.isArray(besoin.flow) && besoin.flow.length) { setFlowStages(besoin.flow); return; }
      try {
        const res = await fetch(`${BASE}/config/recruitment-flow`, { headers: { 'Authorization': `Bearer ${APIService.getToken()}` } });
        if (res.ok) { const d = await res.json(); if (d.stages?.length) { setFlowStages(d.stages); return; } }
      } catch {}
      try { const local = JSON.parse(localStorage.getItem('recruitment_flow')); if (local?.length) { setFlowStages(local); return; } } catch {}
      setFlowStages([]);
    })();
  }, [besoin.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const authHeaders = { 'Authorization': `Bearer ${APIService.getToken()}` };

  const loadCandidats = async () => {
    try {
      setLoading(true);
      // GET /candidats/besoin/:id est LA liste des candidats d'un besoin, et la
      // seule : /besoins/:id/candidats n'existe qu'en POST (proposer un
      // candidat) — on l'appelait en lecture pour rien, un aller-retour perdu à
      // chaque ouverture de besoin.
      const pipe = await APIService.getCandidats(besoin.id).catch(() => []);
      const byId = new Map();
      for (const c of (Array.isArray(pipe) ? pipe : [])) {
        const id = c.id ?? c.candidate_id ?? c.candidat_id;
        if (id == null) continue;
        const prev = byId.get(id) || {};
        // `id` = id de LIGNE (pipeline) : uniquement pour les actions de la ligne sur ce
        // besoin (valider, renommer, uploader, supprimer). `canonical_candidate_id` = SEUL
        // identifiant de navigation vers la fiche — SANS repli sur l'id de ligne : les
        // numérotations se chevauchent (211 pipeline ≠ 211 canonique). Null → lien fiche
        // désactivé, jamais de navigation ambiguë.
        const canonical = prev.canonical_candidate_id ?? c.canonical_candidate_id ?? c.candidate_id ?? c.candidat_id ?? null;
        byId.set(id, { ...prev, ...c, id, candidate_id: canonical, canonical_candidate_id: canonical });
      }
      setCandidats([...byId.values()]);
      // La liste n'a pas pu être lue en entier : on le DIT. Une liste vide
      // qui se tait ne ressemble pas à une panne, elle ressemble à un besoin
      // sur lequel personne n'a travaillé.
      setListePartielle(pipe?.lecturePartielle || null);
      setDistinctions(Array.isArray(pipe?.distinctions) ? pipe.distinctions : []);
    }
    catch { showNotification('Erreur chargement candidats', 'error'); } finally { setLoading(false); }
  };

  // Score de matching s9 par candidat — même moteur/cache que Dossiers AO et
  // Matching par lots (POST /besoins/matching, streaming NDJSON) : les paires
  // déjà scorées reviennent du cache, les autres sont évaluées en direct.
  const scoreMatching = async (ponderations = null) => {
    setScoringMatch(true);
    setScoresAjustes(!!ponderations);
    setScoreProg({ done: 0, total: candidats.length });
    try {
      const res = await fetch(`${BASE}/besoins/matching`, {
        method: 'POST', headers: { ...authHeaders, 'Content-Type': 'application/json' },
        // ponderations : poids ajustés pour CE lancement uniquement (popup de
        // pré-lancement) — absents, le serveur applique les défauts de l'org.
        body: JSON.stringify({ besoinIds: [besoin.id], ...(ponderations ? { ponderations } : {}) }),
      });
      if (!res.ok || !res.body) throw new Error(`HTTP ${res.status}`);
      const reader = res.body.getReader();
      const dec = new TextDecoder();
      let buf = '';
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        buf += dec.decode(value, { stream: true });
        const lines = buf.split('\n');
        buf = lines.pop();
        for (const line of lines) {
          if (!line.trim()) continue;
          let ev; try { ev = JSON.parse(line); } catch { continue; }
          // Le moteur COMMENCE ce candidat : on le dit, tout de suite.
          if (ev.type === 'progress') {
            if (ev.candidatId != null) {
              setScoreEnCours(p => ({ ...p, [String(ev.candidatId)]: ev.candidatNom || '' }));
            }
            continue;
          }
          if (ev.type !== 'result') continue;
          // Il a fini : il sort de la liste des « en cours », qu'il ait un
          // score, pas de CV ou une erreur. Sans ça un candidat en échec
          // resterait à tourner indéfiniment.
          if (ev.candidatId != null) {
            setScoreEnCours(p => { const n = { ...p }; delete n[String(ev.candidatId)]; return n; });
          }
          setScoreProg(p => p ? { ...p, done: Math.min(p.done + 1, p.total || p.done + 1) } : p);
          const m = ev.match || {};
          const info = ev.status === 'ok'
            ? { score: m.score ?? null, niveau: m.niveau, motif: m.motif_non_evaluable, perso: m.poids_personnalises === true, niveauFit: m.niveau_fit ?? null, niveauEcart: m.niveau_ecart ?? null, niveauEcartDetail: m.niveau_ecart_detail ?? null,
                statutAo: m.statut_ao ?? null, statutAoLibelle: m.statut_ao_libelle ?? null, enLEtat: m.score_en_l_etat ?? null, potentiel: m.score_potentiel ?? null, aConfirmer: m.a_confirmer || [], confirmations: m.confirmations_ao || null }
            : { score: null, motif: ev.status === 'no_cv' ? 'CV indisponible' : (ev.error || 'Erreur') };
          setMatchScores(prev => {
            const n = { ...prev };
            if (ev.candidatId != null) n[String(ev.candidatId)] = info;
            if (ev.candidatNom) n['nom:' + ev.candidatNom.trim().toLowerCase()] = info;
            return n;
          });
        }
      }
    } catch (e) { showNotification('Erreur scoring : ' + e.message, 'error'); }
    // Quoi qu'il arrive — fin normale, erreur, flux coupé — plus personne
    // n'est « en cours » : une carte qui tourne pour toujours est pire que
    // pas d'indicateur du tout.
    finally { setScoringMatch(false); setScoreProg(null); setScoreEnCours({}); }
  };
  // LES ÉCARTÉS QUITTENT LA LISTE (demande 23.09 : « les profils écartés
  // doivent bouger et aller dans l'onglet profils écartés »).
  //
  // Les faire descendre en bas ne suffisait pas : ils gardaient un rang, ils
  // comptaient dans « Candidats 21 », ils pesaient dans Market Ready et dans
  // le classement — alors qu'ils ne partiront pas chez le client. Un profil
  // refusé n'est pas un profil en retard : c'est une décision prise, et elle
  // se range ailleurs.
  //
  // Ils ne DISPARAISSENT pas : les cacher ferait croire qu'on les a perdus, et
  // la marque se lève d'un clic. Ils ont leur onglet, avec leur motif.
  const [expandedEcarteIdx, setExpandedEcarteIdx] = useState(null);
  const candidatsActifs = candidats.filter(c => !c.ne_pas_envoyer);
  const candidatsEcartes = candidats.filter(c => c.ne_pas_envoyer);
  // Lever le DERNIER écarté fait disparaître son onglet : sans ça on resterait
  // sur un onglet qui n'existe plus, devant un écran vide.
  useEffect(() => {
    if (besoinTab === 'ecartes' && candidatsEcartes.length === 0) setBesoinTab('candidats');
  }, [besoinTab, candidatsEcartes.length]);
  // Pas diffusé et rien reçu : l'onglet des propositions n'a rien à montrer.
  const propositionsVisibles = sourciaOn && (!!diff.diffusion || (diff.propCount || 0) > 0 || (diff.proposals || []).length > 0);
  useEffect(() => {
    if (besoinTab === 'propositions' && !propositionsVisibles) setBesoinTab('candidats');
  }, [besoinTab, propositionsVisibles]);

  // Lookup tolérant : id pipeline (événements NDJSON), id canonique, nom ; repli sur
  // le score déjà porté par le positionnement (c.score).
  const matchInfoFor = (c) => matchScores[String(c.id)]
    ?? matchScores[String(c.candidate_id)]
    ?? (c.nom ? matchScores['nom:' + String(c.nom).trim().toLowerCase()] : undefined)
    ?? (c.score != null ? { score: Number(c.score), perso: c.poids_personnalises === true, niveauFit: c.niveau_fit ?? null, niveauEcart: c.niveau_ecart ?? null, niveauEcartDetail: c.niveau_ecart_detail ?? null,
        statutAo: c.statut_ao ?? null, statutAoLibelle: c.statut_ao_libelle ?? null, enLEtat: c.score_en_l_etat ?? null, potentiel: c.score_potentiel ?? null, aConfirmer: c.a_confirmer || [], confirmations: c.confirmations_ao || null } : undefined);

  const loadTestQuestions = async () => {
    try {
      const res = await fetch(`${BASE}/tests/besoin/${besoin.id}`, { headers: authHeaders });
      const data = await res.json();
      setTestQuestions(Array.isArray(data) ? data : []);
    } catch { setTestQuestions([]); }
  };

  const extractCVInfo = async (file) => {
    try {
      const base64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result.split(',')[1]);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
      // /claude/extract-cv N'A JAMAIS EXISTÉ côté serveur (aucune route
      // montée) : l'appel 404-ait en silence et la fiche naissait avec le NOM
      // DU FICHIER pour patronyme (« cv_2024_v3 »). La lecture du CV se fait
      // sur /candidates/analyser-cv, qui lit PDF, DOC et DOCX.
      const res = await fetch(`${BASE}/candidates/analyser-cv`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHeaders },
        body: JSON.stringify({ base64, mimeType: file.type || 'application/pdf', fileName: file.name })
      });
      if (res.ok) { const data = await res.json(); if (data.success && data.candidat) return data.candidat; }
    } catch { console.warn('Extraction CV indisponible'); }

    const nomFichier = file.name.replace(/\.(pdf|doc|docx)$/i,'').replace(/\s*\(\d+\)\s*/g,'').replace(/^cv[_\s]TAT[_\s]/i,'').replace(/^cv[_\s]/i,'').replace(/_/g,' ').replace(/^.*?[-–]\s*/,'').trim();
    return { nom: nomFichier || 'Candidat', prenom: '', experience: 0, localisation: '', disponibilite: '', commentaire: '' };
  };

  // Crée une NOUVELLE fiche à partir d'un CV analysé, puis y rattache le CV.
  const createFromCv = async (file, cvInfo) => {
    setUploadingFiles(true);
    try {
      const nouveau = await APIService.createCandidat({ nom: cvInfo.nom || file.name.replace(/\.(pdf|doc|docx)$/i,'').trim(), prenom: cvInfo.prenom || '', besoinId: besoin.id, experience: cvInfo.experience || 0, localisation: cvInfo.localisation || '', disponibilite: cvInfo.disponibilite || '', commentaire: cvInfo.commentaire || '' });
      await APIService.uploadCV(file, `${cvInfo.prenom||''} ${cvInfo.nom||''}`.trim(), besoin.id, nouveau.id);
      showNotification('CV analysé et ajouté', 'success');
      await loadCandidats(); onUpdate();
    } catch (error) { showNotification(error.message || 'Erreur upload', 'error'); } finally { setUploadingFiles(false); }
  };

  // FUSION : positionne la fiche EXISTANTE sur le besoin + y rattache le CV importé (aucune fiche créée).
  const mergeIntoExisting = async (match, file) => {
    const canonicalId = match.candidate_id ?? match.canonical_candidate_id ?? match.id;
    setUploadingFiles(true);
    try {
      const res = await fetch(`${BASE}/candidates/${canonicalId}/besoins`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', ...authHeaders },
        body: JSON.stringify({ besoin_id: besoin.id, besoinId: besoin.id }),
      });
      if (!res.ok) { const j = await res.json().catch(() => ({})); throw new Error(j.error || `HTTP ${res.status}`); }
      // Rattache le CV importé à la fiche canonique (non bloquant si l'endpoint diffère côté serveur).
      if (file) {
        try {
          const fd = new FormData(); fd.append('file', file); fd.append('type', 'cv'); fd.append('type_piece', 'cv');
          await fetch(`${BASE}/candidates/${canonicalId}/documents`, { method: 'POST', headers: authHeaders, body: fd });
        } catch { /* le positionnement a réussi : on n'échoue pas pour le CV */ }
      }
      const nom = `${match.prenom || ''} ${match.nom || ''}`.trim() || 'Candidat';
      showNotification(`${nom} positionné (fiche existante réutilisée)`, 'success');
      await loadCandidats(); onUpdate();
    } catch (e) { showNotification('Erreur fusion : ' + e.message, 'error'); } finally { setUploadingFiles(false); }
  };

  // Le dépôt de fichiers passe par ICI comme le bouton « Parcourir » : une
  // seule fonction d'import, sinon glisser-déposer et clic divergent (vécu :
  // la zone annonçait « Glissez-déposez vos CVs ici » et ne portait AUCUN
  // gestionnaire — le fichier lâché était ouvert par le navigateur, rien
  // n'était uploadé).
  const CV_EXT = ['.pdf', '.doc', '.docx'];
  const handleFileUpload = (event) => importerCvs(event.target.files);
  const importerCvs = async (fileList) => {
    const tous = Array.from(fileList || []);
    const files = tous.filter(f => CV_EXT.some(e => f.name.toLowerCase().endsWith(e)));
    // Ce qui est refusé se dit : l'utilisateur voit le nom du fichier écarté
    // et les formats acceptés, plutôt qu'un dépôt sans effet.
    const refuses = tous.filter(f => !files.includes(f));
    if (refuses.length) {
      showNotification(`${refuses.map(f => f.name).join(', ')} : format non pris en charge. CV acceptés en PDF, DOC ou DOCX.`, 'error');
    }
    if (!files.length) return;
    // Import multiple : pas de dédoublonnage interactif (décision impossible par lot).
    if (files.length > 1) {
      setUploadingFiles(true);
      try {
        const result = await APIService.uploadMultipleCV(files, besoin.id);
        showNotification(`${result.uploaded} CV uploadé(s)`, 'success');
        await loadCandidats(); onUpdate();
      } catch (error) { showNotification(error.message || 'Erreur upload', 'error'); } finally { setUploadingFiles(false); }
      return;
    }
    // Import unique : analyse → recherche d'une fiche existante AVANT de créer.
    const file = files[0];
    setUploadingFiles(true);
    let cvInfo;
    try {
      showNotification('Analyse du CV en cours...', 'success');
      cvInfo = await extractCVInfo(file);
    } catch (error) { showNotification(error.message || 'Erreur analyse CV', 'error'); setUploadingFiles(false); return; }
    // Doublon ? recherche par nom côté serveur (?search=).
    let matches = [];
    const full = `${cvInfo.prenom || ''} ${cvInfo.nom || ''}`.trim();
    if (full) {
      try {
        const p = new URLSearchParams({ search: full, limit: '8' });
        const r = await fetch(`${BASE}/candidats/vue?${p.toString()}`, { headers: authHeaders });
        const j = await r.json().catch(() => ({}));
        const norm = (s) => (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z ]/g, ' ').replace(/\s+/g, ' ').trim();
        const target = norm(full);
        matches = (j.data || []).filter(c => {
          const nm = norm(`${c.prenom || ''} ${c.nom || ''}`);
          return nm && target && (nm === target || nm.includes(target) || target.includes(nm));
        }).slice(0, 5);
      } catch { /* recherche best-effort */ }
    }
    setUploadingFiles(false);
    if (matches.length) { setDupPrompt({ file, cvInfo, matches }); return; } // → modale « fiche existante, fusionner ? »
    await createFromCv(file, cvInfo);
  };

  // Rattacher (= POSITIONNER) un candidat EXISTANT sur ce besoin — jamais recréer une fiche.
  // POST /candidates/:id/besoins avec l'id CANONIQUE (cand vient de /candidats/vue → cand.id canonique).
  // Recréer via POST /candidats fabriquerait un doublon legacy (« Benoit Depoil » → « Benoit Depoil frtelch »).
  const attachExistingCandidat = async (cand) => {
    const canonicalId = cand.candidate_id ?? cand.canonical_candidate_id ?? cand.id;
    if (canonicalId == null) { showNotification('Fiche candidat sans identifiant.', 'error'); return; }
    try {
      const res = await fetch(`${BASE}/candidates/${canonicalId}/besoins`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${APIService.getToken()}` },
        body: JSON.stringify({ besoin_id: besoin.id, besoinId: besoin.id }),
      });
      if (!res.ok) { const j = await res.json().catch(() => ({})); throw new Error(j.error || `HTTP ${res.status}`); }
      const nom = `${cand.prenom || ''} ${cand.nom || ''}`.trim() || 'Candidat';
      showNotification(`${nom} positionné sur le besoin`, 'success');
      await loadCandidats(); onUpdate();
    } catch (e) { showNotification('Erreur ajout candidat : ' + e.message, 'error'); }
  };

  // Reliquat de l'ancien système : chaque frappe faisait un PUT AWAITÉ avant la
  // mise à jour locale — les réponses revenaient dans le désordre et
  // réappliquaient des valeurs anciennes (texte qui saute / se perd en tapant).
  // Désormais : état local IMMÉDIAT (la frappe ne dépend plus du réseau) + PUT
  // débouncé par candidat×champ (600 ms) qui n'envoie que la DERNIÈRE valeur.
  const putTimersRef = React.useRef({});
  // Auto-save débouncé des textes longs du besoin (notes, candidats contactés) :
  // la sauvegarde au blur seul perdait le texte quand on quittait l'écran sans
  // blur (clic sidebar → React ne déclenche PAS onBlur au démontage).
  const autoSaveTimersRef = React.useRef({});
  const scheduleAutoSave = (key, fn) => {
    clearTimeout(autoSaveTimersRef.current[key]);
    autoSaveTimersRef.current[key] = setTimeout(fn, 1200);
  };
  // Range la liste du meilleur score au moins bon. Le serveur lit les scores
  // DÉJÀ calculés (aucun appel IA) et écrit le classement ; s'il n'y en a
  // aucun, il le dit — « Scorer » d'abord.
  const [classementBusy, setClassementBusy] = useState(false);
  const classerParScore = async () => {
    setClassementBusy(true);
    try {
      const r = await fetch(`${BASE}/besoins/${besoin.id}/classement`, {
        method: 'PUT', headers: { 'Content-Type': 'application/json', ...authHeaders },
        body: JSON.stringify({ par: 'score' }),
      });
      const data = await r.json().catch(() => ({}));
      if (r.status === 404 || r.status === 501) { showNotification('Classement par score : arrive côté serveur.', 'error'); return; }
      if (!r.ok || data.success === false) throw new Error(data.error || `HTTP ${r.status}`);
      showNotification(data.message || 'Classement par score enregistré', 'success');
      await loadCandidats();
    } catch (e) { showNotification(e.message, 'error'); }
    finally { setClassementBusy(false); }
  };

  // Dépose la ligne saisie DEVANT la ligne survolée, puis persiste l'ordre
  // complet. Optimiste : la liste bouge tout de suite, et revient à son état
  // d'avant si le serveur refuse.
  const deposerRang = async (cibleId) => {
    const source = rangDrag;
    setRangDrag(null); setRangSurvol(null);
    if (source == null || source === cibleId) return;
    const avant = candidats;
    const ids = candidats.map(c => c.id);
    const from = ids.indexOf(source), to = ids.indexOf(cibleId);
    if (from === -1 || to === -1) return;
    const ordonne = [...candidats];
    const [deplace] = ordonne.splice(from, 1);
    ordonne.splice(to, 0, deplace);
    setCandidats(ordonne);
    // Le serveur classe par id CANONIQUE de candidat (la candidature), pas par
    // l'id de ligne : les deux espaces d'ids se chevauchent.
    const canon = ordonne.map(c => c.candidate_id ?? c.canonical_candidate_id).filter(x => x != null);
    if (!canon.length) return;
    try {
      const r = await fetch(`${BASE}/besoins/${besoin.id}/classement`, {
        method: 'PUT', headers: { 'Content-Type': 'application/json', ...authHeaders },
        body: JSON.stringify({ candidate_ids: canon }),
      });
      const data = await r.json().catch(() => ({}));
      if (r.status === 404 || r.status === 501) { showNotification('Classement : arrive côté serveur.', 'error'); setCandidats(avant); return; }
      if (!r.ok || data.success === false) throw new Error(data.error || `HTTP ${r.status}`);
      showNotification(data.message || 'Classement enregistré', 'success');
    } catch (e) {
      setCandidats(avant);
      showNotification('Classement non enregistré : ' + e.message, 'error');
    }
  };

  // L'avis du commercial. Optimiste, et remis comme avant si le serveur
  // refuse (une recruteuse n'a pas ce droit — le serveur le dit).
  // « NE PAS ENVOYER » — le refus MOTIVÉ, sur CE besoin. Même route que
  // « bon à envoyer » (PATCH du positionnement) : mêmes contrôles, mêmes
  // refus. Le serveur exige la raison et retire l'avis inverse — on ne les
  // combine pas ici, sinon deux vérités.
  const marquerNePasEnvoyer = async (candidat, { actif, motif }) => {
    const canon = candidat.candidate_id ?? candidat.canonical_candidate_id;
    if (canon == null) { showNotification('Fiche pas encore synchronisée — réessayez dans un instant', 'error'); return; }
    const avant = { ne_pas_envoyer: candidat.ne_pas_envoyer, ne_pas_envoyer_motif: candidat.ne_pas_envoyer_motif, bon_a_envoyer: candidat.bon_a_envoyer };
    // LE PROFIL ÉCARTÉ DESCEND TOUT DE SUITE (vécu 22.09 : « quand je fais
    // écarter ce profil, ça doit partir en bas et pas rester en top 1 »). Le
    // serveur range déjà la liste, mais on ne la relit pas après ce clic : sans
    // ce rangement local, le profil garde sa coupe de premier avec son motif de
    // refus à côté jusqu'au prochain chargement. Même règle, appliquée au même
    // moment que la marque — et le retour arrière la défait aussi.
    setCandidats(prev => ecartesEnBas(prev.map(c => c.id === candidat.id
      ? { ...c, ne_pas_envoyer: actif, ne_pas_envoyer_motif: actif ? motif : null, bon_a_envoyer: actif ? false : c.bon_a_envoyer }
      : c)));
    try {
      const r = await fetch(`${BASE}/candidates/${canon}/besoins/${besoin.id}`, {
        method: 'PATCH', headers: { 'Content-Type': 'application/json', ...authHeaders },
        body: JSON.stringify({ ne_pas_envoyer: actif, ...(actif ? { ne_pas_envoyer_motif: motif } : {}) }),
      });
      const data = await r.json().catch(() => ({}));
      // Même nuance que « bon à envoyer » : un 404 qui porte NOTRE JSON est
      // un vrai refus, pas une route manquante.
      if (r.status === 501 || (r.status === 404 && data.success !== false)) {
        showNotification('« Ne pas envoyer » : arrive côté serveur.', 'error');
        setCandidats(prev => ecartesEnBas(prev.map(c => c.id === candidat.id ? { ...c, ...avant } : c)));
        return;
      }
      if (!r.ok || data.success === false) throw new Error(data.error || `HTTP ${r.status}`);
      showNotification(data.message || (actif ? 'Profil écarté de l\'envoi' : 'Marque levée'), actif ? 'info' : 'success');
    } catch (e) {
      setCandidats(prev => ecartesEnBas(prev.map(c => c.id === candidat.id ? { ...c, ...avant } : c)));
      showNotification(e.message, 'error');
    }
  };

  // LA COUPE — posée à la main (23.09 : « l'IA ne mettra plus les coupes,
  // c'est l'humain qui va le faire, et il peut choisir quelle coupe »).
  // Même route que les deux avis (PATCH du positionnement) : mêmes contrôles,
  // mêmes refus. Le serveur valide la clé, refuse de décorer un profil écarté
  // et DÉPLACE la place si elle était prise — on reproduit ce déplacement ici
  // tout de suite, sinon l'écran affiche deux premiers choix jusqu'au
  // prochain chargement.
  const poserCoupe = async (candidat, cle) => {
    const canon = candidat.candidate_id ?? candidat.canonical_candidate_id;
    if (canon == null) { showNotification('Fiche pas encore synchronisée — réessayez dans un instant', 'error'); return; }
    const avant = candidats.map(c => ({ id: c.id, podium: c.podium, podium_libelle: c.podium_libelle, podium_icone: c.podium_icone, podium_rang: c.podium_rang }));
    const d = (distinctions || []).find(x => x.cle === cle) || null;
    setCandidats(prev => prev.map(c => {
      if (c.id === candidat.id) {
        return { ...c, podium: d ? d.cle : null, podium_libelle: d ? d.libelle : null,
                 podium_icone: d ? d.icone : null, podium_rang: d ? d.rang : null };
      }
      // La place est unique : celui qui la portait la perd, ici comme en base.
      if (d && c.podium === d.cle) return { ...c, podium: null, podium_libelle: null, podium_icone: null, podium_rang: null };
      return c;
    }));
    try {
      const r = await fetch(`${BASE}/candidates/${canon}/besoins/${besoin.id}`, {
        method: 'PATCH', headers: { 'Content-Type': 'application/json', ...authHeaders },
        body: JSON.stringify({ podium: cle }),
      });
      const data = await r.json().catch(() => ({}));
      // Même nuance qu'ailleurs : un 404 qui porte NOTRE JSON est un vrai
      // refus, pas une route manquante.
      if (r.status === 501 || (r.status === 404 && data.success !== false)) {
        showNotification('Les coupes : arrivent côté serveur.', 'error');
        setCandidats(prev => prev.map(c => ({ ...c, ...(avant.find(a => a.id === c.id) || {}) })));
        return;
      }
      if (!r.ok || data.success === false) throw new Error(data.error || `HTTP ${r.status}`);
      showNotification(data.message || (d ? `${d.libelle} posé` : 'Coupe retirée'), 'success');
    } catch (e) {
      setCandidats(prev => prev.map(c => ({ ...c, ...(avant.find(a => a.id === c.id) || {}) })));
      showNotification(e.message, 'error');
    }
  };

  const marquerBonAEnvoyer = async (candidat, valeur) => {
    const canon = candidat.candidate_id ?? candidat.canonical_candidate_id;
    if (canon == null) { showNotification('Fiche pas encore synchronisée — réessayez dans un instant', 'error'); return; }
    setCandidats(prev => prev.map(c => c.id === candidat.id ? { ...c, bon_a_envoyer: valeur } : c));
    try {
      // PATCH, comme le déclare la route du positionnement (et comme
      // l'appellent déjà les conditions de contrat côté dossier AO). En PUT,
      // Express ne trouvait AUCUNE route — les méthodes se comparent à
      // l'identique — et rendait un 404 que la garde ci-dessous lisait comme
      // « la route n'existe pas encore ». Le bouton annonçait donc « arrive
      // côté serveur » pour une route livrée depuis longtemps : rien à
      // attendre, tout à recliquer.
      const r = await fetch(`${BASE}/candidates/${canon}/besoins/${besoin.id}`, {
        method: 'PATCH', headers: { 'Content-Type': 'application/json', ...authHeaders },
        body: JSON.stringify({ bon_a_envoyer: valeur }),
      });
      const data = await r.json().catch(() => ({}));
      // Un 404 qui porte NOTRE JSON est une vraie réponse (« Candidat non
      // trouvé », « Besoin non trouvé ») : on l'affiche telle quelle. Seul un
      // 404 muet, ou un 501, veut dire que la route manque — sans cette
      // nuance, un refus légitime se déguisait en fonctionnalité à venir.
      if (r.status === 501 || (r.status === 404 && data.success !== false)) { showNotification('Avis « bon à envoyer » : arrive côté serveur.', 'error'); setCandidats(prev => prev.map(c => c.id === candidat.id ? { ...c, bon_a_envoyer: !valeur } : c)); return; }
      if (!r.ok || data.success === false) throw new Error(data.error || `HTTP ${r.status}`);
      showNotification(data.message || (valeur ? 'Profil marqué bon à envoyer' : 'Marquage retiré'), 'success');
    } catch (e) {
      setCandidats(prev => prev.map(c => c.id === candidat.id ? { ...c, bon_a_envoyer: !valeur } : c));
      showNotification(e.message, 'error');
    }
  };

  const updateCandidat = (candidatId, field, value) => {
    setCandidats(prev => prev.map(c => c.id === candidatId ? { ...c, [field]: value } : c));
    const k = `${candidatId}:${field}`;
    clearTimeout(putTimersRef.current[k]);
    putTimersRef.current[k] = setTimeout(async () => {
      delete putTimersRef.current[k];
      try { await APIService.updateCandidat(candidatId, { [field]: value }); }
      catch (e) {
        // Un refus du serveur est écrit pour la personne qui saisit (« … n'est
        // pas une date ») : on l'affiche tel quel. « Erreur 400 » n'apprend
        // rien — dans ce cas seulement, on garde notre phrase. Et comme la
        // valeur affichée vient d'une mise à jour optimiste, on relit la
        // liste : ce qui est à l'écran doit être ce qui est enregistré.
        const brut = e?.message || '';
        showNotification(/^Erreur \d+$/.test(brut) || !brut ? 'Sauvegarde échouée — votre dernière modification n\'est pas enregistrée' : brut, 'error');
        loadCandidats();
      }
    }, 600);
  };

  const uploadCVForCandidat = async (candidatId, file) => {
    // UN SEUL CV PAR BESOIN : si un CV format entreprise est déjà en place,
    // le dépôt le remplace — on prévient avant, on ne duplique jamais.
    const cand = (candidats || []).find(c => String(c.id) === String(candidatId));
    if (cand?.cv_url && cand?.cv_est_entreprise === true) {
      const ok = await confirmErpia({
        title: 'Remplacer le CV du besoin ?',
        message: 'Un CV format entreprise est déjà en place sur ce besoin. Le fichier déposé le remplacera — il n’y a qu’un seul CV par besoin.',
        confirmLabel: 'Remplacer le CV', tone: 'danger',
      });
      if (!ok) return;
    }
    try {
      showNotification('Upload CV en cours...', 'success');
      const res = await APIService.uploadCV(file, file.name.replace(/\.(pdf|doc|docx)$/i,'').trim(), besoin.id, candidatId);
      // Le message du serveur dit s'il s'agit d'un AJOUT ou d'un REMPLACEMENT
      // — affiché tel quel, on ne devine pas à sa place.
      showNotification(res?.message || 'CV uploadé !', 'success');
      await loadCandidats(); onUpdate();
    } catch (err) { showNotification(err.message || 'Erreur upload CV', 'error'); }
  };

  const deleteCandidat = async (candidatId) => {
    if (!await confirmErpia({ message: 'Supprimer ce candidat ?' })) return;
    try {
      await APIService.deleteCandidat(candidatId);
      setCandidats(prev => prev.filter(c => c.id !== candidatId));
      showNotification('Candidat supprimé', 'success'); onUpdate();
    } catch { showNotification('Erreur suppression', 'error'); }
  };

  const saveJD = async () => {
    setSavingJD(true);
    try {
      await fetch(`${BASE}/besoins/${besoin.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${APIService.getToken()}` },
        body: JSON.stringify({ description: jdEditContent })
      });
      besoin.description = jdEditContent;
      showNotification('JD sauvegardé', 'success');
      setShowJDEditor(false);
    } catch (e) { showNotification('Erreur sauvegarde JD', 'error'); }
    setSavingJD(false);
  };

  // Localisation de la mission, éditable en ligne : c'est la ville que le
  // sourcing vise par défaut (formulaire, moteur, InMails). Un tiret qu'on
  // ne pouvait pas éditer laissait chaque campagne repartir sans ville.
  const [locEdit, setLocEdit] = useState(null); // null = lecture ; texte = en cours d'édition
  // RÉFÉRENCE INTERNE (27.10) : repère de l'équipe, jamais publié.
  const [refEdit, setRefEdit] = useState(null);
  // DATE DE DÉMARRAGE et SALAIRE MAX (02.10 : « pourquoi je ne peux pas
  // éditer la date de démarrage ? » — la ligne lisait un champ que le serveur
  // n'a jamais envoyé). Le refus du serveur (date illisible, salaire mensuel
  // saisi par erreur, champ obligatoire qu'on voudrait vider) s'affiche tel
  // quel : c'est lui qui dit quoi corriger.
  const [condEdit, setCondEdit] = useState(null); // null = lecture ; { champ, valeur } = en cours
  const [condBusy, setCondBusy] = useState(false);
  const enregistrerCond = async () => {
    if (!condEdit) return;
    const { champ, valeur } = condEdit;
    const col = champ === 'dateDemarrage' ? 'date_demarrage' : 'salaire_max';
    const avant = champ === 'dateDemarrage' ? jourIso(besoin.date_demarrage) : String(besoin.salaire_max ?? '');
    setCondEdit(null);
    if (String(valeur).trim() === avant) return;
    setCondBusy(true);
    try {
      const r = await fetch(`${BASE}/besoins/${besoin.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${APIService.getToken()}` },
        body: JSON.stringify({ [champ]: valeur }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok || j.success === false) throw new Error(j.error || `HTTP ${r.status}`);
      // Un serveur qui ne connaît pas encore ces champs répond 200 sans les
      // rendre : on le dit plutôt que d'afficher une valeur non enregistrée.
      if (j.data && j.data[col] === undefined) { showNotification('Ce champ arrive côté serveur — rien n\'a été enregistré.', 'info'); return; }
      onUpdate?.({ ...besoin, [col]: j.data ? j.data[col] : valeur });
      showNotification(champ === 'dateDemarrage'
        ? `Démarrage souhaité le ${dateCH(j.data?.[col] ?? valeur) || valeur}.`
        : `Salaire max : ${chf(j.data?.[col] ?? valeur) || valeur} par an.`, 'success');
    } catch (e) { showNotification(e.message || 'Enregistrement impossible', 'error'); }
    finally { setCondBusy(false); }
  };
  const toucheCond = (e) => {
    if (e.key === 'Enter') { e.preventDefault(); enregistrerCond(); }
    else if (e.key === 'Escape') { e.preventDefault(); setCondEdit(null); }
  };
  const enregistrerRef = async () => {
    if (refEdit == null) return;
    const v = String(refEdit).replace(/\s+/g, ' ').trim();
    setRefEdit(null);
    if (v === String(besoin.reference_interne || '')) return;
    try {
      const r = await fetch(`${BASE}/besoins/${besoin.id}`, {
        method: 'PUT', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${APIService.getToken()}` },
        body: JSON.stringify({ reference_interne: v || null }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok || j.success === false) throw new Error(j.error || `HTTP ${r.status}`);
      // Un serveur qui ne connaît pas encore le champ l'ignore sans le dire.
      if (j.data && !('reference_interne' in j.data)) { showNotification("La référence interne arrive côté serveur : elle n'a pas été enregistrée.", 'info'); return; }
      if (onUpdate) onUpdate({ ...besoin, reference_interne: j.data?.reference_interne ?? (v || null) });
      showNotification(v ? `Référence interne enregistrée : ${v}.` : 'Référence interne effacée.', 'success');
    } catch (e) { showNotification(e.message || 'Enregistrement impossible', 'error'); }
  };
  const enregistrerLoc = async () => {
    if (locEdit == null) return;
    const v = String(locEdit).trim();
    setLocEdit(null);
    if (v === String(besoin.localisation || '')) return;
    await patch('localisation', v || null);
    showNotification(v ? `Localisation enregistrée : ${v} — le sourcing visera cette ville par défaut.` : 'Localisation effacée.', 'success');
  };
  // LE COMMERCIAL QUI SUIT LE BESOIN, éditable en ligne (demande 23.09). Il
  // se choisissait à la création et plus jamais : un départ, une reprise de
  // portefeuille, une erreur de clic — et le besoin restait au nom de
  // quelqu'un qui ne le suit plus. Or c'est LE destinataire : les
  // propositions de sourceurs le préviennent, « mes besoins » se filtre sur
  // lui. Un besoin attribué à quelqu'un qui n'est plus là est un besoin que
  // personne ne regarde.
  const [respEdit, setRespEdit] = useState(null);   // null = lecture ; sinon l'id en cours
  const [respListe, setRespListe] = useState([]);
  const [respBusy, setRespBusy] = useState(false);
  const ouvrirResp = async () => {
    setRespEdit(String(besoin.responsable?.id ?? besoin.responsable_id ?? ''));
    if (respListe.length) return;
    try {
      const d = await APIService.getUsers();
      const tous = (d.users || []).filter(u => compteActif(u) && !(u.role === 'ressource' || u.ressource === true));
      const bm = tous.filter(estBusinessManager);
      setRespListe(bm.length ? bm : tous);
    } catch { /* liste vide : le champ le dira */ }
  };
  const enregistrerResp = async (valeur) => {
    const actuel = String(besoin.responsable?.id ?? besoin.responsable_id ?? '');
    setRespEdit(null);
    if (String(valeur) === actuel) return;
    setRespBusy(true);
    try {
      const r = await fetch(`${BASE}/besoins/${besoin.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${APIService.getToken()}` },
        body: JSON.stringify({ responsableId: valeur === '' ? null : Number(valeur) }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok || j.success === false) { showNotification(j.error || 'Changement impossible', 'error'); return; }
      // Le serveur rend le besoin à jour (responsable inclus) : on le reprend
      // plutôt que de recomposer le nom ici.
      if (onUpdate) onUpdate({ ...besoin, ...(j.besoin || j.data || {}) });
      // Le message du serveur fait foi : c'est lui qui sait qui a été prévenu.
      showNotification(j.message || 'Responsable enregistré.', 'success');
    } catch (e) { showNotification('Changement impossible', 'error'); }
    finally { setRespBusy(false); }
  };

  // LA RECRUTEUSE DU BESOIN — à qui les campagnes de sourcing proposent
  // leurs profils, automatiquement (règle « une campagne a trouvé ses profils
  // → les proposer à la recruteuse du besoin »). Lue et écrite par sa route :
  // le serveur vérifie le compte et prévient la recruteuse. Route absente
  // (serveur pas encore déployé) → la ligne ne s'affiche pas.
  const sourcingOrgBesoin = useFeatureOptIn('sourcing_linkedin');
  const [recrut, setRecrut] = useState(undefined);      // undefined = inconnue, null = personne, {id, nom}
  const [recrutEdit, setRecrutEdit] = useState(null);
  const [recrutListe, setRecrutListe] = useState([]);
  const [recrutBusy, setRecrutBusy] = useState(false);
  useEffect(() => {
    if (!sourcingOrgBesoin || besoin?.id == null) return undefined;
    let annule = false;
    (async () => {
      try {
        const r = await fetch(`${BASE}/besoins/${besoin.id}/recruteuse`, { headers: { Authorization: `Bearer ${APIService.getToken()}` } });
        const j = await r.json().catch(() => ({}));
        if (annule) return;
        if (!r.ok || j.success === false) { setRecrut(undefined); return; }
        setRecrut(j.data?.recruteuse ?? null);
      } catch { if (!annule) setRecrut(undefined); }
    })();
    return () => { annule = true; };
  }, [sourcingOrgBesoin, besoin?.id]);
  const ouvrirRecrut = async () => {
    setRecrutEdit(String(recrut?.id ?? ''));
    if (recrutListe.length) return;
    try {
      const d = await APIService.getUsers();
      setRecrutListe((d.users || []).filter(u => compteActif(u) && !(u.role === 'ressource' || u.ressource === true)));
    } catch { /* liste vide : le champ le dira */ }
  };
  const enregistrerRecrut = async (valeur) => {
    setRecrutEdit(null);
    if (String(valeur) === String(recrut?.id ?? '')) return;
    setRecrutBusy(true);
    try {
      const r = await fetch(`${BASE}/besoins/${besoin.id}/recruteuse`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${APIService.getToken()}` },
        body: JSON.stringify({ user_id: valeur === '' ? null : Number(valeur) }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok || j.success === false) { showNotification(j.error || 'Changement impossible', 'error'); return; }
      setRecrut(j.recruteuse ?? null);
      // Le message du serveur fait foi : il dit qui a été prévenu.
      showNotification(j.message || 'Recrutement attribué.', 'success');
    } catch { showNotification('Changement impossible', 'error'); }
    finally { setRecrutBusy(false); }
  };

  const patch = async (field, val) => {
    try {
      await fetch(`${BASE}/besoins/${besoin.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${APIService.getToken()}` },
        body: JSON.stringify({ [field]: val })
      });
      if (onUpdate) onUpdate({ ...besoin, [field]: val });
    } catch(e) { showNotification('Erreur sauvegarde', 'error'); }
  };

  const saveNotes = async (val) => {
    if (val === (besoin.notes_commercial || '')) return; // pas de changement
    setSavingNotes(true);
    try {
      await fetch(`${BASE}/besoins/${besoin.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${APIService.getToken()}` },
        body: JSON.stringify({ notes_commercial: val })
      });
      besoin.notes_commercial = val;
    } catch (e) { showNotification('Erreur sauvegarde notes', 'error'); }
    setSavingNotes(false);
  };

  const saveContactes = async (val) => {
    if (val === (besoin.candidats_contactes || '')) return;
    try {
      await fetch(`${BASE}/besoins/${besoin.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${APIService.getToken()}` },
        body: JSON.stringify({ candidats_contactes: val })
      });
      besoin.candidats_contactes = val;
    } catch (e) { showNotification('Erreur sauvegarde', 'error'); }
  };


  const formatFileSize = bytes => {
    if (!bytes) return '0 B';
    const k = 1024, sizes = ['B','KB','MB','GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
  };

  return (
    <div className="bd-wrap">
      <style>{BD_STYLES}</style>
      <div className="bd-card bd-header">
        {/* flex-basis 520px : la largeur qu'il faut à un titre de besoin pour
            se lire en une ou deux lignes. En dessous, c'est le BANDEAU qui
            passe à la ligne (les actions descendent) — mesuré : à 340px de
            base, la zone 1150-1300px laissait encore le titre sur trois
            lignes serrées. */}
        <div className="flex items-start gap-3" style={{ flex: '1 1 520px', minWidth: 0 }}>
          <button onClick={onBack} className="bd-back" title="Retour"><BI icon="chevron-left" className="text-xl" /></button>
          <div {...ancre('besoin-entete')} style={{ flex: 1, minWidth: 0 }}>
            <div className="bd-eyebrow">Besoin client <span>#{besoin.id}</span></div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
              {editingTitle ? (
                <input autoFocus value={detailTitre} onChange={e => setDetailTitre(e.target.value)}
                  onBlur={() => { patch('titre', detailTitre); setEditingTitle(false); }}
                  onKeyDown={e => { if (e.key === 'Enter') { patch('titre', detailTitre); setEditingTitle(false); } else if (e.key === 'Escape') { setDetailTitre(besoin.titre); setEditingTitle(false); } }}
                  className="bd-title-input" style={{ flex: 1, minWidth: '200px' }}
                />
              ) : (
                <h1 className="bd-h1"
                  onClick={() => { setDetailTitre(besoin.titre); setEditingTitle(true); }}
                  title="Cliquer pour modifier le titre">
                  {detailTitre || besoin.titre}
                  <BI icon="pencil" className="pen" />
                </h1>
              )}
              {besoin.priorite && BD_PRIO[besoin.priorite] && <span className="bd-prio" style={{ background: BD_PRIO[besoin.priorite].bg, color: BD_PRIO[besoin.priorite].fg, display: 'inline-flex', alignItems: 'center', gap: '5px' }}><BI icon="flag-fill" style={{ fontSize: '10px' }} /> {BD_PRIO[besoin.priorite].l}</span>}
              <PastilleSourcingAuto sourcingAuto={besoin.sourcing_auto} />
              <StatutStepper statut={statut} onChange={changeStatutBesoin} />
            </div>
            {editingClient ? (
              <input autoFocus value={detailClient} onChange={e => setDetailClient(e.target.value)}
                onBlur={() => { patch('client', detailClient); setEditingClient(false); }}
                onKeyDown={e => { if (e.key === 'Enter') { patch('client', detailClient); setEditingClient(false); } else if (e.key === 'Escape') { setDetailClient(besoin.client); setEditingClient(false); } }}
                className="bd-sub-input"
              />
            ) : (
              <p className="bd-meta"
                onClick={() => { setDetailClient(besoin.client); setEditingClient(true); }}
                title="Cliquer pour modifier le client">
                {detailClient || besoin.client} · {typeof besoin.responsable === 'string' ? besoin.responsable : (besoin.responsable ? nomUtilisateur(besoin.responsable) : '—')} · Créé le {new Date(besoin.created_at).toLocaleDateString('fr-FR')}
              </p>
            )}
          </div>
        </div>
        <div className="bd-header-actions flex items-center gap-2">
          {sourciaOn && <DiffusionHeaderButton diffusion={diff.diffusion} onOpen={diff.openDraft} />}
          <BoutonAnnonce cible="besoin" besoin={besoin} showNotification={showNotification} />
          {/* Publier sur LinkedIn : réservé à l'administrateur (demande 27.10,
              avant la mise en production de l'org ctlq) — un recruteur ne
              publie pas sur le compte Recruiter de l'agence. */}
          {isAoAdmin(APIService.getCurrentUser()) && <PublierOffreLinkedIn besoin={besoin} showNotification={showNotification} />}
          <button onClick={() => setBesoinTab('poste')} className="bd-btn">
            <BI icon="pencil-square" /> Voir / Éditer JD
          </button>
          <button onClick={downloadJdPdf} disabled={genJdPdf} className="bd-btn" style={{ opacity: genJdPdf ? 0.7 : 1, cursor: genJdPdf ? 'wait' : 'pointer' }}>
            <BI icon={genJdPdf ? 'arrow-repeat' : 'file-earmark-text'} style={genJdPdf ? { display: 'inline-block', animation: 'ats-spin .7s linear infinite' } : undefined} /> {genJdPdf ? 'Génération…' : 'Générer JD PDF'}
          </button>
          <button onClick={() => showNotification('Génération du dossier complet — à brancher côté backend', 'success')} className="bd-btn-primary">
            <BI icon="folder-plus" /> Générer tout le dossier
          </button>
        </div>
      </div>

      {/* Barre de pilotage */}
      {(() => {
        const mrReady = candidats.filter(c => mrEtat(c).ready).length;
        const pct = candidats.length ? Math.round((mrReady / candidats.length) * 100) : 0;
        return (
          <div className="bd-pilot">
            <div className="bd-pilot-cell bd-pilot-cell-primary"><div className="bd-pilot-l">Market Ready</div><div className="bd-pilot-v mono">{mrReady}/{candidats.length}</div><div className="bd-progress"><span style={{ width: pct + '%' }} /></div></div>
            <div className="bd-pilot-cell"><div className="bd-pilot-l">Candidats</div><div className="bd-pilot-v mono">{candidats.length}</div></div>
            {/* « Date visée » et « Tarif / Salaire » lisaient des champs que le
                serveur n'a jamais envoyés : un tiret à vie. Ils montrent
                désormais la date de démarrage et le salaire max du besoin. */}
            <div className="bd-pilot-cell"><div className="bd-pilot-l">Démarrage souhaité</div><div className="bd-pilot-v">{dateCH(besoin.date_demarrage) || '—'}</div></div>
            <div className="bd-pilot-cell"><div className="bd-pilot-l">Salaire max / an</div><div className="bd-pilot-v">{chf(besoin.salaire_max) || '—'}</div></div>
            <div className="bd-pilot-cell"><div className="bd-pilot-l">Ouvert depuis</div><div className="bd-pilot-v">{besoin.created_at ? Math.floor((Date.now() - new Date(besoin.created_at)) / 86400000) + ' j' : '—'}</div></div>
          </div>
        );
      })()}


      {/* Notes commerciales — avec mode plein écran */}
      {notesFullscreen && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(4,6,11,0.55)', backdropFilter: 'blur(2px)', zIndex: 500, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}>
          <div className="bd-card" style={{ width: '100%', maxWidth: '768px', display: 'flex', flexDirection: 'column', height: '80vh' }}>
            <div className="bd-sect-head" style={{ borderRadius: '12px 12px 0 0' }}>
              <span className="bd-sect-title"><BI icon="pencil-square" /> Notes commerciales / RH — {besoin.titre}
                <span className="bd-chip-accent">Interne</span>
              </span>
              <div className="flex items-center gap-3">
                {savingNotes && <span className="bd-saving">Sauvegarde…</span>}
                {!savingNotes && notesCommercial && <span className="bd-saved"><BI icon="check-lg" /> Sauvegardé</span>}
                <button onClick={() => { saveNotes(notesCommercial); setNotesFullscreen(false); }}
                  className="bd-btn-primary" style={{ padding: '6px 14px', fontSize: '12.5px' }}>
                  <BI icon="check-lg" /> Fermer
                </button>
              </div>
            </div>
            <textarea
              autoFocus
              value={notesCommercial}
              onChange={e => { const v = e.target.value; setNotesCommercial(v); scheduleAutoSave('notes', () => saveNotes(v)); }}
              onBlur={e => saveNotes(e.target.value)}
              placeholder="Notes internes : qualification client, budget, urgence, contexte, contacts clés, feedback entretiens..."
              className="bd-textarea"
              style={{ flex: 1, borderRadius: '0 0 12px 12px' }}
            />
          </div>
        </div>
      )}

      <div className="bd-body">
        {/* Rail de contexte gauche */}
        <div className="bd-rail">
          <div className="bd-rail-card">
            <div className="bd-rail-title">Détails</div>
            <div className="bd-kv">
              <div className="bd-kv-row"><span className="k">Localisation</span>
                {locEdit == null
                  ? <button type="button" className={`bd-kv-edit${besoin.localisation || besoin.ville ? '' : ' bd-kv-edit--vide'}`}
                      title="Modifier la localisation — la ville que le sourcing vise par défaut"
                      onClick={() => setLocEdit(besoin.localisation || besoin.ville || '')}>
                      {besoin.localisation || besoin.ville || 'À préciser'} <BI icon="pencil" />
                    </button>
                  : <input autoFocus className="bd-kv-input" value={locEdit} placeholder="Genève" maxLength={160} aria-label="Localisation de la mission"
                      onChange={e => setLocEdit(e.target.value)}
                      onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); enregistrerLoc(); } else if (e.key === 'Escape') { e.preventDefault(); setLocEdit(null); } }}
                      onBlur={enregistrerLoc} />}
              </div>
              <div className="bd-kv-row"><span className="k">Référence</span>
                {refEdit == null
                  ? <button type="button" className={`bd-kv-edit${besoin.reference_interne ? '' : ' bd-kv-edit--vide'}`}
                      title="Référence interne — pour l'équipe, jamais publiée (ni LinkedIn, ni lien envoyé au candidat)"
                      onClick={() => setRefEdit(besoin.reference_interne || '')}>
                      {besoin.reference_interne || 'Aucune'} <BI icon="pencil" />
                    </button>
                  : <input autoFocus className="bd-kv-input" value={refEdit} placeholder="Réf AO OCSIN 26-04" maxLength={120} aria-label="Référence interne du besoin"
                      onChange={e => setRefEdit(e.target.value)}
                      onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); enregistrerRef(); } else if (e.key === 'Escape') { e.preventDefault(); setRefEdit(null); } }}
                      onBlur={enregistrerRef} />}
              </div>
              {/* LE DOSSIER AO (01.11 : « ajoute AO dans Détails pour voir s'il est
                  lié à un AO ») : servi par la fiche (`ao`, lu dans l'organisation),
                  jamais deviné ici. `null` = rattaché à aucun appel d'offres → « Aucun » ;
                  absent (serveur pas encore à jour) → « — », pas un faux « Aucun ». */}
              <div className="bd-kv-row"><span className="k">Dossier AO</span>
                {besoin.ao?.id
                  ? <button type="button" className="bd-kv-edit"
                      title={`Ouvrir le dossier AO « ${besoin.ao.titre || `#${besoin.ao.id}`} »`}
                      onClick={() => onOpenAo?.(besoin.ao.id)}>
                      {besoin.ao.titre || `Dossier #${besoin.ao.id}`} <BI icon="folder2-open" />
                    </button>
                  : besoin.ao === null
                    ? <span className="v bd-kv-vide" title="Ce besoin n'est rattaché à aucun appel d'offres">Aucun</span>
                    : <span className="v bd-kv-vide" title="Le dossier AO du besoin arrive côté serveur">—</span>}
              </div>
              <div className="bd-kv-row"><span className="k">Commercial</span>
                {respEdit == null
                  ? <button type="button" disabled={respBusy}
                      className={`bd-kv-edit${(besoin.responsable || besoin.responsable_id) ? '' : ' bd-kv-edit--vide'}`}
                      title="Changer le commercial qui suit ce besoin — il en sera prévenu, l'ancien aussi"
                      onClick={ouvrirResp}>
                      {besoin.responsable
                        ? (typeof besoin.responsable === 'string' ? besoin.responsable : nomUtilisateur(besoin.responsable))
                        : 'À attribuer'} <BI icon={respBusy ? 'arrow-repeat' : 'pencil'} />
                    </button>
                  : <ErpiaSelect autoFocus className="bd-kv-input" value={respEdit}
                      aria-label="Commercial qui suit ce besoin"
                      onChange={e => enregistrerResp(e.target.value)}
                      onKeyDown={e => { if (e.key === 'Escape') { e.preventDefault(); setRespEdit(null); } }}
                      onBlur={() => setRespEdit(null)}>
                      <option value="">Aucun responsable</option>
                      {respListe.map(u => <option key={u.id} value={u.id}>{nomUtilisateur(u)}</option>)}
                    </ErpiaSelect>}
              </div>
              {recrut !== undefined && (
                <div className="bd-kv-row"><span className="k">Recrutement</span>
                  {recrutEdit == null
                    ? <button type="button" disabled={recrutBusy}
                        className={`bd-kv-edit${recrut ? '' : ' bd-kv-edit--vide'}`}
                        title="Qui recrute sur ce besoin — les profils trouvés par ses campagnes de sourcing lui sont proposés à trier ; la personne en sera prévenue"
                        onClick={ouvrirRecrut}>
                        {recrut ? recrut.nom : 'À attribuer'} <BI icon={recrutBusy ? 'arrow-repeat' : 'pencil'} />
                      </button>
                    : <ErpiaSelect autoFocus className="bd-kv-input" value={recrutEdit}
                        aria-label="Qui recrute sur ce besoin"
                        onChange={e => enregistrerRecrut(e.target.value)}
                        onKeyDown={e => { if (e.key === 'Escape') { e.preventDefault(); setRecrutEdit(null); } }}
                        onBlur={() => setRecrutEdit(null)}>
                        <option value="">Personne</option>
                        {recrutListe.map(u => <option key={u.id} value={u.id}>{nomUtilisateur(u)}</option>)}
                      </ErpiaSelect>}
                </div>
              )}
              <div className="bd-kv-row"><span className="k">Contrat</span><span className="v">{besoin.contrat || besoin.type_contrat || '—'}</span></div>
              <div className="bd-kv-row"><span className="k">Séniorité</span><span className="v">{besoin.seniorite || '—'}</span></div>
              <div className="bd-kv-row"><span className="k">Démarrage</span>
                {condEdit?.champ !== 'dateDemarrage'
                  ? <button type="button" disabled={condBusy}
                      className={`bd-kv-edit${besoin.date_demarrage ? '' : ' bd-kv-edit--vide'}`}
                      title="Date de démarrage souhaitée — obligatoire, modifiable à tout moment"
                      onClick={() => setCondEdit({ champ: 'dateDemarrage', valeur: jourIso(besoin.date_demarrage) })}>
                      {dateCH(besoin.date_demarrage) || 'À préciser'} <BI icon={condBusy ? 'arrow-repeat' : 'pencil'} />
                    </button>
                  : <input autoFocus type="date" className="bd-kv-input" value={condEdit.valeur} aria-label="Date de démarrage souhaitée"
                      onChange={e => setCondEdit({ champ: 'dateDemarrage', valeur: e.target.value })}
                      onKeyDown={toucheCond} onBlur={enregistrerCond} />}
              </div>
              <div className="bd-kv-row"><span className="k">Salaire max</span>
                {condEdit?.champ !== 'salaireMax'
                  ? <button type="button" disabled={condBusy}
                      className={`bd-kv-edit${besoin.salaire_max ? '' : ' bd-kv-edit--vide'}`}
                      title="Salaire max annuel brut — interne, jamais sur la fiche de poste envoyée"
                      onClick={() => setCondEdit({ champ: 'salaireMax', valeur: String(besoin.salaire_max ?? '') })}>
                      {chf(besoin.salaire_max) ? `${chf(besoin.salaire_max)} / an` : 'À préciser'} <BI icon={condBusy ? 'arrow-repeat' : 'pencil'} />
                    </button>
                  : <input autoFocus className="bd-kv-input" inputMode="numeric" value={condEdit.valeur} placeholder="120 000" aria-label="Salaire max, CHF brut par an"
                      onChange={e => setCondEdit({ champ: 'salaireMax', valeur: e.target.value })}
                      onKeyDown={toucheCond} onBlur={enregistrerCond} />}
              </div>
              <div className="bd-kv-row"><span className="k">Priorité</span><span className="v">{BD_PRIO[besoin.priorite]?.l || '—'}</span></div>
            </div>
          </div>
          {sourciaOn && diff.diffusion && <DiffusionContextCard diffusion={diff.diffusion} propCount={diff.propCount} onOpen={diff.openDraft} />}
          <FloatingPanels candidats={candidats} besoinId={besoin.id} BASE={BASE}
            onMrSync={(id, key, val) => setCandidats(prev => prev.map(c => c.id === id ? { ...c, [key]: val } : c))} />
        </div>

        {/* Zone de travail à onglets */}
        <div className="bd-main-panel">
          {/* Un onglet qui ne tient pas passe dans « Plus » : la barre ne
              coupe plus « Documents » au bord de l'écran (vécu 29.09). */}
          <BarreOnglets actif={besoinTab} onChoisir={setBesoinTab} onglets={[
            { key: 'candidats', icon: 'people-fill', label: 'Candidats', count: candidatsActifs.length },
            // L'onglet n'apparaît QUE s'il a quelque chose : un onglet à zéro
            // sur tous les besoins ferait chercher ce qui n'existe pas.
            ...(candidatsEcartes.length > 0 ? [{ key: 'ecartes', icon: 'send-slash', label: 'Profils écartés', count: candidatsEcartes.length }] : []),
            // Même règle pour les propositions : tant que le besoin n'est pas
            // diffusé, l'onglet ne dirait que « diffusez », ce que fait déjà le
            // bouton d'en-tête.
            ...(propositionsVisibles ? [{ key: 'propositions', icon: 'send', label: 'Propositions sourceurs', count: diff.propCount }] : []),
            { key: 'questions', icon: 'patch-question', label: 'Questions techniques', count: testQuestions.length },
            { key: 'brief', icon: 'journal-text', label: 'Brief & Notes' },
            { key: 'poste', icon: 'file-earmark-text', label: 'Fiche de poste' },
            // Le lot gagné, le client convoque : c'est un fait DU BESOIN, pas
            // de la fiche candidat — c'est ici qu'on suit qui est attendu, où
            // et quand.
            { key: 'entretiens', icon: 'calendar-check', label: 'Entretiens' },
            { key: 'documents', icon: 'folder2-open', label: 'Documents' },
          ]} />
          <div className="bd-work">
            {/* LA LISTE N'A PAS PU ÊTRE LUE EN ENTIER. Le serveur le dit, on
                l'affiche : un besoin qui montre moins de profils qu'il n'en
                porte ne se voit pas, et on repositionne par-dessus. */}
            {listePartielle && (
              <div className="bd-avert" role="status">
                <BI icon="exclamation-triangle" />
                <span>{listePartielle}</span>
              </div>
            )}
            {/* PROFILS ÉCARTÉS — les décisions prises, rangées à part. Ils ne
                sont pas cachés : la marque se lève d'un clic, et le motif est
                là pour qu'on sache POURQUOI avant de revenir dessus. */}
            {besoinTab === 'ecartes' && (
              <div className="bd-sect" style={{ padding: '18px' }}>
                <div className="flex items-center gap-3" style={{ marginBottom: '14px', flexWrap: 'wrap' }}>
                  <h2 className="bd-sect-title"><BI icon="send-slash" /> Profils écartés</h2>
                  <span className="bd-count">{candidatsEcartes.length}</span>
                </div>
                <p style={{ margin: '0 0 14px', fontSize: '12.5px', color: 'var(--text-2)', lineHeight: 1.55, maxWidth: '72ch' }}>
                  Ces profils ne partiront pas dans la livraison de ce dossier, même si leur lot est validé.
                  Chacun porte la raison de son refus. <b>Lever</b> le remet dans la liste des candidats, à sa place de classement.
                </p>
                {candidatsEcartes.length === 0 ? (
                  <p style={{ fontSize: '13px', color: 'var(--text-faint)' }}>Aucun profil écarté sur ce besoin.</p>
                ) : (
                  <div className="flex flex-col gap-2">
                    {candidatsEcartes.map((candidat, index) => (
                      <CandidatCard key={candidat.id} candidat={candidat} index={index} besoinId={besoin.id}
                        onBonAEnvoyer={(v) => marquerBonAEnvoyer(candidat, v)}
                        distinctions={distinctions} onCoupe={(cle) => poserCoupe(candidat, cle)}
                        onNePasEnvoyer={(o) => marquerNePasEnvoyer(candidat, o)}
                        matchInfo={matchInfoFor(candidat)} onEntretienEtat={onEntretienEtat}
                        expanded={expandedEcarteIdx === index}
                        onToggle={() => setExpandedEcarteIdx(expandedEcarteIdx === index ? null : index)}
                        flowStages={flowStages}
                        onUpdate={updateCandidat} onDelete={deleteCandidat} onUploadCV={uploadCVForCandidat}
                        onMatrixBesoin={besoin} onOpenCandidat={onOpenCandidat}
                        showNotification={showNotification} formatFileSize={formatFileSize}
                        sessionsRefreshKey={sessionsRefreshKey} />
                    ))}
                  </div>
                )}
              </div>
            )}

            {besoinTab === 'propositions' && sourciaOn && (
              <div className="bd-sect" style={{ padding: '18px' }}>
                <PropositionsTab
                  diffusion={diff.diffusion} proposals={diff.proposals}
                  audienceCount={diff.diffusion?.audience_count} busyPropId={diff.busyPropId}
                  onOpenDiff={diff.openDraft} onAccept={diff.accept} onReject={diff.reject}
                  onScore={diff.scoreProposal} onScoreAll={diff.scoreAllProposals}
                  scoringPropId={diff.scoringPropId} scoringAll={diff.scoringAll} />
              </div>
            )}
            {besoinTab === 'brief' && (<>
      <div className="bd-sect">
        <div className="bd-sect-head">
          <span className="bd-sect-title"><BI icon="pencil-square" /> Notes commerciales / RH
            <span className="bd-chip-accent">Interne</span>
          </span>
          <div className="flex items-center gap-3">
            {savingNotes && <span className="bd-saving">Sauvegarde…</span>}
            {!savingNotes && notesCommercial && <span className="bd-saved"><BI icon="check-lg" /> Sauvegardé</span>}
            <button onClick={() => setNotesFullscreen(true)} className="bd-link-mini" title="Agrandir en plein écran">
              <BI icon="arrows-fullscreen" /> Agrandir
            </button>
          </div>
        </div>
        <MentionTextarea
          value={notesCommercial}
          onChange={val => { setNotesCommercial(val); scheduleAutoSave('notes', () => saveNotes(val)); }}
          onBlur={() => saveNotes(notesCommercial)}
          onMention={async (user) => {
            // Créer notification pour l'utilisateur tagué
            try {
              await fetch(`${BASE}/notifications/inapp`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${APIService.getToken()}` },
                body: JSON.stringify({
                  user_id: user.id,
                  message: `📌 ${APIService.getCurrentUser()?.username} vous a mentionné dans les notes de "${besoin.titre}" (${besoin.client})`,
                  type: 'mention',
                  ref_type: 'besoin',
                  ref_id: besoin.id
                })
              });
            } catch(e) {}
          }}
          users={allUsers}
          placeholder="Notes internes : qualification client, budget, urgence... Tapez @ pour mentionner quelqu'un"
          rows={5}
          className="bd-textarea"
        />
      </div>

      {/* Candidats contactés */}
      <div className="bd-sect">
        <div className="bd-sect-head">
          <h2 className="bd-sect-title"><BI icon="telephone-fill" /> Candidats contactés</h2>
          <span className="bd-sect-hint">Noms, statuts, retours des candidats approchés</span>
        </div>
        <textarea value={candidatsContactes} onChange={e => { const v = e.target.value; setCandidatsContactes(v); scheduleAutoSave('contactes', () => saveContactes(v)); }}
          onBlur={e => saveContactes(e.target.value)} rows={4}
          placeholder="Ex: Jean Dupont — Intéressé, dispo juin&#10;Marie Martin — En poste, pas disponible avant sept..."
          className="bd-textarea" />
      </div>
            </>)}

            {besoinTab === 'entretiens' && (
              <BesoinEntretiens besoin={besoin} candidats={candidats} showNotification={showNotification} />
            )}

            {besoinTab === 'poste' && (
              <JDDocument besoin={besoin} showNotification={showNotification}
                onGeneratePDF={() => setShowJDModal(true)}
                onSourcingAuto={() => onUpdate?.()} />
            )}

            {besoinTab === 'documents' && (
      <div className="bd-sect" style={{ padding: '18px' }}>
        <div className="flex items-center justify-between" style={{ marginBottom: '14px' }}>
          <h2 className="bd-sect-title"><BI icon="folder2-open" /> Upload CVs</h2>
          <span className="bd-sect-hint">Formats : PDF, DOC, DOCX</span>
        </div>
        <div className={`bd-drop${dropCv ? ' is-drop' : ''}`}
          onDragOver={e => { e.preventDefault(); if (!uploadingFiles) setDropCv(true); }}
          onDragLeave={e => { e.preventDefault(); setDropCv(false); }}
          onDrop={e => { e.preventDefault(); setDropCv(false); if (!uploadingFiles) importerCvs(e.dataTransfer?.files); }}>
          <BI icon="cloud-upload" className="bd-drop-ico" />
          <div style={{ fontSize: '13.5px', fontWeight: 500, color: 'var(--text-2)', marginBottom: '3px' }}>Glissez-déposez vos CVs ici</div>
          <div style={{ fontSize: '12px', color: 'var(--text-faint)', marginBottom: '14px' }}>ou</div>
          <label className="bd-btn-primary" style={{ cursor: uploadingFiles ? 'not-allowed' : 'pointer', opacity: uploadingFiles ? 0.6 : 1, display: 'inline-flex' }}>
            <BI icon="file-earmark-text" />
            {uploadingFiles ? 'Analyse en cours…' : 'Parcourir'}
            <input type="file" multiple accept=".pdf,.doc,.docx" onChange={handleFileUpload} className="hidden" disabled={uploadingFiles} />
          </label>
        </div>
      </div>
            )}

            {besoinTab === 'questions' && (
      <TestQuestionsManager besoin={besoin} showNotification={showNotification} />
            )}

            {besoinTab === 'candidats' && (
      <div className="bd-sect" style={{ padding: '18px' }}>
        {/* flexWrap : quand la place manque, les boutons passent à la ligne au
            lieu d'être compressés (le bouton Scorer, en overflow hidden pour sa
            barre de progression, se faisait rogner le texte). */}
        <div className="flex items-center gap-3" style={{ marginBottom: '18px', flexWrap: 'wrap', rowGap: '8px' }}>
          <h2 className="bd-sect-title"><BI icon="people-fill" /> Candidats</h2>
          <span className="bd-count">{candidatsActifs.length}</span>
          {candidatsActifs.length > 0 && <>
            <span className="bd-ok-chip" title="Candidats validés"><BI icon="check-circle-fill" /> {candidatsActifs.filter(c=>c.valide).length}</span>
            {/* Le compteur « non validés » a été retiré (23.09) : « Candidats 21 »
                et « ✓ 0 » le disaient déjà — une soustraction affichée n'apprend
                rien. À sa place, ce que le moteur fait EN CE MOMENT. */}
            {scoringMatch && (() => {
              const noms = Object.values(scoreEnCours).filter(Boolean);
              return (
                <span className="bd-chip bd-chip--vivant" aria-live="polite"
                  title="Le moteur évalue ces profils en ce moment — chacun demande une lecture du CV">
                  <BI icon="arrow-repeat" className="bd-tourne" />
                  {noms.length === 0 ? 'Préparation…'
                    : noms.length === 1 ? noms[0]
                    : `${noms[0]} + ${noms.length - 1}`}
                </span>
              );
            })()}
            {appelsIaOn && testQuestions.length > 0 && (
              <BatchCallButton
                candidats={candidats}
                besoin={besoin}
                questions={testQuestions}
                showNotification={showNotification}
                onBatchComplete={() => setSessionsRefreshKey(k => k + 1)}
              />
            )}
            {matchModal && (
              <MatchingLancementModal titre="Matching de ce besoin" sousTitre={besoin.poste || besoin.titre || ''}
                besoinId={besoin.id}
                onClose={() => setMatchModal(false)} onLancer={(p) => scoreMatching(p)} />
            )}
            {scoresAjustes && !scoringMatch && (
              <span className="bd-mr-chip" style={{ background: 'rgba(217,119,6,0.12)', color: '#b45309', flex: 'none' }}
                title="Les scores affichés ont été calculés avec des poids ajustés pour ce lancement — pas les réglages par défaut de l'organisation.">
                <BI icon="sliders" /> Réglages ajustés
              </span>
            )}
            <button {...ancre('matching-lancer')} onClick={() => setMatchModal(true)} disabled={scoringMatch} className="bd-mini"
              style={{ position: 'relative', overflow: 'hidden', flex: 'none' }}
              title="Calculer le score de matching de chaque candidat sur ce besoin (moteur s9, cache partagé avec les Dossiers AO)">
              <BI icon={scoringMatch ? 'arrow-repeat' : 'stars'} style={scoringMatch ? { animation: 'ats-spin .8s linear infinite' } : undefined} />
              {scoringMatch
                ? <span className="ats-mono" style={{ fontVariantNumeric: 'tabular-nums' }}>
                    Scoring {scoreProg && scoreProg.total > 0 ? `${scoreProg.done}/${scoreProg.total}` : '…'}{scoreTick > 0 ? ` · ${scoreTick}s` : ''}
                  </span>
                : 'Scorer'}
              {/* Barre de progression : indéterminée (navette) tant qu'aucun résultat n'est
                  arrivé — chaque candidat = 1-3 appels IA, le 1er result peut mettre >1 min —
                  puis réelle (elle avance à chaque évènement result du flux NDJSON). */}
              {scoringMatch && (scoreProg && scoreProg.done > 0 && scoreProg.total > 0
                ? <span style={{ position: 'absolute', left: 0, bottom: 0, height: '2px', width: `${Math.round((scoreProg.done / scoreProg.total) * 100)}%`, background: 'var(--accent)', transition: 'width .25s ease' }} />
                : <span style={{ position: 'absolute', bottom: 0, height: '2px', width: '35%', background: 'var(--accent)', animation: 'bd-indet 1.2s ease-in-out infinite' }} />
              )}
            </button>
            {/* Le score PROPOSE, l'humain DISPOSE : ce bouton ÉCRIT le
                classement (le même que le glisser-déposer) à partir des scores
                déjà calculés. Pas de second ordre d'affichage concurrent —
                sinon deux listes différentes selon l'écran. */}
            <button onClick={classerParScore} disabled={scoringMatch || classementBusy} className="bd-mini" style={{ flex: 'none' }}
              title="Ranger les candidats du meilleur score au moins bon (écrit le classement — le glisser-déposer reste possible ensuite)">
              <BI icon={classementBusy ? 'arrow-repeat' : 'sort-numeric-down'} style={classementBusy ? { animation: 'ats-spin .8s linear infinite' } : undefined} /> Classer par score
            </button>
            {/* Diagnostic réservé à l'administration : compare le score IA au
                moteur local. Aucune de ces valeurs n'atterrit sur les écrans
                métier — un seul score fait foi pour les recruteurs. */}
            {adminScoring && (
              <button onClick={() => setCompareModal(true)} className="bd-mini" style={{ flex: 'none' }}
                title="Diagnostic administrateur : comparer le score IA au moteur de score local (classement, écarts, critère par critère)">
                <BI icon="bar-chart-steps" /> Comparer local / IA
              </button>
            )}
            {compareModal && (
              <ComparaisonScoresModal besoinId={besoin.id} besoinTitre={besoin.poste || besoin.titre || ''}
                showNotification={showNotification} onClose={() => setCompareModal(false)} />
            )}
          </>}
          {scanVivierOn && <button onClick={() => setShowScanVivier(true)} className="bd-btn" style={{ marginLeft: 'auto' }}
            title="Chercher les meilleurs profils de toute la base pour ce besoin">
            <BI icon="search" /> Trouver les meilleurs profils
          </button>}
          {/* Un seul bouton : « Ajouter un candidat » choisit dans la base OU
              importe un CV. « Proposer un candidat » faisait la même chose (la
              base seulement) et affichait, faute de score, un chiffre inventé. */}
          <button onClick={() => setShowAddCandidat(true)} className="bd-btn" style={scanVivierOn ? undefined : { marginLeft: 'auto' }}>
            <BI icon="person-plus" /> Ajouter un candidat
          </button>
        </div>

        {/* Suivi des entretiens du besoin — bâti sur les cartes réellement
            ouvertes. On dit sur combien il porte : un total partiel présenté
            comme un total ment. */}
        {(() => {
          const vus = Object.entries(entretiens);
          const propose = vus.filter(([, v]) => v === 'propose').length;
          const confirme = vus.filter(([, v]) => v === 'confirme').length;
          if (!propose && !confirme) return null;
          return (
            <div className="bd-entretiens-suivi" role="status">
              <BI icon="calendar-week" />
              <span>
                {confirme > 0 && <b>{confirme} entretien{confirme > 1 ? 's' : ''} confirmé{confirme > 1 ? 's' : ''}</b>}
                {confirme > 0 && propose > 0 && ' · '}
                {propose > 0 && <>{propose} en attente de réponse</>}
              </span>
              <em>sur {vus.length} candidat{vus.length > 1 ? 's' : ''} consulté{vus.length > 1 ? 's' : ''}</em>
            </div>
          );
        })()}

        {loading ? <div className="flex justify-center py-10"><div className="bd-spin" /></div>
        : candidatsActifs.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '48px 0', color: 'var(--text-faint)' }}>
            <div style={{ fontSize: '42px', marginBottom: '12px' }}><BI icon="people" /></div>
            <h3 style={{ fontSize: '14px', fontWeight: 600, color: 'var(--text-2)', margin: '0 0 3px' }}>
              {candidatsEcartes.length > 0 ? 'Tous les profils sont écartés' : 'Aucun candidat ajouté'}
            </h3>
            {/* « Aucun candidat » et « tous écartés » ne se corrigent pas de la
                même façon : dire le premier quand c'est le second envoie
                chercher des CV alors qu'il y a des décisions à relire. */}
            <p style={{ fontSize: '13px', margin: 0 }}>
              {candidatsEcartes.length > 0
                ? <>Les {candidatsEcartes.length} profils de ce besoin sont dans l'onglet <b>Profils écartés</b>, avec leur motif.</>
                : 'Uploadez des CVs pour commencer'}
            </p>
          </div>
        ) : (
          <div {...ancre('besoin-candidats')} className="flex flex-col gap-2">
            {/* Les écartés ont leur onglet : ils ne prennent plus de rang ici,
                et le classement redevient celui des profils qui peuvent partir. */}
            {candidatsActifs.map((candidat, index) => (
              <div key={candidat.id}
                onDragOver={e => { if (rangDrag != null) { e.preventDefault(); setRangSurvol(candidat.id); } }}
                onDrop={e => { if (rangDrag != null) { e.preventDefault(); deposerRang(candidat.id); } }}
                style={{ borderTop: rangSurvol === candidat.id && rangDrag !== candidat.id
                  ? '2px solid var(--accent)' : '2px solid transparent', transition: 'border-color .12s' }}>
              <CandidatCard candidat={candidat} index={index} besoinId={besoin.id}
                rang={index + 1} total={candidatsActifs.length}
                onRangDragStart={() => setRangDrag(candidat.id)}
                onRangDragEnd={() => { setRangDrag(null); setRangSurvol(null); }}
                onBonAEnvoyer={(v) => marquerBonAEnvoyer(candidat, v)}
                distinctions={distinctions} onCoupe={(cle) => poserCoupe(candidat, cle)}
                onNePasEnvoyer={(o) => marquerNePasEnvoyer(candidat, o)}
                matchInfo={matchInfoFor(candidat)} onEntretienEtat={onEntretienEtat}
                enEvaluation={!!(scoreEnCours[String(candidat.id)] || scoreEnCours[String(candidat.candidate_id)])}
                expanded={expandedCandIdx === index}
                onToggle={() => setExpandedCandIdx(expandedCandIdx === index ? null : index)}
                flowStages={flowStages}
                onUpdate={updateCandidat} onDelete={deleteCandidat} onUploadCV={uploadCVForCandidat}
                onStartTest={testsOn ? (() => setTestSession({ candidat, questions: testQuestions })) : undefined}
                onCallAgent={appelsIaOn ? { besoin, questions: testQuestions, onComplete: () => setSessionsRefreshKey(k => k + 1), onSchedule: (cand) => setScheduleModal(cand) } : undefined}
                onMatrixBesoin={besoin} onOpenCandidat={onOpenCandidat}
                onPrepareCv={canCvPrep && (candidat.canonical_candidate_id ?? candidat.candidate_id) != null ? (() => setCvPrepFor(candidat)) : undefined}
                showNotification={showNotification} formatFileSize={formatFileSize}
                sessionsRefreshKey={sessionsRefreshKey}
                piecesRefreshAll={piecesRefreshAll} />
              </div>
            ))}
          </div>
        )}

        {/* Le marquage « Prêt à envoyer » vit désormais dans chaque ligne candidat
            (verrouillé tant que la checklist Market Ready n'est pas complète). */}
      </div>
            )}
          </div>
        </div>
      </div>

      {showJDModal && (
        <JDGeneratorModal onClose={() => setShowJDModal(false)} showNotification={showNotification}
          initialData={{ titre: besoin.titre, client: besoin.client, contenu: besoin.description || '', responsable: typeof besoin.responsable === 'string' ? besoin.responsable : (besoin.responsable ? nomUtilisateur(besoin.responsable) : '') }} />
      )}

      {showAddCandidat && (
        <AddCandidatModal besoin={besoin} onClose={() => setShowAddCandidat(false)}
          dejaSur={new Set(candidats.map(c => Number(c.canonical_candidate_id ?? c.candidate_id)).filter(Number.isFinite))}
          onUploadFiles={importerCvs} onAttach={attachExistingCandidat} showNotification={showNotification} />
      )}

      {showScanVivier && (
        <ScanVivier besoin={besoin} theme={theme} showNotification={showNotification}
          onClose={() => setShowScanVivier(false)}
          onOpenCandidat={onOpenCandidat}
          onPositioned={() => { loadCandidats(); onUpdate?.(); }} />
      )}

      {sourciaOn && diff.draftOpen && (
        <DiffusionModal besoin={besoin} diffusion={diff.diffusion} audiences={diff.audiences} saving={diff.saving}
          onClose={diff.closeDraft} onPublish={diff.publish} onUnpublish={diff.unpublish} />
      )}

      {cvPrepFor && (
        <CVPrep candidateId={cvPrepFor.canonical_candidate_id ?? cvPrepFor.candidate_id} besoinId={besoin.id}
          positions={[{ besoin_id: besoin.id, besoin_titre: besoin.titre, client: besoin.client }]}
          theme={theme} showNotification={showNotification} onClose={() => setCvPrepFor(null)} />
      )}

      {dupPrompt && (
        <DuplicateCandidateModal prompt={dupPrompt} busy={uploadingFiles}
          onClose={() => setDupPrompt(null)}
          onMerge={(m) => { const p = dupPrompt; setDupPrompt(null); mergeIntoExisting(m, p.file); }}
          onCreate={() => { const p = dupPrompt; setDupPrompt(null); createFromCv(p.file, p.cvInfo); }} />
      )}

      {testSession && testSession.questions.length > 0 && (
        <TestSession candidat={testSession.candidat} besoin={besoin} questions={testSession.questions}
          onClose={() => setTestSession(null)}
          onComplete={result => { const cand = testSession.candidat; setTestSession(null); setTestReport({ result, candidat: cand }); setSessionsRefreshKey(k => k + 1); }}
          showNotification={showNotification} />
      )}

      {testReport && (
        <TestReport result={testReport.result} candidat={testReport.candidat} besoin={besoin}
          onClose={() => setTestReport(null)} />
      )}
      {scheduleModal && (
        <ScheduleCallModal
          candidat={scheduleModal}
          besoin={besoin}
          questions={testQuestions}
          onClose={() => setScheduleModal(null)}
          onScheduled={() => { setScheduleRefresh(k => k + 1); setScheduleModal(null); }}
        />
      )}
    </div>
  );
};

// ===== ROUTING — une URL par écran (le bouton Précédent du navigateur fonctionne) =====
const VIEW_PATHS = {
  list: '/besoins',
  kanban: '/pipeline',
  vivier: '/vivier',
  candidats: '/candidats',
  dossiers: '/dossiers',
  sourceur: '/sourceur',
  crm: '/crm',
  calendrier: '/calendrier',
  // `qualifications` manquait : `setCurrentView` retombe sur '/besoins' quand
  // la vue n'a pas de chemin, et `pathToView` ne sait alors pas relire
  // '/qualifications'. L'entrée de la barre latérale ne menait donc nulle
  // part, et l'écran ne s'affichait JAMAIS — troisième fois que ce trou se
  // paie (roadmap, clients, celui-ci) : scripts/check-view-paths.js le refuse
  // désormais au build.
  qualifications: '/qualifications',
  documents: '/documents',
  'liste-noire': '/liste-noire',
  // Le journal d'activité : administrateurs (règle serveur).
  journal: '/journal-activite',
  propositions: '/propositions',
  forms: '/forms',
  ressources: '/ressources',
  tatlease: '/gestion-de-flotte',
  'me-cra': '/mon-espace',
  'me-conges': '/mon-espace/conges',
  'me-frais': '/mon-espace/frais',
  'me-docs': '/mon-espace/documents',
  marketplace: '/marketplace',
  config: '/config',
  // ÉDITEUR — hors de la navigation du client. `roadmap` n'était PAS ici :
  // `setCurrentView` retombe sur '/besoins' quand la vue n'a pas de chemin,
  // et l'entrée de la barre latérale ne menait donc nulle part.
  roadmap: '/roadmap',
  clients: '/clients',
  sonde: '/sonde',
  import: '/import',
};
const pathToView = (pathname) => {
  if (/^\/besoins\/[^/]+$/.test(pathname)) return 'detail';
  if (/^\/candidats\/[^/]+$/.test(pathname)) return 'candidats';
  if (/^\/dossiers\/[^/]+$/.test(pathname)) return 'dossiers';
  if (/^\/sourceur\/[^/]+$/.test(pathname)) return 'sourceur';
  if (/^\/ressources\/[^/]+$/.test(pathname)) return 'ressources';
  if (/^\/crm\/factures\/[^/]+$/.test(pathname)) return 'crm';
  const found = Object.keys(VIEW_PATHS).find(v => VIEW_PATHS[v] === pathname);
  return found || 'list';
};

/* TUTORIELS GUIDÉS — la bannière, la bulle et le panneau. Composant séparé
   parce qu'il lit le contexte : il doit vivre SOUS le provider. Rien ne
   s'affiche tant que le serveur n'a pas répondu, et rien du tout si la route
   n'existe pas encore. */
function TutorielCoque() {
  const tuto = useTutoriel();
  if (!tuto?.disponible) return null;
  return (<>
    <TutorielBanniere tuto={tuto} />
    {tuto.actif && <TutorielBulle tuto={tuto} />}
    <TutorielPanneau tuto={tuto} />
  </>);
}

// ===== APP =====
function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [connecting, setConnecting] = useState(false);   // balayage rouge de connexion
  const [logoutPhase, setLogoutPhase] = useState(null);  // 'in' | 'out' | null — balayage de déconnexion
  const [currentUser, setCurrentUser] = useState(null);
  const [organisation, setOrganisation] = useState(() => APIService.getOrganisation());
  // currentView dérivé de l'URL ; setCurrentView devient une navigation (crée une entrée d'historique)
  const currentView = pathToView(location.pathname);
  const setCurrentView = (view) => navigate(VIEW_PATHS[view] || '/besoins');
  const besoinIdFromPath = (location.pathname.match(/^\/besoins\/([^/]+)$/) || [])[1];
  const candidatIdFromPath = (location.pathname.match(/^\/candidats\/([^/]+)$/) || [])[1];
  const aoIdFromPath = (location.pathname.match(/^\/dossiers\/([^/]+)$/) || [])[1];
  const sourceurBesoinIdFromPath = (location.pathname.match(/^\/sourceur\/([^/]+)$/) || [])[1];
  // /ressources/:id — la fiche d'une ressource a maintenant son URL, comme le
  // besoin et le dossier AO. Sans elle, le CRM pouvait montrer une ressource
  // sans aucun moyen d'ouvrir sa fiche : on voyait son nom, ses missions, et
  // c'était un cul-de-sac.
  const ressourceIdFromPath = (location.pathname.match(/^\/ressources\/([^/]+)$/) || [])[1];
  // Facture ouverte par lien profond (/crm/factures/:id) — depuis la
  // facturation d'un CRA ou une notification.
  const crmFactureIdFromPath = (location.pathname.match(/^\/crm\/factures\/([^/]+)$/) || [])[1];
  const [theme, setTheme] = useState(() => { try { return localStorage.getItem('ats-theme') || 'light'; } catch { return 'light'; } });
  const toggleTheme = () => setTheme(t => { const n = t === 'dark' ? 'light' : 'dark'; try { localStorage.setItem('ats-theme', n); } catch {} return n; });
  useEffect(() => { try { document.documentElement.setAttribute('data-theme', theme); } catch {} }, [theme]);

  // Bloquer le scroll vertical de la page sur les boards
  useEffect(() => {
    const isBoardView = currentView === 'kanban' || currentView === 'vivier';
    document.body.style.overflow = isBoardView ? 'hidden' : '';
    document.documentElement.style.overflow = isBoardView ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    };
  }, [currentView]);
  const [selectedBesoin, setSelectedBesoin] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [createBesoinClient, setCreateBesoinClient] = useState('');
  const openCreateBesoin = (client = '') => { setCreateBesoinClient(String(client || '')); setShowCreateModal(true); };
  const [showJDModal, setShowJDModal] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [inAppNotifs, setInAppNotifs] = useState([]);
  const [notifCount, setNotifCount] = useState(0);

  const notifAuth = () => ({ Authorization: `Bearer ${APIService.getToken()}` });
  // Nombre max de notifications chargées/affichées — réglable dans Config
  // (clé org notif_inapp.max, défaut 10). Ref : loadNotifList reste stable.
  const notifMaxRef = React.useRef(10);
  const loadNotifList = React.useCallback(async () => {
    try {
      const max = notifMaxRef.current;
      const r = await fetch(`${BASE}/notifications/inapp?limit=${max}`, { headers: notifAuth() });
      if (r.ok) {
        const j = await r.json();
        const arr = j.data || j.notifications || (Array.isArray(j) ? j : []);
        // slice en secours : si le backend ignore ?limit, on n'affiche que les N dernières
        setInAppNotifs(Array.isArray(arr) ? arr.slice(0, max) : []);
      }
    } catch {}
  }, []);

  // Badge : endpoint dédié léger, poll ~60 s. Liste : au montage + à chaque action.
  useEffect(() => {
    if (!isLoggedIn) return;
    const fetchCount = async () => {
      try { const r = await fetch(`${BASE}/notifications/inapp/unread-count`, { headers: notifAuth() }); if (r.ok) { const j = await r.json(); setNotifCount(j.count ?? j.data?.count ?? 0); } } catch {}
    };
    fetchCount(); loadNotifList();
    // Valeur org du max (GET /config, admin ou lecture autorisée) — silencieux
    // sinon : le défaut 10 reste. Rechargement si la valeur diffère.
    (async () => {
      try {
        const r = await fetch(`${BASE}/config`, { headers: notifAuth() });
        if (!r.ok) return;
        const j = await r.json().catch(() => ({}));
        const m = parseInt(j.notif_inapp?.max, 10);
        if (m > 0 && m !== notifMaxRef.current) { notifMaxRef.current = m; loadNotifList(); }
      } catch {}
    })();
    const interval = setInterval(fetchCount, 60000);
    return () => clearInterval(interval);
  }, [isLoggedIn, loadNotifList]);

  const markNotifRead = async (id) => {
    try {
      await fetch(`${BASE}/notifications/inapp/${id}/read`, { method: 'PUT', headers: notifAuth() });
      setInAppNotifs(prev => prev.map(n => n.id === id ? { ...n, lu: true, read: true } : n));
      setNotifCount(c => Math.max(0, c - 1));
    } catch {}
  };
  // Où mène une notification : chemin + libellé du lien, ou null quand le clic
  // n'ouvrirait rien — le lien de la sidebar ne promet alors rien. Les
  // notifications du Sourceur (« Numéro récupéré… fiche à créer depuis l'écran
  // Sourceur ») pointent l'ÉCRAN Sourceur : la fiche n'existe pas encore,
  // c'est là-bas que l'action se fait. Tant que le back n'envoie pas de
  // ref_type dédié pour elles, le texte du message sert de repli.
  const destinationNotif = (n) => {
    const type = n?.ref_type || n?.refType || '';
    const rid = n?.ref_id ?? n?.refId;
    // Un paquet de profils proposés : il se trie sur son écran, ouvert sur
    // le bon besoin. Avant « besoin » : la notification porte l'id du besoin.
    if (/proposition/i.test(type)) return { path: `/propositions${rid != null ? `?besoin=${rid}` : ''}`, label: 'Trier les profils →' };
    if (rid != null && /candidat/i.test(type)) return { path: `/candidats/${rid}`, label: 'Ouvrir la fiche →' };
    if (rid != null && /besoin/i.test(type)) return { path: `/besoins/${rid}`, label: 'Ouvrir la fiche →' };
    if (/ressource/i.test(type)) return { path: '/ressources', label: 'Ouvrir les ressources →' };
    // L'écran Sourceur est réservé aux admins : pour les autres comptes, la
    // notification reste lisible mais ne promet pas un lien qui n'ouvre rien.
    if (sourceurOn && (/sourc|linkedin/i.test(type) || /[ée]cran sourceur/i.test(n?.message || n?.text || n?.body || ''))) {
      return { path: '/sourceur', label: 'Ouvrir l’écran Sourceur →' };
    }
    return null;
  };
  // Clic sur une notification : marque lu + navigue vers sa destination.
  const openNotif = (n) => {
    if (n?.id != null && !(n.lu || n.read)) markNotifRead(n.id);
    const dest = destinationNotif(n);
    if (dest) navigate(dest.path);
  };

  const unreadCount = notifCount || inAppNotifs.filter(n => !(n.lu || n.read)).length;

  useEffect(() => {
    if (APIService.isAuthenticated()) { const user = APIService.getCurrentUser(); setCurrentUser(user); setOrganisation(APIService.getOrganisation()); setIsLoggedIn(true); }
  }, []);

  // Le profil stocké date de la connexion : un droit accordé depuis (ici
  // super_admin, qui ouvre la Roadmap) n'apparaîtrait qu'à la reconnexion
  // suivante. On relit /auth/me au démarrage et on ne reprend QUE ces champs —
  // tolérant : une route absente ou un refus ne change rien à l'écran.
  // Relu AUSSI quand on revient sur l'onglet : un rôle se change dans une
  // autre fenêtre (celle de l'administrateur), et c'est en revenant ici
  // qu'on s'attend à le voir.
  const [relireProfil, setRelireProfil] = useState(0);
  useEffect(() => {
    const auRetour = () => { if (document.visibilityState === 'visible') setRelireProfil(n => n + 1); };
    document.addEventListener('visibilitychange', auRetour);
    return () => document.removeEventListener('visibilitychange', auRetour);
  }, []);
  useEffect(() => {
    if (!isLoggedIn) return;
    let annule = false;
    (async () => {
      try {
        // Sans session, on ne demande pas : un appel authentifié sans jeton
        // n'apprend rien et remplit le journal serveur de refus (25.09).
        const jeton = APIService.getToken();
        if (!jeton) return;
        const r = await fetch(`${BASE}/auth/me`, { headers: { Authorization: `Bearer ${jeton}` } });
        if (!r.ok) return;
        const j = await r.json();
        if (annule || !j?.user) return;
        // Les champs de RÔLE relus : ce sont ceux qu'un administrateur peut
        // accorder ou retirer pendant qu'on est connecté. Sans cette relecture,
        // accorder « business manager » à quelqu'un ne changeait rien à son
        // écran tant qu'il ne se déconnectait pas — et personne ne fait le
        // rapprochement. Les autres champs du profil stocké ne bougent pas.
        //
        // ADMIN en fait partie (24.09 : « Admin requis — pourquoi j'ai ça en
        // tant qu'admin ? »). Il n'était PAS relu : le menu Config suivait le
        // rôle du jour de la connexion, le serveur celui d'aujourd'hui. Un
        // rôle retiré laissait des écrans que chaque clic refusait ; un rôle
        // accordé n'ouvrait rien avant la reconnexion.
        const frais = {
          admin: j.user.admin === true,
          recruteuse: j.user.recruteuse === true,
          super_admin: j.user.super_admin === true,
          business_manager: j.user.business_manager === true,
          ...(Array.isArray(j.user.roles) ? { roles: j.user.roles } : {}),
        };
        setCurrentUser(prev => {
          if (!prev) return prev;
          // `role` (le résumé que certains écrans lisent) suit, calculé comme
          // à la connexion — seulement s'il en vient : un rôle d'un autre
          // registre n'est pas écrasé.
          if (['admin', 'ressource', 'recruteuse', 'user'].includes(prev.role)) {
            frais.role = frais.admin ? 'admin' : (j.user.ressource === true ? 'ressource' : (frais.recruteuse ? 'recruteuse' : 'user'));
          }
          const change = Object.keys(frais).some(k => JSON.stringify(prev[k]) !== JSON.stringify(frais[k]));
          if (!change) return prev;
          const suivant = { ...prev, ...frais };
          try { localStorage.setItem('user', JSON.stringify(suivant)); } catch { /* stockage plein ou bloqué */ }
          return suivant;
        });
      } catch { /* hors ligne : on garde le profil stocké */ }
    })();
    return () => { annule = true; };
  }, [isLoggedIn, relireProfil]);

  // Le rôle Administrateur retiré pendant qu'on est sur la configuration : on
  // en sort en le DISANT, plutôt que de laisser une page blanche — ou des
  // écrans dont chaque bouton répondrait « réservé aux administrateurs ».
  useEffect(() => {
    if (currentView === 'config' && currentUser && currentUser.admin === false) {
      navigate('/besoins');
      showNotification("La configuration est réservée aux administrateurs, et votre compte n'a pas (ou plus) ce rôle.", 'error');
    }
  }, [currentView, currentUser]); // eslint-disable-line react-hooks/exhaustive-deps

  const removeNotification = useCallback((id) => setNotifications(prev => prev.filter(n => n.id !== id)), []);
  const showNotification = useCallback((message, type = 'success', options = {}) => {
    const id = Date.now() + Math.random();
    setNotifications(prev => [...prev.slice(-3), { id, message, type, ...options }]);
  }, []);

  // Feature flags de l'organisation : chargés à la connexion ; un 403
  // feature_disabled (onglet resté ouvert pendant une bascule) affiche le
  // message backend tel quel et recharge les flags.
  const agentChatOn = useFeature('agent_chat');
  const cvPrepOn = useFeature('cv_prep');
  // Écran Sourceur (campagnes LinkedIn) : opt-in, entrée de menu + route masquées
  // tant que le flag n'est pas activé — et réservé aux ADMINS : les autres
  // comptes ne le voient pas. Ce masquage est du confort d'interface ; la
  // protection réelle reste le 403 du serveur sur /sourcing.
  const sourceurOn = useFeatureOptIn('sourcing_linkedin') && isAoAdmin(APIService.getCurrentUser());
  // Brique Ressources/Timesheet : app Marketplace (état org, sans bypass admin).
  // NB : « Mon espace » des consultants reste piloté par le RÔLE ressource — un
  // compte lié garde son espace même si l'écran manager est masqué.
  // Droits par utilisateur : app activée au Marketplace ET non retirée à ce
  // user (Config → Utilisateurs → Modules). Admin : toujours tout.
  const ressourcesOn = useFeatureApp('ressources') && moduleAllowed(currentUser, 'ressources');
  // CRM (clients & missions) : app Marketplace « crm ».
  const crmOn = useFeatureApp('crm') && moduleAllowed(currentUser, 'crm');
  // Forms : son propre drapeau, activé par défaut côté serveur.
  const formsOn = useFeatureApp('forms') && moduleAllowed(currentUser, 'forms');
  // Gestion de flotte (TATLease) : app Marketplace « tatlease ».
  const tatleaseOn = useFeatureApp('tatlease') && moduleAllowed(currentUser, 'tatlease');
  // Rôle « ressource » (consultant) : l'app se réduit à « Mon espace ».
  const isResource = currentUser?.role === 'ressource' || currentUser?.ressource === true;
  // Pile de fiches candidat ouvertes par l'assistant IA (aperçus empilés, non-modal).
  const [previewStack, setPreviewStack] = useState([]);
  const openCandidatPreview = useCallback((id, meta = {}) => {
    if (id == null) return;
    setPreviewStack(prev => prev.some(s => String(s.id) === String(id)) ? prev : [...prev, { id, ...meta }]);
  }, []);
  useEffect(() => { installFeatureDisabledInterceptor(); }, []);
  useEffect(() => { if (isLoggedIn) loadFeatures(); }, [isLoggedIn]);
  useEffect(() => {
    // Dédoublonnage : un écran peut déclencher plusieurs appels vers des endpoints
    // coupés en parallèle → un seul toast par message identique dans la fenêtre.
    let lastDisabled = { msg: '', at: 0 };
    const onDisabled = (e) => {
      // scope: 'user' = module retiré à CE compte (Config → Utilisateurs →
      // Modules), pas une désactivation org — le message le dit clairement.
      const msg = e.detail?.error || (e.detail?.scope === 'user'
        ? 'Cette fonctionnalité a été retirée pour votre compte.'
        : 'Fonctionnalité désactivée pour votre organisation.');
      const now = Date.now();
      if (msg === lastDisabled.msg && now - lastDisabled.at < 5000) return;
      lastDisabled = { msg, at: now };
      showNotification(msg, 'error');
    };
    window.addEventListener('erpia:feature-disabled', onDisabled);
    // Compte désactivé pendant la session (401 account_disabled) → déconnexion + retour login.
    const onAccountDisabled = (e) => {
      showNotification(e.detail?.error || 'Votre compte a été désactivé.', 'error');
      APIService.logout(); setCurrentUser(null); setOrganisation(null); setIsLoggedIn(false); setSelectedBesoin(null); navigate('/besoins');
    };
    window.addEventListener('erpia:account-disabled', onAccountDisabled);
    return () => { window.removeEventListener('erpia:feature-disabled', onDisabled); window.removeEventListener('erpia:account-disabled', onAccountDisabled); };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // TEASING D'ENTRÉE — une seule fois par personne et par version. Décidé
  // ICI, au moment où la personne arrive (connexion, ou session retrouvée au
  // chargement), pas à chaque rendu : `teaser` ne repasse jamais à true.
  const [teaser, setTeaser] = useState(null); // { apresBalayage } | null
  useEffect(() => {
    if (!isLoggedIn || !currentUser?.id || teaser !== null) return;
    if (!teaserDejaVu(currentUser.id)) setTeaser({ apresBalayage: connecting });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn, currentUser?.id]);

  const handleLogin = (user, org) => {
    setCurrentUser(user); setOrganisation(org || APIService.getOrganisation()); setIsLoggedIn(true);
    setConnecting(true); setTimeout(() => setConnecting(false), 1550); // balayage rouge « erpia. » (couvre puis révèle)
    showNotification(`Bienvenue ${user.username} !`, 'success');
  };
  const handleLogout = () => {
    if (logoutPhase) return;
    setLogoutPhase('in'); // balayage entre (« À bientôt. »)
    setTimeout(() => {
      APIService.logout(); setCurrentUser(null); setOrganisation(null); setIsLoggedIn(false); setSelectedBesoin(null); navigate('/besoins');
      setLogoutPhase('out'); // puis balayage sort, révèle le login
      setTimeout(() => setLogoutPhase(null), 620);
    }, 560);
  };

  const handleSelectBesoin = async besoin => {
    try {
      const full = await APIService.getBesoin(besoin.id);
      setSelectedBesoin(full);
      navigate(`/besoins/${besoin.id}`);
    } catch { showNotification('Erreur chargement du besoin', 'error'); }
  };

  // Retour depuis le détail : revient à l'écran précédent (pipeline ou liste), sinon la liste
  const handleDetailBack = () => {
    if (location.key && location.key !== 'default') navigate(-1);
    else navigate('/besoins');
  };

  const handleDeleteBesoin = async besoin => {
    if (!await confirmErpia({ message: `Supprimer le besoin "${besoin.titre}" ?` })) return;
    try {
      await APIService.deleteBesoin(besoin.id);
      showNotification(`Besoin "${besoin.titre}" supprimé`, 'success');
      if (selectedBesoin?.id === besoin.id) { setSelectedBesoin(null); navigate('/besoins'); }
      setRefreshKey(k => k + 1);
    } catch (error) { showNotification(error.message || 'Erreur suppression', 'error'); }
  };

  const handleBesoinUpdate = async () => {
    if (selectedBesoin) {
      try { setSelectedBesoin(await APIService.getBesoin(selectedBesoin.id)); } catch {}
    }
  };

  // Canonicalise "/" → "/besoins" (ou "/mon-espace" pour une ressource — qui
  // n'a accès à AUCUN autre écran : toute autre URL y est ramenée).
  useEffect(() => {
    if (!isLoggedIn) return;
    if (isResource) {
      if (!location.pathname.startsWith('/mon-espace')) navigate('/mon-espace', { replace: true });
      return;
    }
    if (location.pathname === '/') navigate('/besoins', { replace: true });
  }, [isLoggedIn, isResource, location.pathname, navigate]);

  // Charge le besoin depuis l'URL (lien direct, refresh, navigation arrière/avant du navigateur)
  useEffect(() => {
    if (!isLoggedIn || !besoinIdFromPath) return;
    if (selectedBesoin && String(selectedBesoin.id) === String(besoinIdFromPath)) return;
    let cancelled = false;
    APIService.getBesoin(besoinIdFromPath)
      .then(b => { if (!cancelled) setSelectedBesoin(b); })
      .catch(() => { if (!cancelled) { showNotification('Erreur chargement du besoin', 'error'); navigate('/besoins', { replace: true }); } });
    return () => { cancelled = true; };
  }, [isLoggedIn, besoinIdFromPath, selectedBesoin, navigate]);

  // Balayage rouge de connexion / déconnexion (design v2)
  const sweep = (connecting || logoutPhase) ? (
    <div style={{ position: 'fixed', inset: 0, zIndex: 4000, background: '#E2231A', display: 'flex', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none',
      animation: connecting ? 'loginReveal 1.5s cubic-bezier(.65,0,.35,1) forwards'
        : logoutPhase === 'in' ? 'logoutIn .55s cubic-bezier(.65,0,.35,1) forwards'
          : 'logoutOut .6s cubic-bezier(.65,0,.35,1) forwards' }}>
      {logoutPhase ? <span style={{ color: '#fff', fontFamily: "'Archivo',sans-serif", fontSize: 'clamp(40px,6vw,84px)', fontWeight: 900, letterSpacing: '-0.04em' }}>À bientôt<span style={{ color: '#0c0d10' }}>.</span></span> : <ErpiaBrand variant="sweep" />}
    </div>
  ) : null;

  // Route publique (hors auth) : questionnaire candidat via lien à token.
  // Le lien envoyé par email est sans hash (/questionnaire/:token) → on regarde
  // aussi le vrai chemin, pas seulement la route hash.
  const qToken = (location.pathname.match(/^\/questionnaire\/([^/]+)$/) || [])[1]
    || (typeof window !== 'undefined' && (window.location.pathname.match(/^\/questionnaire\/([^/]+)$/) || [])[1]);
  if (qToken) return <QuestionnairePage token={qToken} />;

  // Route publique (hors auth) : validation de CV par le candidat via lien à token.
  const cvToken = (location.pathname.match(/^\/cv-validation\/([^/]+)$/) || [])[1]
    || (typeof window !== 'undefined' && (window.location.pathname.match(/^\/cv-validation\/([^/]+)$/) || [])[1]);
  if (cvToken) return <CVValidationPage token={cvToken} />;

  // Route publique (hors auth) : fiche de poste partagée (erpia.ch/jd/:token).
  const jdToken = (location.pathname.match(/^\/jd\/([^/]+)$/) || [])[1]
    || (typeof window !== 'undefined' && (window.location.pathname.match(/^\/jd\/([^/]+)$/) || [])[1]);
  if (jdToken) return <PublicJDPage token={jdToken} />;

  // Route publique (hors auth) : la page « Postuler » d'une annonce
  // (erpia.ch/postuler/:token) — le candidat n'a pas de compte.
  const annonceToken = (location.pathname.match(/^\/postuler\/([^/]+)$/) || [])[1]
    || (typeof window !== 'undefined' && (window.location.pathname.match(/^\/postuler\/([^/]+)$/) || [])[1]);
  if (annonceToken) return <PublicAnnonce token={annonceToken} />;

  // Route publique (hors auth) : le candidat relit SON CV au format entreprise
  // et valide, corrige ou refuse les ajouts du recruteur
  // (erpia.ch/valider-cv/:jeton) — sans compte, lien qui expire.
  const validerCvJeton = (location.pathname.match(/^\/valider-cv\/([^/]+)$/) || [])[1]
    || (typeof window !== 'undefined' && (window.location.pathname.match(/^\/valider-cv\/([^/]+)$/) || [])[1]);
  if (validerCvJeton) return <PublicValiderCv jeton={validerCvJeton} />;

  // Route publique (hors auth) : formulaire à remplir en ligne
  // (erpia.ch/formulaire/:token) — la personne n'a pas de compte.
  const formToken = (location.pathname.match(/^\/formulaire\/([^/]+)$/) || [])[1]
    || (typeof window !== 'undefined' && (window.location.pathname.match(/^\/formulaire\/([^/]+)$/) || [])[1]);
  if (formToken) return <PublicFormulaire token={formToken} />;

  // Route publique (hors auth) : choix d'un créneau d'entretien
  // (erpia.ch/entretien/:token) — le candidat n'a pas de compte.
  const rdvToken = (location.pathname.match(/^\/entretien\/([^/]+)$/) || [])[1]
    || (typeof window !== 'undefined' && (window.location.pathname.match(/^\/entretien\/([^/]+)$/) || [])[1]);
  if (rdvToken) return <PublicEntretien token={rdvToken} />;

  if (!isLoggedIn) return <>{sweep}<LoginPage onLogin={handleLogin} /></>;

  return (
    // Les traitements CV vivent au-dessus du commutateur de vues : une
    // génération réduite en pastille survit à un changement d'écran.
    <TraitementsCvProvider showNotification={showNotification}>
    {/* TUTORIELS GUIDÉS — autour de la coque connectée seulement : ni sur
        l'écran de connexion, ni pour un consultant placé (son espace n'est pas
        couvert). Le provider tolère l'absence des routes : rien ne s'affiche,
        rien ne casse, rien n'est écrit. */}
    <TutorielProvider currentView={currentView} onNaviguer={navigate} actif={!isResource}>
    <div data-theme={theme} className="app-shell" style={{ color: 'var(--text)', fontFamily: "'IBM Plex Sans', system-ui, sans-serif", display: 'flex', flexDirection: 'row', minHeight: '100vh' }}>
      {sweep}
      {/* La session se ferme dans cinq minutes : on le DIT, avec le geste qui
          l'empêche. Sans ça on l'apprend en cliquant Enregistrer. */}
      <SessionQuiSeFerme actif={isLoggedIn} />
      {/* Le teasing vit SOUS le balayage rouge (z 3900 < 4000) : le balayage
          se retire et le révèle, comme un rideau. */}
      {teaser && teaser !== 'fini' && <BienvenueTeaser user={currentUser} apresBalayage={teaser.apresBalayage} onFin={() => setTeaser('fini')} />}
      <AtsSidebar
        currentView={currentView}
        setCurrentView={setCurrentView}
        currentUser={currentUser}
        organisation={organisation}
        onLogout={handleLogout}
        theme={theme}
        onToggleTheme={toggleTheme}
        inAppNotifs={inAppNotifs}
        unreadCount={unreadCount}
        onMarkAllRead={async () => {
          await fetch(`${BASE}/notifications/inapp/read-all`, { method: 'PUT', headers: notifAuth() });
          setInAppNotifs(prev => prev.map(n => ({ ...n, lu: true, read: true }))); setNotifCount(0);
        }}
        onMarkRead={markNotifRead}
        onOpenNotif={openNotif}
        notifDest={destinationNotif}
      />
 
      {/* Contenu principal — occupe le reste à droite de la sidebar
          (sous 820px : sous la barre supérieure mobile, hauteur via .erp-main) */}
      <div className="erp-main" style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
        <TutorielCoque />
        {(currentView === 'kanban' || currentView === 'vivier') ? (
          // Boards pleine hauteur (scroll horizontal interne)
          <div style={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
            {currentView === 'kanban' && <KanbanView showNotification={showNotification} onSelectBesoin={handleSelectBesoin} />}
            {currentView === 'vivier' && <VivierRH showNotification={showNotification} onOpenInCandidats={(id) => navigate(`/candidats/${id}`)} />}
          </div>
        ) : (
          // Pages normales — scroll vertical, contenu centré
          <div style={{ flex: 1, overflowY: 'auto' }}>
            {/* Pleine largeur (plafond 1800px pour les ultra-wides) : l'écran
                intérieur occupe tout l'espace à droite de la sidebar. */}
            <div className="erp-main-pad" style={{ maxWidth: '1800px', margin: '0 auto', padding: '30px 28px 64px' }}>
              {currentView === 'list' && <BesoinsList key={refreshKey} onSelectBesoin={handleSelectBesoin} onCreateBesoin={() => openCreateBesoin()} onDeleteBesoin={handleDeleteBesoin} onOuvrirKanban={() => setCurrentView('kanban')} showNotification={showNotification} />}
              {currentView === 'detail' && (
                selectedBesoin && String(selectedBesoin.id) === String(besoinIdFromPath)
                  ? <BesoinDetail besoin={selectedBesoin} onBack={handleDetailBack} onUpdate={handleBesoinUpdate} showNotification={showNotification} onOpenCandidat={(id) => navigate(`/candidats/${id}`)} onOpenAo={(id) => navigate(`/dossiers/${id}`)} canCvPrep={currentUser?.role !== 'sourcer' && cvPrepOn} theme={theme} />
                  : <div className="flex justify-center py-10"><div className="animate-spin" style={{ width: '40px', height: '40px', borderRadius: '50%', border: '2px solid var(--hair)', borderBottomColor: 'var(--accent)' }} /></div>
              )}
              {currentView === 'config' && currentUser?.admin && <ConfigPage showNotification={showNotification} />}
              {currentView === 'import' && <ImportCandidats showNotification={showNotification} />}
              {/* Candidats : tous les recruteurs (les notifications « Ouvrir la fiche »
                  y mènent) — seul le rôle sourcer est exclu, comme dans la sidebar. */}
              {currentView === 'candidats' && currentUser && currentUser.role !== 'sourcer' && <VueCandidats showNotification={showNotification} theme={theme} onToggleTheme={toggleTheme} ficheRouteId={candidatIdFromPath} onOpenFiche={(id) => navigate(`/candidats/${id}`)} onCloseFiche={() => navigate('/candidats')} onOpenBesoin={(id) => navigate(`/besoins/${id}`)} />}
              {currentView === 'dossiers' && <DossiersAO showNotification={showNotification} onOpenCandidat={(id) => navigate(`/candidats/${id}`)} onOpenBesoin={(id) => navigate(`/besoins/${id}`)} routeAoId={aoIdFromPath} onOpenAo={(id) => navigate(`/dossiers/${id}`)} onCloseAo={() => navigate('/dossiers')} />}
              {currentView === 'sourceur' && sourceurOn && <SourceurPage showNotification={showNotification} onOpenBesoin={(id) => navigate(`/besoins/${id}`)} onOpenCandidat={(id) => navigate(`/candidats/${id}`)} routeBesoinId={sourceurBesoinIdFromPath} onSelectBesoin={(id) => navigate(`/sourceur/${id}`)} onClearBesoin={() => navigate('/sourceur')} />}
              {currentView === 'ressources' && ressourcesOn && !isResource && <Ressources showNotification={showNotification} currentUser={currentUser} ficheInitiale={ressourceIdFromPath} onOpenFacture={crmOn ? (id) => navigate(`/crm/factures/${id}`) : undefined} />}
              {currentView === 'calendrier' && !isResource && <Calendrier showNotification={showNotification} onOuvrirBesoin={(id) => navigate(`/besoins/${id}`)} />}
              {/* Suivi des qualifications — écran de CONTRÔLE (« est-ce que ça
                  avance ? »). La portée est décidée par le serveur : admin =
                  tout, commercial = les besoins dont il est responsable. */}
              {currentView === 'qualifications' && !isResource && (
                <SuiviQualifications onOuvrirCandidat={(id) => navigate(`/candidats/${id}`)} showNotification={showNotification} />
              )}
              {/* Suivi des documents — « qu'est-ce qui est parti et n'est
                  jamais revenu », signé, refusé ou expiré compris. Chacun voit
                  ses envois, l'administrateur tout (règle serveur). Le module
                  de signature peut être éteint :
                  l'écran n'apparaît alors pas dans la navigation, mais
                  l'adresse reste servie (un lien en favori ne casse pas, il
                  affiche un état vide qui le dit). */}
              {currentView === 'documents' && !isResource && (
                <SuiviDocuments showNotification={showNotification}
                  onOuvrirCandidat={(id) => navigate(`/candidats/${id}`)}
                  onOuvrirBesoin={(id) => navigate(`/besoins/${id}`)} />
              )}
              {/* Liste noire — les personnes qu'on ne contacte plus, d'où que
                  vienne la décision (fiche, campagne de sourcing, réponse par
                  message, copilote) : motif, depuis quand, qui. Le serveur
                  porte la marque et la barrière ; l'écran lit, pose, lève. */}
              {/* Profils proposés — le tri à la façon d'un jeu de cartes :
                  intéressant (entre dans le besoin) ou pas (avec un motif).
                  Le paquet vient d'une campagne de sourcing, que la
                  recruteuse ne voit pas. */}
              {currentView === 'propositions' && !isResource && (
                <ProfilsProposes showNotification={showNotification} besoinInitial={new URLSearchParams(location.search).get('besoin')}
                  onOuvrirBesoin={(id) => navigate(`/besoins/${id}`)} onOuvrirCandidat={(id) => navigate(`/candidats/${id}`)} />
              )}
              {currentView === 'liste-noire' && !isResource && (
                <ListeNoire showNotification={showNotification} onOuvrirCandidat={(id) => navigate(`/candidats/${id}`)} />
              )}
              {/* Journal d'activité — qui a fait quoi, et quand, copilote
                  compris. Administrateurs seulement (le serveur refuse les
                  autres ; l'entrée n'apparaît que pour eux). */}
              {currentView === 'journal' && currentUser?.admin && (
                <JournalActivite onOuvrirCandidat={(id) => navigate(`/candidats/${id}`)} onOuvrirBesoin={(id) => navigate(`/besoins/${id}`)} />
              )}
              {currentView === 'forms' && formsOn && !isResource && <Forms showNotification={showNotification} />}
              {currentView === 'crm' && crmOn && !isResource && <CRM showNotification={showNotification} organisation={organisation} factureInitiale={crmFactureIdFromPath} onOpenRessource={ressourcesOn ? (id) => navigate(`/ressources/${id}`) : undefined} onCreateBesoin={(client) => openCreateBesoin(client?.nom || client || '')} onOpenBesoin={(id) => navigate(`/besoins/${id}`)} onOpenForms={formsOn ? () => navigate('/forms') : undefined} notifications={inAppNotifs} onOpenNotif={openNotif} onReadNotif={markNotifRead} />}
              {currentView === 'tatlease' && tatleaseOn && !isResource && <TatLease showNotification={showNotification} />}
              {currentView.startsWith('me-') && isResource && <MonEspace tab={currentView.slice(3)} showNotification={showNotification} onOuvrirConges={() => setCurrentView('me-conges')} />}
              {currentView === 'marketplace' && currentUser?.admin && <Marketplace showNotification={showNotification} currentUser={currentUser} />}
              {/* Roadmap : écran de l'éditeur du produit (super admin), pas
                  d'une organisation — le serveur refuse à quiconque d'autre. */}
              {currentView === 'roadmap' && currentUser?.super_admin && <Roadmap showNotification={showNotification} />}
              {/* Les CLIENTS d'ERPIA — les organisations à qui on vend le
                  produit, pas les entreprises où l'on place (ça, c'est le CRM). */}
              {currentView === 'clients' && currentUser?.super_admin && <ClientsErpia showNotification={showNotification} />}
              {/* La SONDE — contrôle automatique de non-régression, dans sa
                  propre organisation de test : écran de l'éditeur. */}
              {currentView === 'sonde' && currentUser?.super_admin && <Sonde showNotification={showNotification} />}
            </div>
          </div>
        )}
      </div>
 
      {showCreateModal && <CreateBesoinModal initialClient={createBesoinClient} onClose={() => { setShowCreateModal(false); setCreateBesoinClient(''); }} onSuccess={besoin => { setShowCreateModal(false); setCreateBesoinClient(''); handleSelectBesoin(besoin); }} showNotification={showNotification} />}
      {showJDModal && <JDGeneratorModal onClose={() => setShowJDModal(false)} showNotification={showNotification} />}
      <ErpiaConfirmHost />
      <Notification notifications={notifications} removeNotification={removeNotification} />
      {agentChatOn && !isResource && <AgentChat
        theme={theme}
        showNotification={showNotification}
        onOpenCandidat={openCandidatPreview}
        onCloseCandidat={id => setPreviewStack(prev => id != null ? prev.filter(s => String(s.id) !== String(id)) : [])}
        onOpenBesoin={id => navigate(`/besoins/${id}`)}
        onOpenAo={id => navigate(`/dossiers/${id}`)}
        onNavigate={to => { const t = String(to).replace(/^#/, ''); navigate(t.startsWith('/') ? t : `/${t}`); }}
      />}
      {/* Aperçus candidat empilés ouverts par l'assistant (non-modal, plusieurs à la fois) */}
      <CandidatPreviewDrawers
        items={previewStack}
        onClose={id => setPreviewStack(prev => prev.filter(s => String(s.id) !== String(id)))}
        onCloseAll={() => setPreviewStack([])}
        onOpenFull={id => { setPreviewStack([]); navigate(`/candidats/${id}`); }}
        showNotification={showNotification}
      />
    </div>
    </TutorielProvider>
    </TraitementsCvProvider>
  );
}
export default App;
